import axios from "axios";
import storeLocal from 'store';
import router from '@/router';
import {MessageBox} from 'element-ui';
import getErrorMsg from '@/language/getErrorMessage';
import {errorAlert} from "@/utils/utils";
import getI18n from '@/vueI18n/getI18n';

/**
 *  此文件为自动生成，请不要修改！
 *
 * (function (api, enums, pms) {
 *
 *    //Api 使用示例
 *    let pm = pms.Index.getIndexListParamBuilder();
 *    pm.folderId = 1;
 *    pm.indexFilterParam.starred = true;
 *    api.Index.getIndexList(pm, function (data) {
 *       //proc data
 *    });
 *
 *    //Emuns 使用示例; 强制要求使用枚举
 *    var loginAppType =  enums.LoginAppType.WEBMAIL_PC;
 *
 * })(xmail.api, xmail.enums, xmail.pms);
 */

let xmail = function(){};

xmail.api = function(){};

xmail.pms = function(){};

xmail.enums = function(){};

xmail.flags = function(){};

xmail.api.request = function (url, pm, callback) {
    const urlParams = storeLocal.get('Pwm-urlParams');
    const request = axios.create({
        // baseURL: process.env.PRIVATE_CLOUD_WM_API, // api的base_url
        baseURL: '',
        timeout: 60000 // 请求超时时间
    });
    request.interceptors.request.use(
        config => {
            //拦截请求，在请求头加token等操作
            return config
        },
        err => {
            return Promise.reject(err)
        }
    )
    request.interceptors.response.use(
        response => {
            //拦截响应，根据错误码执行路由跳转等操作
            if (response.data.code) {
                if(response.data.code === 401) {
                    storeLocal.remove('Pwm-Islogin');
                    storeLocal.remove('Pwm-user');
                    storeLocal.remove('Pwm-password');
                    const routerData = {path: '/error', query:{code: response.data.code,host: response.data.host,time: response.data.time,traceId: response.data.traceId}};
                    router.app.$router.push(routerData);
                } else if ((response.data.code >= 2051 && response.data.code <= 2060)
|| (response.data.code >= 2851 && response.data.code <= 2900)){
// 该错误代码段不适用此提示
} else if (response.data.code !== xmail.enums.ErrorCode.FS_FILE_UPLOAD_CHUNK_CHECK_FAIL) {
errorAlert(response);
}
}
return response
},
//接口错误状态处理，也就是说无响应时的处理
error => {
MessageBox.alert(getErrorMsg(504) + '<p style="color:#cccccc; font-size: 12px">' + new Date().toLocaleDateString()+ new
    Date().toLocaleTimeString()+ '&nbsp;&nbsp;' + url + '</p>', getI18n.t('wm_lang_c45357'), {dangerouslyUseHTMLString: true});
return Promise.reject(error.response.status) // 返回接口返回的错误信息
}
)
return request({
url: url + (urlParams || ''),
method: 'post',
data: pm
}).then(callback);
};

xmail.api.Account = function(){};

xmail.pms.Account = function(){};

//批量删除信任地
xmail.api.Account.batchDelTrustLocation = function(params, callbackFunc) {
    xmail.api.request('/xmail/wm/v1/mailAccount/batchDelTrustLocation', params, callbackFunc);
};
//批量删除信任地
xmail.pms.Account.batchDelTrustLocationParamBuilder = function () {
    return new xmail.pms.DelTrustLocationParam();
};

//绑定手机
xmail.api.Account.bindMobile = function(params, callbackFunc) {
    xmail.api.request('/xmail/wm/v1/mailAccount/bindMobile', params, callbackFunc);
};
//绑定手机
xmail.pms.Account.bindMobileParamBuilder = function () {
    return new xmail.pms.BindMobileParam();
};

//探测密码是否符合规则
xmail.api.Account.detectPassword = function(params, callbackFunc) {
    xmail.api.request('/xmail/wm/v1/mailAccount/detectPassword', params, callbackFunc);
};
//探测密码是否符合规则
xmail.pms.Account.detectPasswordParamBuilder = function () {
    return new xmail.pms.DetectPasswordParam();
};

//查询异地登录提醒信息
xmail.api.Account.queryRemoteEnable = function(params, callbackFunc) {
    xmail.api.request('/xmail/wm/v1/mailAccount/queryRemoteEnable', params, callbackFunc);
};
//查询异地登录日志
xmail.api.Account.queryRemoteLoginLog = function(params, callbackFunc) {
    xmail.api.request('/xmail/wm/v1/mailAccount/queryRemoteLoginLog', params, callbackFunc);
};
//查询异地登录日志
xmail.pms.Account.queryRemoteLoginLogParamBuilder = function () {
    return new xmail.pms.PageParam();
};

//查询信任地
xmail.api.Account.queryTrustLocation = function(params, callbackFunc) {
    xmail.api.request('/xmail/wm/v1/mailAccount/queryTrustLocation', params, callbackFunc);
};
//查询信任地
xmail.pms.Account.queryTrustLocationParamBuilder = function () {
    return new xmail.pms.PageParam();
};

//保存异地登录提醒信息
xmail.api.Account.saveRemoteEnable = function(params, callbackFunc) {
    xmail.api.request('/xmail/wm/v1/mailAccount/saveRemoteEnable', params, callbackFunc);
};
//保存异地登录提醒信息
xmail.pms.Account.saveRemoteEnableParamBuilder = function () {
    return new xmail.pms.SaveRemoteEnbleParam();
};

//添加单个信任地
xmail.api.Account.saveTrustLocation = function(params, callbackFunc) {
    xmail.api.request('/xmail/wm/v1/mailAccount/saveTrustLocation', params, callbackFunc);
};
//添加单个信任地
xmail.pms.Account.saveTrustLocationParamBuilder = function () {
    return new xmail.pms.TrustLocationParam();
};

//获取验证码
xmail.api.Account.sendCode = function(params, callbackFunc) {
    xmail.api.request('/xmail/wm/v1/mailAccount/sendCode', params, callbackFunc);
};
//获取验证码
xmail.pms.Account.sendCodeParamBuilder = function () {
    return new xmail.pms.SendCodeParam();
};

//解绑手机
xmail.api.Account.unbindMobile = function(params, callbackFunc) {
    xmail.api.request('/xmail/wm/v1/mailAccount/unbindMobile', params, callbackFunc);
};
//解绑手机
xmail.pms.Account.unbindMobileParamBuilder = function () {
    return new xmail.pms.BindMobileParam();
};

//更新账号密码
xmail.api.Account.updatePassword = function(params, callbackFunc) {
    xmail.api.request('/xmail/wm/v1/mailAccount/updatePassword', params, callbackFunc);
};
//更新账号密码
xmail.pms.Account.updatePasswordParamBuilder = function () {
    return new xmail.pms.UpdatePasswordParam();
};

xmail.api.Antispam = function(){};

xmail.pms.Antispam = function(){};

//查询反垃圾设置
xmail.api.Antispam.queryMailAntispamInfo = function(params, callbackFunc) {
    xmail.api.request('/xmail/wm/v1/mailAntispam/queryMailAntispamInfo', params, callbackFunc);
};
//保存反垃圾设置
xmail.api.Antispam.saveMailAntispamInfo = function(params, callbackFunc) {
    xmail.api.request('/xmail/wm/v1/mailAntispam/saveMailAntispamInfo', params, callbackFunc);
};
//保存反垃圾设置
xmail.pms.Antispam.saveMailAntispamInfoParamBuilder = function () {
    return new xmail.pms.AntispamInfoParam();
};

xmail.api.AuditMail = function(){};

xmail.pms.AuditMail = function(){};

//获取审核记录列表
xmail.api.AuditMail.auditLogList = function(params, callbackFunc) {
    xmail.api.request('/xmail/wm/v1/audit/log/list', params, callbackFunc);
};
//获取审核记录列表
xmail.pms.AuditMail.auditLogListParamBuilder = function () {
    return new xmail.pms.CorpAuditLogSearchParam();
};

//审核邮件
xmail.api.AuditMail.auditMail = function(params, callbackFunc) {
    xmail.api.request('/xmail/wm/v1/audit/auditMail', params, callbackFunc);
};
//审核邮件
xmail.pms.AuditMail.auditMailParamBuilder = function () {
    return new xmail.pms.CorpAuditMailParam();
};

//获取审核记录信息
xmail.api.AuditMail.info = function(params, callbackFunc) {
    xmail.api.request('/xmail/wm/v1/audit/log/info', params, callbackFunc);
};
//获取审核记录信息
xmail.pms.AuditMail.infoParamBuilder = function () {
    return new xmail.pms.String();
};

xmail.api.Blacklist = function(){};

xmail.pms.Blacklist = function(){};

//新增黑名单邮箱
xmail.api.Blacklist.addBlacklistAddr = function(params, callbackFunc) {
    xmail.api.request('/xmail/wm/v1/blackList/addBlacklistAddr', params, callbackFunc);
};
//新增黑名单邮箱
xmail.pms.Blacklist.addBlacklistAddrParamBuilder = function () {
    return new xmail.pms.BlacklistParam();
};

//批量删除黑名单邮箱
xmail.api.Blacklist.batchDelBlackAddrs = function(params, callbackFunc) {
    xmail.api.request('/xmail/wm/v1/blackList/batchDelBlackAddrs', params, callbackFunc);
};
//批量删除黑名单邮箱
xmail.pms.Blacklist.batchDelBlackAddrsParamBuilder = function () {
    return new xmail.pms.DelMailAccountBlacklistParam();
};

//分页模糊查询黑名单列表
xmail.api.Blacklist.queryBlacklistBypage = function(params, callbackFunc) {
    xmail.api.request('/xmail/wm/v1/blackList/queryBlacklistBypage', params, callbackFunc);
};
//分页模糊查询黑名单列表
xmail.pms.Blacklist.queryBlacklistBypageParamBuilder = function () {
    return new xmail.pms.BlacklistPageParam();
};

xmail.api.ClientSetting = function(){};

xmail.pms.ClientSetting = function(){};

//新增授权码
xmail.api.ClientSetting.addAuthCode = function(params, callbackFunc) {
    xmail.api.request('/xmail/wm/v1/mailClientSetting/addAuthCode', params, callbackFunc);
};
//新增授权码
xmail.pms.ClientSetting.addAuthCodeParamBuilder = function () {
    return new xmail.pms.AuthCodeParam();
};

//单个删除授权码
xmail.api.ClientSetting.delAuthCode = function(params, callbackFunc) {
    xmail.api.request('/xmail/wm/v1/mailClientSetting/delAuthCode', params, callbackFunc);
};
//单个删除授权码
xmail.pms.ClientSetting.delAuthCodeParamBuilder = function () {
    return new xmail.pms.DelAuthCodeParam();
};

//获取随机生成的授权码
xmail.api.ClientSetting.getAuthCode = function(params, callbackFunc) {
    xmail.api.request('/xmail/wm/v1/mailClientSetting/getAuthCode', params, callbackFunc);
};
//查询授权码信息
xmail.api.ClientSetting.queryAuthCodeInfo = function(params, callbackFunc) {
    xmail.api.request('/xmail/wm/v1/mailClientSetting/queryAuthCodeInfo', params, callbackFunc);
};
//查询客户端设置
xmail.api.ClientSetting.queryClientSetting = function(params, callbackFunc) {
    xmail.api.request('/xmail/wm/v1/mailClientSetting/queryClientSetting', params, callbackFunc);
};
//客户端授权码是否开启
xmail.api.ClientSetting.saveAuthCodeEnable = function(params, callbackFunc) {
    xmail.api.request('/xmail/wm/v1/mailClientSetting/saveAuthCodeEnble', params, callbackFunc);
};
//客户端授权码是否开启
xmail.pms.ClientSetting.saveAuthCodeEnableParamBuilder = function () {
    return new xmail.pms.AuthCodeEnbleParam();
};

//客户端保存已发邮件是否开启
xmail.api.ClientSetting.saveSendMailEnble = function(params, callbackFunc) {
    xmail.api.request('/xmail/wm/v1/mailClientSetting/saveSendMailEnble', params, callbackFunc);
};
//客户端保存已发邮件是否开启
xmail.pms.ClientSetting.saveSendMailEnbleParamBuilder = function () {
    return new xmail.pms.SendMailEnbleParam();
};

xmail.api.CorpContact = function(){};

xmail.pms.CorpContact = function(){};

//查询企业联系人
xmail.api.CorpContact.queryCorpContactInfo = function(params, callbackFunc) {
    xmail.api.request('/xmail/wm/v1/corpContact/queryCorpContactInfo', params, callbackFunc);
};
//查询企业联系人
xmail.pms.CorpContact.queryCorpContactInfoParamBuilder = function () {
    return new xmail.pms.CorpContactInfoParam();
};

//查询邮件列表具体信息
xmail.api.CorpContact.queryEmailList = function(params, callbackFunc) {
    xmail.api.request('/xmail/wm/v1/corpContact/queryEmailList', params, callbackFunc);
};
//查询邮件列表具体信息
xmail.pms.CorpContact.queryEmailListParamBuilder = function () {
    return new xmail.pms.CorpContactInfoParam();
};

//查询外部联系人
xmail.api.CorpContact.queryUserInfo = function(params, callbackFunc) {
    xmail.api.request('/xmail/wm/v1/corpContact/queryUserInfo', params, callbackFunc);
};
//查询外部联系人
xmail.pms.CorpContact.queryUserInfoParamBuilder = function () {
    return new xmail.pms.CorpContactInfoParam();
};

xmail.api.Deliver = function(){};

xmail.pms.Deliver = function(){};

//校验自动转发地址
xmail.api.Deliver.checkEmail = function(params, callbackFunc) {
    xmail.api.request('/xmail/wm/v1/mailDeliver/checkForwardAddr', params, callbackFunc);
};
//校验自动转发地址
xmail.pms.Deliver.checkEmailParamBuilder = function () {
    return new xmail.pms.CheckForwardAddrParam();
};

//查询自动转发,回复配置
xmail.api.Deliver.queryMailDeliver = function(params, callbackFunc) {
    xmail.api.request('/xmail/wm/v1/mailDeliver/queryMailDeliver', params, callbackFunc);
};
//查询自动转发,回复配置操作日志
xmail.api.Deliver.queryMailDeliverLog = function(params, callbackFunc) {
    xmail.api.request('/xmail/wm/v1/mailDeliver/queryMailDeliverLog', params, callbackFunc);
};
//查询自动转发,回复配置操作日志
xmail.pms.Deliver.queryMailDeliverLogParamBuilder = function () {
    return new xmail.pms.PageParam();
};

//新增自动转发,回复配置
xmail.api.Deliver.saveMailDeliver = function(params, callbackFunc) {
    xmail.api.request('/xmail/wm/v1/mailDeliver/saveMailDeliver', params, callbackFunc);
};
//新增自动转发,回复配置
xmail.pms.Deliver.saveMailDeliverParamBuilder = function () {
    return new xmail.pms.DeliverInfoParam();
};

xmail.api.File = function(){};

xmail.pms.File = function(){};

//分片验证
xmail.api.File.chunkCheck = function(params, callbackFunc) {
    xmail.api.request('/xmail/wm/v1/file/chunkCheck', params, callbackFunc);
};
//分片验证
xmail.pms.File.chunkCheckParamBuilder = function () {
    return new xmail.pms.FileChunkCheckParam();
};

//分片上传
xmail.api.File.chunkUpload = function(params, callbackFunc) {
    xmail.api.request('/xmail/wm/v1/file/chunkUpload', params, callbackFunc);
};
//分片上传
xmail.pms.File.chunkUploadParamBuilder = function () {
    return new xmail.pms.MultipartFile();
};

//分片合并
xmail.api.File.chunksMerge = function(params, callbackFunc) {
    xmail.api.request('/xmail/wm/v1/file/chunksMerge', params, callbackFunc);
};
//分片合并
xmail.pms.File.chunksMergeParamBuilder = function () {
    return new xmail.pms.FileChunkCheckParam();
};

//下载附件
xmail.api.File.downloadAttachFile = function(params, callbackFunc) {
    xmail.api.request('/xmail/wm/v1/file/downloadAttachFile', params, callbackFunc);
};
//下载附件
xmail.pms.File.downloadAttachFileParamBuilder = function () {
    return new xmail.pms.String();
};

//内嵌文件预览
xmail.api.File.innerFilePreview = function(params, callbackFunc) {
    xmail.api.request('/xmail/wm/v1/file/innerFilePreview', params, callbackFunc);
};
//内嵌文件预览
xmail.pms.File.innerFilePreviewParamBuilder = function () {
    return new xmail.pms.String();
};

//内嵌文件上传
xmail.api.File.innerFileUpload = function(params, callbackFunc) {
    xmail.api.request('/xmail/wm/v1/file/innerFileUpload', params, callbackFunc);
};
//内嵌文件上传
xmail.pms.File.innerFileUploadParamBuilder = function () {
    return new xmail.pms.MultipartFile();
};

//预览附件
xmail.api.File.previewAllAttachFile = function(params, callbackFunc) {
    xmail.api.request('/xmail/wm/v1/file/previewAllAttachFile', params, callbackFunc);
};
//预览附件
xmail.pms.File.previewAllAttachFileParamBuilder = function () {
    return new xmail.pms.PreviewAttachParam();
};

//预览附件
xmail.api.File.previewAttachFile = function(params, callbackFunc) {
    xmail.api.request('/xmail/wm/v1/file/previewAttachFile', params, callbackFunc);
};
//预览附件
xmail.pms.File.previewAttachFileParamBuilder = function () {
    return new xmail.pms.String();
};

xmail.api.FileTransfer = function(){};

xmail.pms.FileTransfer = function(){};

//完成文件分片上传
xmail.api.FileTransfer.completedFileChunkUpload = function(params, callbackFunc) {
    xmail.api.request('/xmail/ms/v1/filetrans/completedFileChunkUpload', params, callbackFunc);
};
//完成文件分片上传
xmail.pms.FileTransfer.completedFileChunkUploadParamBuilder = function () {
    return new xmail.pms.FileChunkUploadCompletedParam();
};

//文件下载
xmail.api.FileTransfer.downloadFile = function(params, callbackFunc) {
    xmail.api.request('/xmail/ms/v1/filetrans/downloadFile', params, callbackFunc);
};
//文件下载
xmail.pms.FileTransfer.downloadFileParamBuilder = function () {
    return new xmail.pms.String();
};

//文件下载
xmail.api.FileTransfer.downloadMailAccountFile = function(params, callbackFunc) {
    xmail.api.request('/xmail/ms/v1/filetrans/downloadMailAccountFile', params, callbackFunc);
};
//文件下载
xmail.pms.FileTransfer.downloadMailAccountFileParamBuilder = function () {
    return new xmail.pms.String();
};

//文件分片上传
xmail.api.FileTransfer.uploadChunk = function(params, callbackFunc) {
    xmail.api.request('/xmail/ms/v1/filetrans/uploadChunk', params, callbackFunc);
};
//文件分片上传
xmail.pms.FileTransfer.uploadChunkParamBuilder = function () {
    return new xmail.pms.String();
};

//文件分片校验
xmail.api.FileTransfer.uploadChunkCheck = function(params, callbackFunc) {
    xmail.api.request('/xmail/ms/v1/filetrans/uploadChunkCheck', params, callbackFunc);
};
//文件分片校验
xmail.pms.FileTransfer.uploadChunkCheckParamBuilder = function () {
    return new xmail.pms.FileChunkUploadCheckParam();
};

xmail.api.Filter = function(){};

xmail.pms.Filter = function(){};

//新增邮件分类规则
xmail.api.Filter.addFilterInfo = function(params, callbackFunc) {
    xmail.api.request('/xmail/wm/v1/mailFilter/addFilterInfo', params, callbackFunc);
};
//新增邮件分类规则
xmail.pms.Filter.addFilterInfoParamBuilder = function () {
    return new xmail.pms.MailFilterParam();
};

//改变邮件分类规则顺序
xmail.api.Filter.changeFilterPriority = function(params, callbackFunc) {
    xmail.api.request('/xmail/wm/v1/mailFilter/changeFilterPriority', params, callbackFunc);
};
//改变邮件分类规则顺序
xmail.pms.Filter.changeFilterPriorityParamBuilder = function () {
    return new xmail.pms.FilterPriorityParam();
};

//删除单个规则
xmail.api.Filter.delFilterInfo = function(params, callbackFunc) {
    xmail.api.request('/xmail/wm/v1/mailFilter/delFilterInfo', params, callbackFunc);
};
//删除单个规则
xmail.pms.Filter.delFilterInfoParamBuilder = function () {
    return new xmail.pms.FilterIdParam();
};

//查询操作日志
xmail.api.Filter.getFilterLogByPage = function(params, callbackFunc) {
    xmail.api.request('/xmail/wm/v1/mailFilter/getFilterLogByPage', params, callbackFunc);
};
//查询操作日志
xmail.pms.Filter.getFilterLogByPageParamBuilder = function () {
    return new xmail.pms.PageParam();
};

//查询分类规则
xmail.api.Filter.queryFilterInfo = function(params, callbackFunc) {
    xmail.api.request('/xmail/wm/v1/mailFilter/queryFilterInfo', params, callbackFunc);
};
//查询分类规则
xmail.pms.Filter.queryFilterInfoParamBuilder = function () {
    return new xmail.pms.FilterIdParam();
};

//查询所有邮件分类规则描述信息
xmail.api.Filter.queryMailAccountFilterDescribe = function(params, callbackFunc) {
    xmail.api.request('/xmail/wm/v1/mailFilter/queryFilterDescribe', params, callbackFunc);
};
//修改规则
xmail.api.Filter.updateFilterInfo = function(params, callbackFunc) {
    xmail.api.request('/xmail/wm/v1/mailFilter/updateFilterInfo', params, callbackFunc);
};
//修改规则
xmail.pms.Filter.updateFilterInfoParamBuilder = function () {
    return new xmail.pms.UpdateMailFilterParam();
};

//修改邮件分类规则状态
xmail.api.Filter.updateFilterStatus = function(params, callbackFunc) {
    xmail.api.request('/xmail/wm/v1/mailFilter/updateFilterStatus', params, callbackFunc);
};
//修改邮件分类规则状态
xmail.pms.Filter.updateFilterStatusParamBuilder = function () {
    return new xmail.pms.FilterStatusParam();
};

xmail.api.Folder = function(){};

xmail.pms.Folder = function(){};

//添加文件夹
xmail.api.Folder.addFolder = function(params, callbackFunc) {
    xmail.api.request('/xmail/wm/v1/folder/addFolder', params, callbackFunc);
};
//添加文件夹
xmail.pms.Folder.addFolderParamBuilder = function () {
    return new xmail.pms.AddMailFolderParam();
};

//清空文件夹中的邮件
xmail.api.Folder.cleanFolder = function(params, callbackFunc) {
    xmail.api.request('/xmail/wm/v1/folder/cleanFolder', params, callbackFunc);
};
//清空文件夹中的邮件
xmail.pms.Folder.cleanFolderParamBuilder = function () {
    return new xmail.pms.DelMailFolderParam();
};

//删除文件夹(供WebMail使用)
xmail.api.Folder.delFolderWebMail = function(params, callbackFunc) {
    xmail.api.request('/xmail/wm/v1/folder/delFolderWebMail', params, callbackFunc);
};
//删除文件夹(供WebMail使用)
xmail.pms.Folder.delFolderWebMailParamBuilder = function () {
    return new xmail.pms.DelMailFolderParam();
};

//获取文件夹信息
xmail.api.Folder.getFolder = function(params, callbackFunc) {
    xmail.api.request('/xmail/wm/v1/folder/getFolder', params, callbackFunc);
};
//获取文件夹信息
xmail.pms.Folder.getFolderParamBuilder = function () {
    return new xmail.pms.GetMailFolderParam();
};

//文件夹列表
xmail.api.Folder.getFolderList = function(params, callbackFunc) {
    xmail.api.request('/xmail/wm/v1/folder/getFolderList', params, callbackFunc);
};
//更新文件夹
xmail.api.Folder.updateFolder = function(params, callbackFunc) {
    xmail.api.request('/xmail/wm/v1/folder/updateFolder', params, callbackFunc);
};
//更新文件夹
xmail.pms.Folder.updateFolderParamBuilder = function () {
    return new xmail.pms.UpdateMailFolderParam();
};

xmail.api.GarbageMail = function(){};

xmail.pms.GarbageMail = function(){};

//这不是垃圾邮件
xmail.api.GarbageMail.nonGarbageMail = function(params, callbackFunc) {
    xmail.api.request('/xmail/wm/v1/garbage/nonGarbageMail', params, callbackFunc);
};
//这不是垃圾邮件
xmail.pms.GarbageMail.nonGarbageMailParamBuilder = function () {
    return new xmail.pms.String();
};

xmail.api.Home = function(){};

xmail.pms.Home = function(){};

//探测域公告邮件
xmail.api.Home.detectAnnouncedMail = function(params, callbackFunc) {
    xmail.api.request('/xmail/wm/v1/home/detectAnnounced', params, callbackFunc);
};
//探测域公告邮件
xmail.pms.Home.detectAnnouncedMailParamBuilder = function () {
    return new xmail.pms.DetectAnnouncedParam();
};

//首页信息
xmail.api.Home.homeInfo = function(params, callbackFunc) {
    xmail.api.request('/xmail/wm/v1/home/homeInfo', params, callbackFunc);
};
//首页设置
xmail.api.Home.homeSetting = function(params, callbackFunc) {
    xmail.api.request('/xmail/wm/v1/home/homeSetting', params, callbackFunc);
};
xmail.api.Index = function(){};

xmail.pms.Index = function(){};

//移动邮件根据文件夹
xmail.api.Index.batchMoveMailToFolder = function(params, callbackFunc) {
    xmail.api.request('/xmail/wm/v1/index/batchMoveMailToFolder', params, callbackFunc);
};
//移动邮件根据文件夹
xmail.pms.Index.batchMoveMailToFolderParamBuilder = function () {
    return new xmail.pms.BatchMoveMailParam();
};

//设置状态根据文件夹
xmail.api.Index.batchSetMailStatus = function(params, callbackFunc) {
    xmail.api.request('/xmail/wm/v1/index/batchSetMailStatus', params, callbackFunc);
};
//设置状态根据文件夹
xmail.pms.Index.batchSetMailStatusParamBuilder = function () {
    return new xmail.pms.BatchSetMailStatusParam();
};

//检测待撤销邮件状态
xmail.api.Index.checkUndoSentMail = function(params, callbackFunc) {
    xmail.api.request('/xmail/wm/v1/index/checkUndoSentMail', params, callbackFunc);
};
//检测待撤销邮件状态
xmail.pms.Index.checkUndoSentMailParamBuilder = function () {
    return new xmail.pms.UndoSentMailParam();
};

//永久删除
xmail.api.Index.deleteMail = function(params, callbackFunc) {
    xmail.api.request('/xmail/wm/v1/index/deleteMail', params, callbackFunc);
};
//永久删除
xmail.pms.Index.deleteMailParamBuilder = function () {
    return new xmail.pms.DelMailIndexParam();
};

//永久删除根据条件
xmail.api.Index.deleteMailByCondition = function(params, callbackFunc) {
    xmail.api.request('/xmail/wm/v1/index/deleteMailByCondition', params, callbackFunc);
};
//永久删除根据条件
xmail.pms.Index.deleteMailByConditionParamBuilder = function () {
    return new xmail.pms.DelMailIndexByConditionParam();
};

//获取索引信息
xmail.api.Index.getIndex = function(params, callbackFunc) {
    xmail.api.request('/xmail/wm/v1/index/getIndex', params, callbackFunc);
};
//获取索引信息
xmail.pms.Index.getIndexParamBuilder = function () {
    return new xmail.pms.GetMailIndexParam();
};

//索引列表
xmail.api.Index.getIndexList = function(params, callbackFunc) {
    xmail.api.request('/xmail/wm/v1/index/getIndexList', params, callbackFunc);
};
//索引列表
xmail.pms.Index.getIndexListParamBuilder = function () {
    return new xmail.pms.ListMailIndexParam();
};

//获取最新的邮件索引账号ID
xmail.api.Index.getLastMailAccountMailIndexId = function(params, callbackFunc) {
    xmail.api.request('/xmail/wm/v1/index/getLastMailAccountMailIndexId', params, callbackFunc);
};
//获取邮件账号索引版本
xmail.api.Index.getMailAccountMailIndexVersion = function(params, callbackFunc) {
    xmail.api.request('/xmail/wm/v1/index/getMailAccountMailIndexVersion', params, callbackFunc);
};
//移动邮件根据条件
xmail.api.Index.moveMailByCondition = function(params, callbackFunc) {
    xmail.api.request('/xmail/wm/v1/index/moveMailByCondition', params, callbackFunc);
};
//移动邮件根据条件
xmail.pms.Index.moveMailByConditionParamBuilder = function () {
    return new xmail.pms.MoveMailByConditionParam();
};

//移动邮件
xmail.api.Index.moveMailToFolder = function(params, callbackFunc) {
    xmail.api.request('/xmail/wm/v1/index/moveMailToFolder', params, callbackFunc);
};
//移动邮件
xmail.pms.Index.moveMailToFolderParamBuilder = function () {
    return new xmail.pms.MoveMailParam();
};

//这不是垃圾邮件
xmail.api.Index.nonGarbageMail = function(params, callbackFunc) {
    xmail.api.request('/xmail/wm/v1/index/nonGarbageMail', params, callbackFunc);
};
//这不是垃圾邮件
xmail.pms.Index.nonGarbageMailParamBuilder = function () {
    return new xmail.pms.NonGarbageMailParam();
};

//设置状态
xmail.api.Index.setMailStatus = function(params, callbackFunc) {
    xmail.api.request('/xmail/wm/v1/index/setMailStatus', params, callbackFunc);
};
//设置状态
xmail.pms.Index.setMailStatusParamBuilder = function () {
    return new xmail.pms.SetMailStatusParam();
};

//设置状态根据条件
xmail.api.Index.setMailStatusByCondition = function(params, callbackFunc) {
    xmail.api.request('/xmail/wm/v1/index/setMailStatusByCondition', params, callbackFunc);
};
//设置状态根据条件
xmail.pms.Index.setMailStatusByConditionParamBuilder = function () {
    return new xmail.pms.SetMailStatusByConditionParam();
};

//撤销已发送邮件
xmail.api.Index.undoSentMail = function(params, callbackFunc) {
    xmail.api.request('/xmail/wm/v1/index/undoSentMail', params, callbackFunc);
};
//撤销已发送邮件
xmail.pms.Index.undoSentMailParamBuilder = function () {
    return new xmail.pms.UndoSentMailParam();
};

xmail.api.LargeFile = function(){};

xmail.pms.LargeFile = function(){};

//删除文件
xmail.api.LargeFile.delFile = function(params, callbackFunc) {
    xmail.api.request('/xmail/wm/v1/large/file/delFile', params, callbackFunc);
};
//删除文件
xmail.pms.LargeFile.delFileParamBuilder = function () {
    return new xmail.pms.LargeFileIdsParam();
};

//延期文件
xmail.api.LargeFile.delayFile = function(params, callbackFunc) {
    xmail.api.request('/xmail/wm/v1/large/file/delayFile', params, callbackFunc);
};
//延期文件
xmail.pms.LargeFile.delayFileParamBuilder = function () {
    return new xmail.pms.LargeFileIdsParam();
};

//下载超大
xmail.api.LargeFile.downloadFile = function(params, callbackFunc) {
    xmail.api.request('/xmail/wm/v1/large/file/downloadSingleFile', params, callbackFunc);
};
//下载超大
xmail.pms.LargeFile.downloadFileParamBuilder = function () {
    return new xmail.pms.LargeFileIdsParam();
};

//获取大文件列表(分页)
xmail.api.LargeFile.getFileList = function(params, callbackFunc) {
    xmail.api.request('/xmail/wm/v1/large/file/getFileList', params, callbackFunc);
};
//获取大文件列表(分页)
xmail.pms.LargeFile.getFileListParamBuilder = function () {
    return new xmail.pms.GetFileListParam();
};

//获取用户空间
xmail.api.LargeFile.getSpaceInfo = function(params, callbackFunc) {
    xmail.api.request('/xmail/wm/v1/large/file/getSpaceInfo', params, callbackFunc);
};
//上传文件开始
xmail.api.LargeFile.uploadFileStartUp = function(params, callbackFunc) {
    xmail.api.request('/xmail/wm/v1/large/file/uploadFileStartUp', params, callbackFunc);
};
//上传文件开始
xmail.pms.LargeFile.uploadFileStartUpParamBuilder = function () {
    return new xmail.pms.UploadFileStartParam();
};

xmail.api.Logger = function(){};

xmail.pms.Logger = function(){};

//
xmail.api.Logger.criterion = function(params, callbackFunc) {
    xmail.api.request('/xmail/udcd/v1/log/unknown', params, callbackFunc);
};
//
xmail.pms.Logger.criterionParamBuilder = function () {
    return new xmail.pms.String();
};

//
xmail.api.Logger.findLogger = function(params, callbackFunc) {
    xmail.api.request('/xmail/udcd/v1/log/find', params, callbackFunc);
};
//
xmail.pms.Logger.findLoggerParamBuilder = function () {
    return new xmail.pms.String();
};

//
xmail.api.Logger.findLogger = function(params, callbackFunc) {
    xmail.api.request('/xmail/udcd/v1/log/find', params, callbackFunc);
};
//
xmail.pms.Logger.findLoggerParamBuilder = function () {
    return new xmail.pms.LoggerFindParam();
};

xmail.api.MailFile = function(){};

xmail.pms.MailFile = function(){};

//获取加密邮件密码
xmail.api.MailFile.getEncryptMailPasswd = function(params, callbackFunc) {
    xmail.api.request('/xmail/wm/v1/mail/getEncryptMailPasswd', params, callbackFunc);
};
//获取加密邮件密码
xmail.pms.MailFile.getEncryptMailPasswdParamBuilder = function () {
    return new xmail.pms.EncryptMailPasswdParam();
};

//获取转发邮件信息
xmail.api.MailFile.getForwardMailInfo = function(params, callbackFunc) {
    xmail.api.request('/xmail/wm/v1/mail/getForwardMailInfo', params, callbackFunc);
};
//获取转发邮件信息
xmail.pms.MailFile.getForwardMailInfoParamBuilder = function () {
    return new xmail.pms.MailIdsParam();
};

//查看信头
xmail.api.MailFile.getMailHeadInfo = function(params, callbackFunc) {
    xmail.api.request('/xmail/wm/v1/mail/getMailHeadInfo', params, callbackFunc);
};
//查看信头
xmail.pms.MailFile.getMailHeadInfoParamBuilder = function () {
    return new xmail.pms.MailIdParam();
};

//获取邮件
xmail.api.MailFile.getMailInfo = function(params, callbackFunc) {
    xmail.api.request('/xmail/wm/v1/mail/getMailInfo', params, callbackFunc);
};
//获取邮件
xmail.pms.MailFile.getMailInfoParamBuilder = function () {
    return new xmail.pms.ReadMailParam();
};

//下载邮件
xmail.api.MailFile.mailToStream = function(params, callbackFunc) {
    xmail.api.request('/xmail/wm/v1/mail/mailToStream', params, callbackFunc);
};
//下载邮件
xmail.pms.MailFile.mailToStreamParamBuilder = function () {
    return new xmail.pms.MailIdsParam();
};

//快捷发信
xmail.api.MailFile.quickSendMail = function(params, callbackFunc) {
    xmail.api.request('/xmail/wm/v1/mail/quickSendMail', params, callbackFunc);
};
//快捷发信
xmail.pms.MailFile.quickSendMailParamBuilder = function () {
    return new xmail.pms.SendMailParam();
};

//保存草稿
xmail.api.MailFile.saveDraftMail = function(params, callbackFunc) {
    xmail.api.request('/xmail/wm/v1/mail/saveDraftMail', params, callbackFunc);
};
//保存草稿
xmail.pms.MailFile.saveDraftMailParamBuilder = function () {
    return new xmail.pms.SendMailParam();
};

//发送邮件
xmail.api.MailFile.sendMail = function(params, callbackFunc) {
    xmail.api.request('/xmail/wm/v1/mail/sendMail', params, callbackFunc);
};
//发送邮件
xmail.pms.MailFile.sendMailParamBuilder = function () {
    return new xmail.pms.SendMailParam();
};

//发送邮件回执
xmail.api.MailFile.sendMailReceipt = function(params, callbackFunc) {
    xmail.api.request('/xmail/wm/v1/mail/sendMailReceipt', params, callbackFunc);
};
//发送邮件回执
xmail.pms.MailFile.sendMailReceiptParamBuilder = function () {
    return new xmail.pms.MailReceiptParam();
};

xmail.api.Pop = function(){};

xmail.pms.Pop = function(){};

//新增代收邮箱
xmail.api.Pop.addMailPopInfo = function(params, callbackFunc) {
    xmail.api.request('/xmail/wm/v1/mailPop/addMailPopInfo', params, callbackFunc);
};
//新增代收邮箱
xmail.pms.Pop.addMailPopInfoParamBuilder = function () {
    return new xmail.pms.PopInfoParam();
};

//单个删除代收邮箱
xmail.api.Pop.delMailPopInfo = function(params, callbackFunc) {
    xmail.api.request('/xmail/wm/v1/mailPop/delMailPopInfo', params, callbackFunc);
};
//单个删除代收邮箱
xmail.pms.Pop.delMailPopInfoParamBuilder = function () {
    return new xmail.pms.PopEmailParam();
};

//pop邮箱收取
xmail.api.Pop.popCollectMail = function(params, callbackFunc) {
    xmail.api.request('/xmail/wm/v1/mailPop/popCollectMail', params, callbackFunc);
};
//pop邮箱收取
xmail.pms.Pop.popCollectMailParamBuilder = function () {
    return new xmail.pms.PopEmailParam();
};

//查询单个代收邮箱
xmail.api.Pop.queryMailPopInfo = function(params, callbackFunc) {
    xmail.api.request('/xmail/wm/v1/mailPop/queryMailPopInfo', params, callbackFunc);
};
//查询单个代收邮箱
xmail.pms.Pop.queryMailPopInfoParamBuilder = function () {
    return new xmail.pms.PopEmailParam();
};

//查询代收邮箱
xmail.api.Pop.queryMailPopInfoList = function(params, callbackFunc) {
    xmail.api.request('/xmail/wm/v1/mailPop/queryMailPopInfoList', params, callbackFunc);
};
//修改代收邮箱
xmail.api.Pop.updateMailPopInfo = function(params, callbackFunc) {
    xmail.api.request('/xmail/wm/v1/mailPop/updateMailPopInfo', params, callbackFunc);
};
//修改代收邮箱
xmail.pms.Pop.updateMailPopInfoParamBuilder = function () {
    return new xmail.pms.UpdatePopInfoParam();
};

xmail.api.PreviewAttach = function(){};

xmail.pms.PreviewAttach = function(){};

//下载附件
xmail.api.PreviewAttach.downloadAttachFile = function(params, callbackFunc) {
    xmail.api.request('/xmail/wm/v1/preview/downloadAttachFileForOffice', params, callbackFunc);
};
//下载附件
xmail.pms.PreviewAttach.downloadAttachFileParamBuilder = function () {
    return new xmail.pms.String();
};

xmail.api.Setting = function(){};

xmail.pms.Setting = function(){};

//查询常规设置
xmail.api.Setting.queryMailAccountSetting = function(params, callbackFunc) {
    xmail.api.request('/xmail/wm/v1/mailSetting/queryMailAccountSetting', params, callbackFunc);
};
//保存常规设置
xmail.api.Setting.saveMailAccountSetting = function(params, callbackFunc) {
    xmail.api.request('/xmail/wm/v1/mailSetting/saveMailAccountSetting', params, callbackFunc);
};
//保存常规设置
xmail.pms.Setting.saveMailAccountSettingParamBuilder = function () {
    return new xmail.pms.AccountSettingParam();
};

//修改窗口布局
xmail.api.Setting.updateLayout = function(params, callbackFunc) {
    xmail.api.request('/xmail/wm/v1/mailSetting/updateLayout', params, callbackFunc);
};
//修改窗口布局
xmail.pms.Setting.updateLayoutParamBuilder = function () {
    return new xmail.pms.LayoutParam();
};

xmail.api.Sign = function(){};

xmail.pms.Sign = function(){};

//新增个性签名
xmail.api.Sign.addMailAccountSign = function(params, callbackFunc) {
    xmail.api.request('/xmail/wm/v1/mailSign/addMailAccountSign', params, callbackFunc);
};
//新增个性签名
xmail.pms.Sign.addMailAccountSignParamBuilder = function () {
    return new xmail.pms.SignParam();
};

//单个删除个性签名
xmail.api.Sign.delMailAccountSign = function(params, callbackFunc) {
    xmail.api.request('/xmail/wm/v1/mailSign/delMailAccountSign', params, callbackFunc);
};
//单个删除个性签名
xmail.pms.Sign.delMailAccountSignParamBuilder = function () {
    return new xmail.pms.SignIdParam();
};

//查询所有个性签名信息
xmail.api.Sign.queryAllMailAccountSign = function(params, callbackFunc) {
    xmail.api.request('/xmail/wm/v1/mailSign/queryAllMailAccountSign', params, callbackFunc);
};
//查询单个个性签名信息
xmail.api.Sign.queryMailAccountSign = function(params, callbackFunc) {
    xmail.api.request('/xmail/wm/v1/mailSign/queryMailAccountSign', params, callbackFunc);
};
//查询单个个性签名信息
xmail.pms.Sign.queryMailAccountSignParamBuilder = function () {
    return new xmail.pms.SignIdParam();
};

//修改默认个性签名
xmail.api.Sign.updateDefSign = function(params, callbackFunc) {
    xmail.api.request('/xmail/wm/v1/mailSign/updateDefSign', params, callbackFunc);
};
//修改默认个性签名
xmail.pms.Sign.updateDefSignParamBuilder = function () {
    return new xmail.pms.UpdateDefSignParam();
};

//修改个性签名
xmail.api.Sign.updateMailAccountSign = function(params, callbackFunc) {
    xmail.api.request('/xmail/wm/v1/mailSign/updateMailAccountSign', params, callbackFunc);
};
//修改个性签名
xmail.pms.Sign.updateMailAccountSignParamBuilder = function () {
    return new xmail.pms.UpdateSignParam();
};

xmail.api.UdcdApp = function(){};

xmail.pms.UdcdApp = function(){};

//获取组织结构信息（树形）
xmail.api.UdcdApp.getCorpOrgTreeInfo = function(params, callbackFunc) {
    xmail.api.request('/xmail/udcd/v1/app/getCorpOrgTreeInfo', params, callbackFunc);
};
//获取组织结构信息版本
xmail.api.UdcdApp.getCorpOrgVersion = function(params, callbackFunc) {
    xmail.api.request('/xmail/udcd/v1/app/getCorpOrgVersion', params, callbackFunc);
};
xmail.api.UdcdLogin = function(){};

xmail.pms.UdcdLogin = function(){};

//第三方API登录
xmail.api.UdcdLogin.apiLogin = function(params, callbackFunc) {
    xmail.api.request('/xmail/udcd/v1/login/api/getToken', params, callbackFunc);
};
//第三方API登录
xmail.pms.UdcdLogin.apiLoginParamBuilder = function () {
    return new xmail.pms.ApiLoginParam();
};

//第三方API刷新token
xmail.api.UdcdLogin.apiRefreshToken = function(params, callbackFunc) {
    xmail.api.request('/xmail/udcd/v1/login/api/refreshToken', params, callbackFunc);
};
//第三方API刷新token
xmail.pms.UdcdLogin.apiRefreshTokenParamBuilder = function () {
    return new xmail.pms.ApiTokenParam();
};

//管理员密码登录
xmail.api.UdcdLogin.managerPwdLogin = function(params, callbackFunc) {
    xmail.api.request('/xmail/udcd/v1/login/managerPwdLogin', params, callbackFunc);
};
//管理员密码登录
xmail.pms.UdcdLogin.managerPwdLoginParamBuilder = function () {
    return new xmail.pms.UserPwdLoginParam();
};

//单点认证
xmail.api.UdcdLogin.ssoAuth = function(params, callbackFunc) {
    xmail.api.request('/xmail/udcd/v1/login/ssoAuth', params, callbackFunc);
};
//单点认证
xmail.pms.UdcdLogin.ssoAuthParamBuilder = function () {
    return new xmail.pms.String();
};

//单点登录
xmail.api.UdcdLogin.ssoLoginMail = function(params, callbackFunc) {
    xmail.api.request('/xmail/udcd/v1/login/ssoLoginMail', params, callbackFunc);
};
//单点登录
xmail.pms.UdcdLogin.ssoLoginMailParamBuilder = function () {
    return new xmail.pms.String();
};

//sso读取邮件消息
xmail.api.UdcdLogin.ssoReadMessage = function(params, callbackFunc) {
    xmail.api.request('/xmail/udcd/v1/login/ssoReadMessage', params, callbackFunc);
};
//sso读取邮件消息
xmail.pms.UdcdLogin.ssoReadMessageParamBuilder = function () {
    return new xmail.pms.String();
};

//单点解绑用户
xmail.api.UdcdLogin.ssoUnbind = function(params, callbackFunc) {
    xmail.api.request('/xmail/udcd/v1/login/ssoUnbind', params, callbackFunc);
};
//单点解绑用户
xmail.pms.UdcdLogin.ssoUnbindParamBuilder = function () {
    return new xmail.pms.SsoUnBindParam();
};

//超级管理员密码登录
xmail.api.UdcdLogin.sysManagerLogin = function(params, callbackFunc) {
    xmail.api.request('/xmail/udcd/v1/login/sys/managerLogin', params, callbackFunc);
};
//超级管理员密码登录
xmail.pms.UdcdLogin.sysManagerLoginParamBuilder = function () {
    return new xmail.pms.SysMangerLoginParam();
};

//用户密码登录
xmail.api.UdcdLogin.userPwdLogin = function(params, callbackFunc) {
    xmail.api.request('/xmail/udcd/v1/login/userPwdLogin', params, callbackFunc);
};
//用户密码登录
xmail.pms.UdcdLogin.userPwdLoginParamBuilder = function () {
    return new xmail.pms.UserPwdLoginParam();
};

//用户密码登录(测试异地登录使用)
xmail.api.UdcdLogin.userPwdLoginTest = function(params, callbackFunc) {
    xmail.api.request('/xmail/udcd/v1/login/userPwdLoginTest', params, callbackFunc);
};
//用户密码登录(测试异地登录使用)
xmail.pms.UdcdLogin.userPwdLoginTestParamBuilder = function () {
    return new xmail.pms.UserPwdLoginParam();
};

//用户单点 登录
xmail.api.UdcdLogin.userSsoLogin = function(params, callbackFunc) {
    xmail.api.request('/xmail/udcd/v1/login/userSsoLogin', params, callbackFunc);
};
//用户单点 登录
xmail.pms.UdcdLogin.userSsoLoginParamBuilder = function () {
    return new xmail.pms.UserSsoLoginParam();
};

xmail.api.UdcdLogout = function(){};

xmail.pms.UdcdLogout = function(){};

//退出登录
xmail.api.UdcdLogout.logout = function(params, callbackFunc) {
    xmail.api.request('/xmail/udcd/v1/logout/logout', params, callbackFunc);
};
//安全退出
xmail.api.UdcdLogout.safeLogout = function(params, callbackFunc) {
    xmail.api.request('/xmail/udcd/v1/logout/safeLogout', params, callbackFunc);
};
xmail.api.UdcdSsoAuthTest = function(){};

xmail.pms.UdcdSsoAuthTest = function(){};

//
xmail.api.UdcdSsoAuthTest.$deserializeLambda$ = function(params, callbackFunc) {
    xmail.api.request('/xmail/udcd/v1/ssoAuthTest/unknown', params, callbackFunc);
};
//
xmail.pms.UdcdSsoAuthTest.$deserializeLambda$ParamBuilder = function () {
    return new xmail.pms.SerializedLambda();
};

//接收第三方应用订阅事件
xmail.api.UdcdSsoAuthTest.receiveEvent = function(params, callbackFunc) {
    xmail.api.request('/xmail/udcd/v1/ssoAuthTest/receiveMessage', params, callbackFunc);
};
//接收第三方应用订阅事件
xmail.pms.UdcdSsoAuthTest.receiveEventParamBuilder = function () {
    return new xmail.pms.Object();
};

//接收第三方应用订阅事件
xmail.api.UdcdSsoAuthTest.ssoReadMessage = function(params, callbackFunc) {
    xmail.api.request('/xmail/udcd/v1/ssoAuthTest/ssoReadMessage', params, callbackFunc);
};
//接收第三方应用订阅事件
xmail.pms.UdcdSsoAuthTest.ssoReadMessageParamBuilder = function () {
    return new xmail.pms.String();
};

//单点登录测试
xmail.api.UdcdSsoAuthTest.sysSsoCorpLogin = function(params, callbackFunc) {
    xmail.api.request('/xmail/udcd/v1/ssoAuthTest/loginMail', params, callbackFunc);
};
//单点登录测试
xmail.pms.UdcdSsoAuthTest.sysSsoCorpLoginParamBuilder = function () {
    return new xmail.pms.String();
};

xmail.api.UdcdSso = function(){};

xmail.pms.UdcdSso = function(){};

//单点跳转日程登录
xmail.api.UdcdSso.calSsoLogin = function(params, callbackFunc) {
    xmail.api.request('/xmail/udcd/v1/sso/calSsoLogin', params, callbackFunc);
};
//单点跳转登录
xmail.api.UdcdSso.sysSsoCorpLogin = function(params, callbackFunc) {
    xmail.api.request('/xmail/udcd/v1/sso/sysSsoCorpLogin', params, callbackFunc);
};
//单点跳转登录
xmail.pms.UdcdSso.sysSsoCorpLoginParamBuilder = function () {
    return new xmail.pms.SysSsoCorpLoginParam();
};

xmail.api.UnActiveAccount = function(){};

xmail.pms.UnActiveAccount = function(){};

//探测密码是否符合规则
xmail.api.UnActiveAccount.detectPassword = function(params, callbackFunc) {
    xmail.api.request('/xmail/wm/v1/unActiveMailAccount/detectPassword', params, callbackFunc);
};
//探测密码是否符合规则
xmail.pms.UnActiveAccount.detectPasswordParamBuilder = function () {
    return new xmail.pms.DetectPasswordParam();
};

//获取验证码
xmail.api.UnActiveAccount.sendCode = function(params, callbackFunc) {
    xmail.api.request('/xmail/wm/v1/unActiveMailAccount/sendCode', params, callbackFunc);
};
//获取验证码
xmail.pms.UnActiveAccount.sendCodeParamBuilder = function () {
    return new xmail.pms.SendCodeParam();
};

//更新账号密码
xmail.api.UnActiveAccount.updatePassword = function(params, callbackFunc) {
    xmail.api.request('/xmail/wm/v1/unActiveMailAccount/updatePassword', params, callbackFunc);
};
//更新账号密码
xmail.pms.UnActiveAccount.updatePasswordParamBuilder = function () {
    return new xmail.pms.UpdatePasswordParam();
};

//二次验证
xmail.api.UnActiveAccount.verifySecureLogin = function(params, callbackFunc) {
    xmail.api.request('/xmail/wm/v1/unActiveMailAccount/verifySecureLogin', params, callbackFunc);
};
//二次验证
xmail.pms.UnActiveAccount.verifySecureLoginParamBuilder = function () {
    return new xmail.pms.CheckCodeParam();
};

xmail.api.UserContact = function(){};

xmail.pms.UserContact = function(){};

//添加到新的组
xmail.api.UserContact.addToNewGroup = function(params, callbackFunc) {
    xmail.api.request('/xmail/wm/v1/user/contact/addToNewGroup', params, callbackFunc);
};
//添加到新的组
xmail.pms.UserContact.addToNewGroupParamBuilder = function () {
    return new xmail.pms.AddToNewGroupParam();
};

//新增组
xmail.api.UserContact.addUserContactGroup = function(params, callbackFunc) {
    xmail.api.request('/xmail/wm/v1/user/contact/addUserContactGroup', params, callbackFunc);
};
//新增组
xmail.pms.UserContact.addUserContactGroupParamBuilder = function () {
    return new xmail.pms.AddContactGroupParam();
};

//新增联系人
xmail.api.UserContact.addUserContactInfo = function(params, callbackFunc) {
    xmail.api.request('/xmail/wm/v1/user/contact/addUserContactInfo', params, callbackFunc);
};
//新增联系人
xmail.pms.UserContact.addUserContactInfoParamBuilder = function () {
    return new xmail.pms.UserContactInfoParam();
};

//删除组
xmail.api.UserContact.delUserContactGroup = function(params, callbackFunc) {
    xmail.api.request('/xmail/wm/v1/user/contact/delUserContactGroup', params, callbackFunc);
};
//删除组
xmail.pms.UserContact.delUserContactGroupParamBuilder = function () {
    return new xmail.pms.DelUserContactGroupParam();
};

//批量删除联系人
xmail.api.UserContact.delUserContactInfo = function(params, callbackFunc) {
    xmail.api.request('/xmail/wm/v1/user/contact/delUserContactInfo', params, callbackFunc);
};
//批量删除联系人
xmail.pms.UserContact.delUserContactInfoParamBuilder = function () {
    return new xmail.pms.DelUserContactInfoParam();
};

//探测主邮箱是否存在
xmail.api.UserContact.detectMainEmail = function(params, callbackFunc) {
    xmail.api.request('/xmail/wm/v1/user/contact/detectMainEmail', params, callbackFunc);
};
//探测主邮箱是否存在
xmail.pms.UserContact.detectMainEmailParamBuilder = function () {
    return new xmail.pms.DetectMainEmailParam();
};

//导出联系人
xmail.api.UserContact.exportContactUser = function(params, callbackFunc) {
    xmail.api.request('/xmail/wm/v1/user/contact/exportContactUser', params, callbackFunc);
};
//导出联系人
xmail.pms.UserContact.exportContactUserParamBuilder = function () {
    return new xmail.pms.ExportContactUserParam();
};

//查询用户的所有组
xmail.api.UserContact.getAllGroup = function(params, callbackFunc) {
    xmail.api.request('/xmail/wm/v1/user/contact/getAllGroup', params, callbackFunc);
};
//查找单个联系人
xmail.api.UserContact.getUserContactInfo = function(params, callbackFunc) {
    xmail.api.request('/xmail/wm/v1/user/contact/getUserContactInfo', params, callbackFunc);
};
//查找单个联系人
xmail.pms.UserContact.getUserContactInfoParamBuilder = function () {
    return new xmail.pms.GetUserContactInfoParam();
};

//查询联系人列表
xmail.api.UserContact.getUserContactTreeInfo = function(params, callbackFunc) {
    xmail.api.request('/xmail/wm/v1/user/contact/getUserContactTreeInfo', params, callbackFunc);
};
//查询联系人列表
xmail.pms.UserContact.getUserContactTreeInfoParamBuilder = function () {
    return new xmail.pms.GetUserContactListParam();
};

//导入联系人
xmail.api.UserContact.importContactUser = function(params, callbackFunc) {
    xmail.api.request('/xmail/wm/v1/user/contact/importContactUser', params, callbackFunc);
};
//导入联系人
xmail.pms.UserContact.importContactUserParamBuilder = function () {
    return new xmail.pms.ImportContactUserParam();
};

//搜索联系人
xmail.api.UserContact.searchUserContact = function(params, callbackFunc) {
    xmail.api.request('/xmail/wm/v1/user/contact/searchUserContact', params, callbackFunc);
};
//搜索联系人
xmail.pms.UserContact.searchUserContactParamBuilder = function () {
    return new xmail.pms.SearchUserContactInfoParam();
};

//修改组
xmail.api.UserContact.updateUserContactGroup = function(params, callbackFunc) {
    xmail.api.request('/xmail/wm/v1/user/contact/updateUserContactGroup', params, callbackFunc);
};
//修改组
xmail.pms.UserContact.updateUserContactGroupParamBuilder = function () {
    return new xmail.pms.UpdateContactGroupParam();
};

//修改联系人信息
xmail.api.UserContact.updateUserContactInfo = function(params, callbackFunc) {
    xmail.api.request('/xmail/wm/v1/user/contact/updateUserContactInfo', params, callbackFunc);
};
//修改联系人信息
xmail.pms.UserContact.updateUserContactInfoParamBuilder = function () {
    return new xmail.pms.UpdateUserContactInfoParam();
};

//上传联系人文件获取表头信息
xmail.api.UserContact.uploadContactUserFile = function(params, callbackFunc) {
    xmail.api.request('/xmail/wm/v1/user/contact/uploadContactUserFile', params, callbackFunc);
};
//上传联系人文件获取表头信息
xmail.pms.UserContact.uploadContactUserFileParamBuilder = function () {
    return new xmail.pms.MultipartFile();
};

xmail.api.UserInfo = function(){};

xmail.pms.UserInfo = function(){};

//查询账户信息
xmail.api.UserInfo.queryUserInfo = function(params, callbackFunc) {
    xmail.api.request('/xmail/wm/v1/userInfo/queryUserInfo', params, callbackFunc);
};
//保存账户信息
xmail.api.UserInfo.saveUserInfo = function(params, callbackFunc) {
    xmail.api.request('/xmail/wm/v1/userInfo/saveUserInfo', params, callbackFunc);
};
//保存账户信息
xmail.pms.UserInfo.saveUserInfoParamBuilder = function () {
    return new xmail.pms.UserInfoParam();
};

//
xmail.pms.AccountLimit = function(data) {
    if (!data) {
        return;
    }


    //密码
    this.password = data.password;
};




// 常规设置参数
xmail.pms.AccountSettingParam = function(data) {
    if (!data) {
        return;
    }


    //邮件列表每页数量
    this.pageSize = data.pageSize;

    //窗口布局|layout|LR(1, "左右布局"),LIST(2, "列表布局");
    this.layout = data.layout;

    //工具栏按钮是否显示图标
    this.toolbarButtonIcon = data.toolbarButtonIcon;

    //登录后默认显示|login_router_page|HOME(1, "首页"),INBOX(2, "收件箱");
    this.loginRouterPage = data.loginRouterPage;

    //收信时姓名显示|recv_from_display_type|original(1, "发件人自定义姓名"),CONTACT(2, "通讯录中备注姓名");
    this.recvFromDisplay = data.recvFromDisplay;

    //皮肤|webmail_skin|OFFICE(1, "商务办公"),REDSIMPLE(2, "红色简约"),BRAVEFORWARD(3, "勇者前行"),SCRIPTURES(4,"经典木纹"),GREEN(5,"绿意风情"),PINK(6,"粉色回忆"),GRASS(7,"青青幽境"),BLACK(8,"时尚酷黑"),GOLD(9,"金色时光");
    this.webmailSkin = data.webmailSkin;

    //语言|language|CN(1, "中文简体"),HK(2, "中文繁体"),EN(3, "英文"),JP(4, "日语"),KO(5, "韩语");
    this.language = data.language;

    //我的名称|send_from_display_type|NONE(1, "不显示"),REAL_NAME(2, "真实姓名"),CUSTOM(3, "自定义");
    this.sendFromDisplay = data.sendFromDisplay;

    //自定义名字
    this.customName = data.customName;

    //自定义名字权限
    this.customSenderName = data.customSenderName;

    //写信默认字体
    this.fontName = data.fontName;

    //写信默认字体大小
    this.fontSize = data.fontSize;

    //保存web已发信件
    this.webSent = data.webSent;

    //回执
    this.receipt = data.receipt;

    //回复时加入原信
    this.replyWithContent = data.replyWithContent;

    //回复/转发信头|reply_subject_prefix|EN(1,"Re:/Fw:/Auto-Re:"),CN(2,"回复:/转发:/自动回复:");
    this.replySubjectPrefix = data.replySubjectPrefix;

    //是否自动加入通讯录
    this.orgVisible = data.orgVisible;

    //默认抄送地址
    this.ccDef = data.ccDef;

    //默认密送地址
    this.bccDef = data.bccDef;
};




// 常规设置回结果
xmail.pms.AccountSettingResult = function(data) {
    if (!data) {
        return;
    }


    //邮件列表每页数量
    this.pageSize = data.pageSize;

    //窗口布局|layout|LR(1, "左右布局"),LIST(2, "列表布局");
    this.layout = data.layout;

    //工具栏按钮是否显示图标
    this.toolbarButtonIcon = data.toolbarButtonIcon;

    //登录后默认显示|login_router_page|HOME(1, "首页"),INBOX(2, "收件箱");
    this.loginRouterPage = data.loginRouterPage;

    //收信时姓名显示|recv_from_display_type|original(1, "发件人自定义姓名"),CONTACT(2, "通讯录中备注姓名");
    this.recvFromDisplay = data.recvFromDisplay;

    //皮肤|webmail_skin|OFFICE(1, "商务办公"),REDSIMPLE(2, "红色简约"),BRAVEFORWARD(3, "勇者前行"),SCRIPTURES(4,"经典木纹"),GREEN(5,"绿意风情"),PINK(6,"粉色回忆"),GRASS(7,"青青幽境"),BLACK(8,"时尚酷黑"),GOLD(9,"金色时光");
    this.webmailSkin = data.webmailSkin;

    //语言|language|CN(1, "中文简体"),HK(2, "中文繁体"),EN(3, "英文"),JP(4, "日语"),KO(5, "韩语");
    this.language = data.language;

    //我的名称|send_from_display_type|NONE(1, "不显示"),REAL_NAME(2, "真实姓名"),CUSTOM(3, "自定义");
    this.sendFromDisplay = data.sendFromDisplay;

    //自定义名字
    this.customName = data.customName;

    //真实姓名
    this.realName = data.realName;

    //写信默认字体
    this.fontName = data.fontName;

    //写信默认字体大小
    this.fontSize = data.fontSize;

    //保存web已发信件
    this.webSent = data.webSent;

    //回执
    this.receipt = data.receipt;

    //回复时加入原信
    this.replyWithContent = data.replyWithContent;

    //回复/转发信头|reply_subject_prefix|EN(1,"Re:/Fw:/Auto-Re:"),CN(2,"回复:/转发:/自动回复:");
    this.replySubjectPrefix = data.replySubjectPrefix;

    //是否自动加入通讯录
    this.orgVisible = data.orgVisible;

    //默认抄送地址
    this.ccDef = data.ccDef;

    //默认密送地址
    this.bccDef = data.bccDef;
};




// 新增通讯录组参数
xmail.pms.AddContactGroupParam = function(data) {
    if (!data) {
        return;
    }


    //通讯组名称
    this.name = data.name;

    //联系人唯一Id集合
    this.userContactIds = data.userContactIds;
};




// 添加文件夹参数
xmail.pms.AddMailFolderParam = function(data) {
    if (!data) {
        return;
    }


    //
    this.name = data.name;

    //
    this.parentFolderId = data.parentFolderId;

    //
    this.subscribed = data.subscribed;
};




// 联系人新增到新组参数
xmail.pms.AddToNewGroupParam = function(data) {
    if (!data) {
        return;
    }


    //联系人id
    this.userContactIds = data.userContactIds;

    //要添加到的组Id
    this.newGroupIds = data.newGroupIds;
};




// 域公告邮件
xmail.pms.AnnouncedMail = function(data) {
    if (!data) {
        return;
    }


    //索引id
    this.mailIndexId = data.mailIndexId;

    //邮件原信fileId
    this.fileId = data.fileId;

    //
    this.folderId = data.folderId;

    //主题
    this.subject = data.subject;

    //已读
    this.seen = data.seen;

    //存信时间(同createtime，搬家例外)
    this.receivedTime = data.receivedTime;
};




// 反垃圾设置参数
xmail.pms.AntispamInfoParam = function(data) {
    if (!data) {
        return;
    }


    //反垃圾级别|spam_level|IGNORE(1, "不过滤"),LOW(2, "低级"),MEDIUM_LOW(3, "中低"),MEDIUM(4, "中级"),MEDIUM_HIGH(5, "中高"),HIGH(6, "高级");
    this.spamLevel = data.spamLevel;

    //反垃圾处理|spam_execute_opt_type|DELETE(1, "删除");
    this.executeOptType = data.executeOptType;

    //垃圾邮件删除时间
    this.spamMailDeleteTime = data.spamMailDeleteTime;

    //反垃圾提醒周期
    this.remindCycle = data.remindCycle;

    //
    this.remindStartTime = data.remindStartTime;

    //
    this.remindEndTime = data.remindEndTime;

    //反垃圾提醒语言|language|CN(1, "中文简体"),HK(2, "中文繁体"),EN(3, "英文"),JP(4, "日语"),KO(5, "韩语");
    this.remindLanguage = data.remindLanguage;

    //邮件图片|mail_picture_visiable|ENABLE(1, "企业邮件图片"),DISABLE(2, "禁用所有邮件中的图片，手动点击后显示"),DISABLE_SPAM(3, "禁用垃圾邮件中的图片，手动点击后显示");
    this.mailPictureVisiable = data.mailPictureVisiable;
};




// 反垃圾设置返回结果
xmail.pms.AntispamInfoResult = function(data) {
    if (!data) {
        return;
    }


    //反垃圾级别|spam_level|IGNORE(1, "不过滤"),LOW(2, "低级"),MEDIUM_LOW(3, "中低"),MEDIUM(4, "中级"),MEDIUM_HIGH(5, "中高"),HIGH(6, "高级");
    this.spamLevel = data.spamLevel;

    //反垃圾处理|spam_execute_opt_type|DELETE(1, "删除");
    this.executeOptType = data.executeOptType;

    //垃圾邮件删除时间
    this.spamMailDeleteTime = data.spamMailDeleteTime;

    //反垃圾提醒是否开启
    this.remindEnable = data.remindEnable;

    //反垃圾提醒周期
    this.remindCycle = data.remindCycle;

    //提醒开始时间
    this.remindStartTime = data.remindStartTime;

    //提醒结束时间
    this.remindEndTime = data.remindEndTime;

    //反垃圾提醒语言|language|CN(1, "中文简体"),HK(2, "中文繁体"),EN(3, "英文"),JP(4, "日语"),KO(5, "韩语");
    this.remindLanguage = data.remindLanguage;

    //邮件图片|mail_picture_visiable|ENABLE(1, "企业邮件图片"),DISABLE(2, "禁用所有邮件中的图片，手动点击后显示"),DISABLE_SPAM(3, "禁用垃圾邮件中的图片，手动点击后显示");
    this.mailPictureVisiable = data.mailPictureVisiable;
};




// 第三方API登录参数
xmail.pms.ApiLoginParam = function(data) {
    if (!data) {
        return;
    }


    //第三方应用ID
    this.suiteId = data.suiteId;

    //第三方应用密钥
    this.suiteSecret = data.suiteSecret;
};




// 第三方API登录返回结果
xmail.pms.ApiLoginResult = function(data) {
    if (!data) {
        return;
    }


    //认证token
    this.accessToken = data.accessToken;

    //刷新token
    this.refreshToken = data.refreshToken;
};




// 第三方API刷新token参数
xmail.pms.ApiTokenParam = function(data) {
    if (!data) {
        return;
    }


    //刷新token
    this.refreshToken = data.refreshToken;
};




//
xmail.pms.AttachInfo = function(data) {
    if (!data) {
        return;
    }


    //
    this.fileId = data.fileId;

    //
    this.fileName = data.fileName;

    //
    this.size = data.size;

    //
    this.file = data.file;

    //
    this.isLarge = data.isLarge;

    //
    this.downUrl = data.downUrl;

    //
    this.previewUrl = data.previewUrl;

    //
    this.previewServerDomainName = data.previewServerDomainName;

    //
    this.previewOfficeUrl = data.previewOfficeUrl;
};




// 审核邮件明细
xmail.pms.AuditMailInfoResult = function(data) {
    if (!data) {
        return;
    }


    //审核日志记录
    this.auditLog = new CorpAuditLog(data.auditLog);

    //所有审核人记录
    this.auditorLog = new CorpAuditorLog(data.auditorLog);
};




// 保存客户端授权码是否开启参数
xmail.pms.AuthCodeEnbleParam = function(data) {
    if (!data) {
        return;
    }


    //保存客户端授权码是否开启
    this.authCodeEnble = data.authCodeEnble;

    //发送消息通知语言类型，若页面不是中文则为英文提醒
    this.languageType = data.languageType;
};




// 客户端授权码参数
xmail.pms.AuthCodeParam = function(data) {
    if (!data) {
        return;
    }


    //授权码
    this.passwd = data.passwd;

    //授权码用途
    this.memo = data.memo;

    //发送消息通知语言类型，若页面不是中文则为英文提醒
    this.languageType = data.languageType;
};




// 自动转发参数
xmail.pms.AutoForward = function(data) {
    if (!data) {
        return;
    }


    //自动转发是否启用
    this.forwardEnable = data.forwardEnable;

    //转发地址
    this.forwardAddr = data.forwardAddr;

    //保存副本在邮箱中是否启用
    this.forwardDiscardEnable = data.forwardDiscardEnable;
};




// 自动回复参数
xmail.pms.AutoReply = function(data) {
    if (!data) {
        return;
    }


    //自动回复是否启用
    this.replyEnable = data.replyEnable;

    //回复内容
    this.replyContent = data.replyContent;

    //自动回复生效时间是否启用
    this.replyTimeEnable = data.replyTimeEnable;

    //开始时间
    this.replyStartTime = data.replyStartTime;

    //结束时间
    this.replyEndTime = data.replyEndTime;

    //自动回复对通讯录中的联系人是否启用
    this.replyContactEnable = data.replyContactEnable;

    //发件人发送一次自动回复是否启用
    this.replyOnceEnable = data.replyOnceEnable;
};




// 移动邮件参数
xmail.pms.BatchMoveMailParam = function(data) {
    if (!data) {
        return;
    }


    //源文件夹
    this.sourceFolderId = data.sourceFolderId;

    //目标文件夹
    this.targetFolderId = data.targetFolderId;
};




// 设置全部邮件状态参数
xmail.pms.BatchSetMailStatusParam = function(data) {
    if (!data) {
        return;
    }


    //
    this.folderId = data.folderId;

    //邮件状态
    this.targetMailStatus = data.targetMailStatus;
};




//绑定信息返回结果 
xmail.pms.BindInfoResult = function(data) {
    if (!data) {
        return;
    }


    //绑定数据
    this.bindId = data.bindId;

    //绑定类型|account_bind_type|SSO(1, "sso单点登录"),OPEN_APP(2, "开放平台"),PHONE(3, "手机")
    this.bindType = data.bindType;
};




// 绑定手机参数
xmail.pms.BindMobileParam = function(data) {
    if (!data) {
        return;
    }


    //手机
    this.mobile = data.mobile;

    //验证码
    this.code = data.code;
};




//
xmail.pms.BlackListLimit = function(data) {
    if (!data) {
        return;
    }


    //黑名单地址
    this.blackAddr = data.blackAddr;
};




// 黑名单搜索分页请求参数
xmail.pms.BlacklistPageParam = function(data) {
    if (!data) {
        return;
    }


    //搜索词
    this.keyWords = data.keyWords;

    //页数(第几页)
    this.page = data.page;

    //条数
    this.limit = data.limit;
};




// 黑名单联系人参数
xmail.pms.BlacklistParam = function(data) {
    if (!data) {
        return;
    }


    //黑名单地址
    this.blackAddr = data.blackAddr;
};




// 验证验证码参数
xmail.pms.CheckCodeParam = function(data) {
    if (!data) {
        return;
    }


    //手机
    this.mobile = data.mobile;

    //验证码
    this.code = data.code;

    //同一浏览器是否跳过二次验证校验
    this.skipCheckCode = data.skipCheckCode;
};




// 自动转发回复校验邮箱参数
xmail.pms.CheckForwardAddrParam = function(data) {
    if (!data) {
        return;
    }


    //转发地址
    this.forwardAddr = data.forwardAddr;
};




// 校验是否为自己的邮箱地址返回结果
xmail.pms.CheckForwardAddrResult = function(data) {
    if (!data) {
        return;
    }


    //是否为自己的邮箱地址
    this.isOwnEmail = data.isOwnEmail;

    //禁止转发到外域
    this.isDisableForeign = data.isDisableForeign;
};




// 分片上传结果
xmail.pms.ChunkUploadResult = function(data) {
    if (!data) {
        return;
    }


    //文件名称
    this.fileName = data.fileName;

    //文件ID
    this.fid = data.fid;

    //文件大小描述
    this.fileSize = data.fileSize;

    //文件大小字节
    this.fileSizeBytes = data.fileSizeBytes;

    //预览文件路径
    this.previewFileUrl = data.previewFileUrl;

    //是否存在
    this.isExist = data.isExist;
};




//
xmail.pms.ClientLimit = function(data) {
    if (!data) {
        return;
    }


    //授权码
    this.passwd = data.passwd;

    //授权码用途
    this.memo = data.memo;
};




// 客户端设置返回结果
xmail.pms.ClientSettingResult = function(data) {
    if (!data) {
        return;
    }


    //保存发信是否开启
    this.sendMailEnble = data.sendMailEnble;

    //客户授权码是否开启
    this.authCodeEnble = data.authCodeEnble;
};




//CorpAuditLog对象 企业审核记录
xmail.pms.CorpAuditLog = function(data) {
    if (!data) {
        return;
    }


    //
    this.id = data.id;

    //审核日志id
    this.auditLogId = data.auditLogId;

    //企业id
    this.corpId = data.corpId;

    //创建时间
    this.createTime = data.createTime;

    //更新时间
    this.updateTime = data.updateTime;

    //执行范围|audit_scope_type|SEND(1, "发信阶段"),RECIVE(2, "收信阶段"),SENDRECIVE(3, "收信和发信阶段");
    this.scopeType = data.scopeType;

    //审核状态|audit_log_status|AGREE(1, "同意"),DISABLE(2, "拒绝"),AUDITING(3, "审核中"),FAIL(4,"失败"),SCHEDULE(5,"定时任务");
    this.status = data.status;

    //邮件唯一id
    this.fileId = data.fileId;

    //邮件发件人
    this.mailFrom = data.mailFrom;

    //邮件真实发件人
    this.realSender = data.realSender;

    //邮件真实发件人主名
    this.primeSender = data.primeSender;

    //
    this.rcpt = data.rcpt;

    //邮件收件人
    this.mailTo = data.mailTo;

    //邮件抄送人
    this.cc = data.cc;

    //
    this.bcc = data.bcc;

    //邮件主题
    this.subject = data.subject;

    //邮件大小
    this.mailSize = data.mailSize;

    //邮件时间
    this.mailDate = data.mailDate;

    //审核人
    this.auditors = data.auditors;

    //多人审核裁决结果|audit_log_audit_type|FIRST(1, "最先裁决为结果"),ALL(2, "所有人通过结果");
    this.auditType = data.auditType;

    //审核到期时间
    this.auditExpiredTime = data.auditExpiredTime;

    //是否启用当邮件处于审核状态时,通知原发件人
    this.auditingNoticeEnable = data.auditingNoticeEnable;

    //是否启用审核结果通知选项
    this.resultNoticeEnable = data.resultNoticeEnable;

    //审核结果通知类型|audit_log_result_notice_type|AGREE(1, "同意"),REJECT(2, "拒绝"),ALL(3,"全部");
    this.resultNoticeType = data.resultNoticeType;

    //
    this.errorCode = data.errorCode;

    //备注
    this.memo = data.memo;
};




//审核记录列表搜索参数 
xmail.pms.CorpAuditLogSearchParam = function(data) {
    if (!data) {
        return;
    }


    //搜索词
    this.keyWords = data.keyWords;

    //审核状态|audit_log_status|AGREE(1, "同意"),DISABLE(2, "拒绝"),AUDITING(3, "审核中");
    this.status = data.status;

    //页数(第几页)
    this.page = data.page;

    //条数
    this.limit = data.limit;
};




//审核邮件参数 
xmail.pms.CorpAuditMailParam = function(data) {
    if (!data) {
        return;
    }


    //auditId
    this.auditLogId = data.auditLogId;

    //审核状态|audit_log_status|AGREE(1, "同意"),DISABLE(2, "拒绝"),AUDITING(3, "审核中");
    this.status = data.status;

    //审核备注
    this.memo = data.memo;

    //审核人密码
    this.auditorPwd = data.auditorPwd;

    //审核人邮箱地址
    this.userEmail = data.userEmail;
};




//CorpAuditorLog对象 企业审核人记录
xmail.pms.CorpAuditorLog = function(data) {
    if (!data) {
        return;
    }


    //
    this.id = data.id;

    //审核人日志的id
    this.auditLogId = data.auditLogId;

    //企业id
    this.corpId = data.corpId;

    //创建时间
    this.createTime = data.createTime;

    //更新时间
    this.updateTime = data.updateTime;

    //审核人审核时间
    this.auditorTime = data.auditorTime;

    //审核人的邮箱id
    this.auditorAccountId = data.auditorAccountId;

    //审核人邮箱地址
    this.auditorUserEmail = data.auditorUserEmail;

    //审核人密码
    this.auditorPwd = data.auditorPwd;

    //审核状态|auditor_log_status|AGREE(1, "同意"),DISABLE(2, "拒绝"),AUDITING(3, "审核中"),FAIL(4,"失败");
    this.status = data.status;

    //审核备注
    this.memo = data.memo;

    //审核人错误码
    this.auditorErrorCode = data.auditorErrorCode;
};




// 企业通讯录查询联系人参数
xmail.pms.CorpContactInfoParam = function(data) {
    if (!data) {
        return;
    }


    //唯一Id
    this.corpContactId = data.corpContactId;
};




// 企业联系人返回结果
xmail.pms.CorpContactInfoResult = function(data) {
    if (!data) {
        return;
    }


    //电话号码
    this.telephone = data.telephone;

    //传真号码
    this.fax = data.fax;

    //职位
    this.position = data.position;
};




// 企业联系人邮件列表返回结果
xmail.pms.CorpEmailListResult = function(data) {
    if (!data) {
        return;
    }


    //列表包含成员
    this.includeMembers = data.includeMembers;

    //列表包含部门
    this.includeDepartments = data.includeDepartments;

    //列表嵌套列表
    this.nestList = data.nestList;
};




// 返回结果
xmail.pms.CorpOrgTreeInfoResult = function(data) {
    if (!data) {
        return;
    }


    //企业组织结构信息同步版本号
    this.version = data.version;

    //组织架构信息
    this.orgTrees = [];
    if (data.orgTrees) {
        for (let i = 0; i < data.orgTrees.length; i++) {
            this.orgTrees.push(new xmail.pms.OrgTreeNodeDepart(data.orgTrees[i]));
        }
    }
};




// 个人通讯录自定义返回结果
xmail.pms.CustomResult = function(data) {
    if (!data) {
        return;
    }


    //自定义字段Id
    this.fieldId = data.fieldId;

    //自定义字段值
    this.fieldName = data.fieldName;
};




// 删除客户端授权码参数
xmail.pms.DelAuthCodeParam = function(data) {
    if (!data) {
        return;
    }


    //客户端授权码唯一id
    this.authCodeId = data.authCodeId;
};




// 黑名单删除请求参数
xmail.pms.DelMailAccountBlacklistParam = function(data) {
    if (!data) {
        return;
    }


    //邮箱地址
    this.blackAddr = data.blackAddr;
};




// 删除|清空文件夹参数
xmail.pms.DelMailFolderParam = function(data) {
    if (!data) {
        return;
    }


    //
    this.folderId = data.folderId;

    //
    this.forceDelete = data.forceDelete;
};




//
xmail.pms.DelMailIndexByConditionParam = function(data) {
    if (!data) {
        return;
    }


    //
    this.folderId = data.folderId;

    //索引过滤器参数
    this.mailIndexFilterParam = new MailIndexFilterParam(data.mailIndexFilterParam);

    //索引查询参数
    this.mailIndexQueryParam = new MailIndexQueryParam(data.mailIndexQueryParam);
};




//
xmail.pms.DelMailIndexParam = function(data) {
    if (!data) {
        return;
    }


    //删除邮件ID
    this.mailIndexIds = data.mailIndexIds;
};




//
xmail.pms.DelTrustLocationParam = function(data) {
    if (!data) {
        return;
    }


    //删除的唯一ID集合
    this.trustLocationIds = data.trustLocationIds;
};




// 删除组请求参数
xmail.pms.DelUserContactGroupParam = function(data) {
    if (!data) {
        return;
    }


    //组Id
    this.groupId = data.groupId;

    //是否彻底删除联系人
    this.thoroughDelFlag = data.thoroughDelFlag;
};




// 删除联系人参数
xmail.pms.DelUserContactInfoParam = function(data) {
    if (!data) {
        return;
    }


    //删除联系人项
    this.userContactIds = data.userContactIds;

    //true 仅从当前组移除|false 彻底删除
    this.onlyOutGroup = data.onlyOutGroup;

    //组Id
    this.groupId = data.groupId;
};




// 自动转发回复参数
xmail.pms.DeliverInfoParam = function(data) {
    if (!data) {
        return;
    }


    //自动转发参数
    this.autoForward = new AutoForward(data.autoForward);

    //自动回复参数
    this.autoReply = new AutoReply(data.autoReply);

    //语言类型
    this.languageType = data.languageType;
};




// 自动转发,回复结果
xmail.pms.DeliverResult = function(data) {
    if (!data) {
        return;
    }


    //自动转发返回结果
    this.autoForward = new AutoForward(data.autoForward);

    //自动回复返回结果
    this.autoReply = new AutoReply(data.autoReply);
};




// 收发信设置
xmail.pms.DeliverSetting = function(data) {
    if (!data) {
        return;
    }


    //我的名称|send_from_display_type|NONE(1, "不显示"),REAL_NAME(2, "真实姓名"),CUSTOM(3, "自定义");
    this.sendFromDisplay = data.sendFromDisplay;

    //自定义名字
    this.customName = data.customName;

    //写信默认字体
    this.fontName = data.fontName;

    //写信默认字体大小
    this.fontSize = data.fontSize;

    //保存web已发信件
    this.webSent = data.webSent;

    //回执
    this.receipt = data.receipt;

    //回复时加入原信
    this.replyWithContent = data.replyWithContent;

    //回复/转发信头|reply_subject_prefix|EN(1,"Re:/Fw:/Auto-Re:"),CN(2,"回复:/转发:/自动回复:");
    this.replySubjectPrefix = data.replySubjectPrefix;

    //是否自动加入通讯录
    this.orgVisible = data.orgVisible;

    //默认抄送地址
    this.ccDef = data.ccDef;

    //默认密送地址
    this.bccDef = data.bccDef;

    //是否启用强制真实姓名发信
    this.sendForceRealEnable = data.sendForceRealEnable;

    //单封邮件总大小 单位MB
    this.maxAttachSizeSingle = data.maxAttachSizeSingle;

    //单封邮件最大收件人数量（人）
    this.maxToNumSingle = data.maxToNumSingle;

    //超大附件容量 单位G
    this.maxLargeAttachSize = data.maxLargeAttachSize;

    //超大附件存放期 单位天
    this.largeAttachExpireTime = data.largeAttachExpireTime;

    //邮件发送设置|role_deliver_send_type|ENABLE_PART(1, "只允许发送到指定邮箱或域"),DISABLE(2, "禁止发送"),DISABLE_FOREIGN(3, "禁止发送外域"),DISABLE_PART(4, "禁止发送到指定邮箱或域"),DEFAULT(-1,"系统默认");
    this.sendType = data.sendType;

    //禁止接收外域邮件
    this.recvForeignDomainEnable = data.recvForeignDomainEnable;

    //自动转发设置|role_deliver_forward_type|DISABLE(1, "禁止发送1"),DISABLE_FOREIGN(2, "禁止转发外域"),DEFAULT(-1,"系统默认");
    this.forwardType = data.forwardType;

    //预览服务开关
    this.previewServerOnOff = data.previewServerOnOff;

    //预览服务类型
    this.previewServerType = data.previewServerType;
};




// 探测域公告邮件参数
xmail.pms.DetectAnnouncedParam = function(data) {
    if (!data) {
        return;
    }


    //索引id
    this.mailIndexId = data.mailIndexId;
};




// 探测域公告邮件返回结果
xmail.pms.DetectAnnouncedResult = function(data) {
    if (!data) {
        return;
    }


    //域公告邮件是否存在
    this.announcedMailExist = data.announcedMailExist;
};




// 探测主邮箱参数
xmail.pms.DetectMainEmailParam = function(data) {
    if (!data) {
        return;
    }


    //联系人唯一id,修改联系人探测时需要传
    this.userContactId = data.userContactId;

    //主邮箱
    this.email = data.email;
};




// 探测主邮箱返回结果
xmail.pms.DetectMainEmailResult = function(data) {
    if (!data) {
        return;
    }


    //主邮箱是否存在
    this.isExist = data.isExist;
};




// 探测密码参数
xmail.pms.DetectPasswordParam = function(data) {
    if (!data) {
        return;
    }


    //探测的密码
    this.password = data.password;
};




//探测密码返回结果 
xmail.pms.DetectPasswordResult = function(data) {
    if (!data) {
        return;
    }


    //密码是否符合规则
    this.isAccordRule = data.isAccordRule;

    //探测密码结果提示语
    this.message = data.message;
};




// 显示设置
xmail.pms.DisplaySetting = function(data) {
    if (!data) {
        return;
    }


    //邮件列表每页数量
    this.pageSize = data.pageSize;

    //窗口布局|layout|LR(1, "左右布局"),LIST(2, "列表布局");
    this.layout = data.layout;

    //工具栏按钮是否显示图标
    this.toolbarButtonIcon = data.toolbarButtonIcon;

    //登录后默认显示|login_router_page|HOME(1, "首页"),INBOX(2, "收件箱");
    this.loginRouterPage = data.loginRouterPage;

    //收信时姓名显示|recv_from_display_type|original(1, "发件人自定义姓名"),CONTACT(2, "通讯录中备注姓名");
    this.recvFromDisplay = data.recvFromDisplay;

    //皮肤|webmail_skin|OFFICE(1, "商务办公"),REDSIMPLE(2, "红色简约"),BRAVEFORWARD(3, "勇者前行"),SCRIPTURES(4,"经典木纹"),GREEN(5,"绿意风情"),PINK(6,"粉色回忆"),GRASS(7,"青青幽境"),BLACK(8,"时尚酷黑"),GOLD(9,"金色时光");
    this.webmailSkin = data.webmailSkin;

    //语言|language|CN(1, "中文简体"),HK(2, "中文繁体"),EN(3, "英文"),JP(4, "日语"),KO(5, "韩语");
    this.language = data.language;

    //邮箱logo
    this.emailLogo = data.emailLogo;

    //退出url
    this.logoutUrl = data.logoutUrl;

    //自定义title
    this.customTitle = data.customTitle;

    //垃圾邮件删除时间
    this.spamMailDeleteTime = data.spamMailDeleteTime;

    //日程是否显示
    this.calendarEnable = data.calendarEnable;

    //系统是否支持二次验证
    this.secureLoginVerifyOnOff = data.secureLoginVerifyOnOff;

    //系统二次验证默认方式
    this.secureLoginVerifyMethod = data.secureLoginVerifyMethod;
};




// 个人设置返回结果
xmail.pms.DomainSettingResult = function(data) {
    if (!data) {
        return;
    }


    //显示设置
    this.displaySetting = new DisplaySetting(data.displaySetting);

    //收发信设置
    this.deliverSetting = new DeliverSetting(data.deliverSetting);

    //权限位
    this.priviage = new Priviage(data.priviage);

    //弱密码配置规则
    this.pwdWeakRule = new PwdWeakRule(data.pwdWeakRule);

    //字段及添加数量限制
    this.globalConfig = new GlobalConfig(data.globalConfig);
};




// 获取下载文件的路径
xmail.pms.DownloadFileResult = function(data) {
    if (!data) {
        return;
    }


    //下载地址
    this.url = data.url;
};




//
xmail.pms.EncryptMailPasswdParam = function(data) {
    if (!data) {
        return;
    }


    //邮件索引
    this.mailIndexId = data.mailIndexId;
};




//
xmail.pms.EncryptMailPasswdResult = function(data) {
    if (!data) {
        return;
    }


    //邮件密码
    this.mailPasswd = data.mailPasswd;
};




// 导出联系人参数
xmail.pms.ExportContactUserParam = function(data) {
    if (!data) {
        return;
    }


    //联系人ID
    this.userContactIds = data.userContactIds;

    //联系人组ID
    this.groupId = data.groupId;

    //导出的文件格式|1 csv,2 vcf
    this.exportType = data.exportType;
};




//
xmail.pms.FieldLengthLimit = function(data) {
    if (!data) {
        return;
    }


    //账号信息
    this.userInfoLimit = new UserInfoLimit(data.userInfoLimit);

    //账号安全
    this.accountLimit = new AccountLimit(data.accountLimit);

    //POP代收
    this.popLimit = new PopLimit(data.popLimit);

    //常规设置
    this.settingLimit = new SettingLimit(data.settingLimit);

    //客户端设置
    this.clientLimit = new ClientLimit(data.clientLimit);

    //个性签名
    this.signLimit = new SignLimit(data.signLimit);

    //分类过滤
    this.filterLimit = new FilterLimit(data.filterLimit);

    //黑名单
    this.blackListLimit = new BlackListLimit(data.blackListLimit);

    //个人通讯录
    this.userContactLimit = new UserContactLimit(data.userContactLimit);

    //文件夹管理
    this.folderLimit = new FolderLimit(data.folderLimit);
};




// 文件分片验证参数
xmail.pms.FileChunkCheckParam = function(data) {
    if (!data) {
        return;
    }


    //文件MD5码
    this.fileName = data.fileName;

    //文件实际名称
    this.realFileName = data.realFileName;

    //待验证分片索引
    this.chunkIndex = data.chunkIndex;

    //待验证分片大小
    this.chunkSize = data.chunkSize;

    //是否分片
    this.isChunk = data.isChunk;

    //分片数量
    this.chunksTotal = data.chunksTotal;

    //文件后缀
    this.fileExt = data.fileExt;
};




// 文件分片检测参数
xmail.pms.FileChunkUploadCheckParam = function(data) {
    if (!data) {
        return;
    }


    //
    this.token = data.token;

    //
    this.md5 = data.md5;

    //
    this.chunkIndex = data.chunkIndex;

    //
    this.chunkSize = data.chunkSize;
};




// 参数
xmail.pms.FileChunkUploadCompletedParam = function(data) {
    if (!data) {
        return;
    }


    //
    this.token = data.token;

    //
    this.size = data.size;

    //
    this.md5 = data.md5;
};




// 返回结果
xmail.pms.FileChunkUploadCompletedResult = function(data) {
    if (!data) {
        return;
    }


    //
    this.mailAccountFileId = data.mailAccountFileId;
};




// 邮件分类规则Id参数
xmail.pms.FilterIdParam = function(data) {
    if (!data) {
        return;
    }


    //规则ID
    this.filterId = data.filterId;
};




//
xmail.pms.FilterLimit = function(data) {
    if (!data) {
        return;
    }


    //规则名称
    this.name = data.name;

    //邮件大小
    this.mailSize = data.mailSize;

    //邮件主题
    this.subjectVal = data.subjectVal;
};




// 邮件分类规则修改优先级参数
xmail.pms.FilterPriorityParam = function(data) {
    if (!data) {
        return;
    }


    //规则ID
    this.filterId = data.filterId;

    //移动规则动作:1上移 2下移
    this.filterPriorityType = data.filterPriorityType;
};




// 邮件分类规则结果
xmail.pms.FilterResult = function(data) {
    if (!data) {
        return;
    }


    //规则ID
    this.filterId = data.filterId;

    //优先级
    this.priority = data.priority;

    //规则状态|filter_info_status|ENABLE(1, "启用"),DISABLE(2, "禁用");
    this.status = data.status;

    //规则名称
    this.name = data.name;

    //
    this.fromEnable = data.fromEnable;

    //发件人是否包含
    this.fromInclude = data.fromInclude;

    //发件人成员信息
    this.fromMember = data.fromMember;

    //主题是否启用
    this.subjectEnable = data.subjectEnable;

    //主题是否包含
    this.subjectInclude = data.subjectInclude;

    //
    this.subjectMatchAll = data.subjectMatchAll;

    //主题匹配内容
    this.subjectVal = data.subjectVal;

    //邮件大小是否启用
    this.mailSizeEnable = data.mailSizeEnable;

    //邮件大小最大值 单位：KB
    this.mailSizeMax = data.mailSizeMax;

    //邮件大小规则最小值 单位：KB
    this.mailSizeMin = data.mailSizeMin;

    //相应操作|filter_execute_opt_type|DELETE(1, "删除邮件"),FORWARD(2, "转发至"),DEL_FORWARD(3, "删除并转发至"),SAFETIP(4, "添加安全提示"),RUN(5,"执行以下操作");
    this.executeOptType = data.executeOptType;

    //移动到指定文件夹是否启用
    this.moveFolderEnable = data.moveFolderEnable;

    //移动规则-要移动到的文件夹ID
    this.moveFolderId = data.moveFolderId;

    //转发是否启用
    this.forwardEnable = data.forwardEnable;

    //转发地址成员id
    this.forwardAddr = data.forwardAddr;

    //丢弃已自动转发的邮件是否启用
    this.forwardDiscardEnable = data.forwardDiscardEnable;

    //自动回复是否启用
    this.replyEnable = data.replyEnable;

    //自动回复内容
    this.replyContent = data.replyContent;

    //收件人或抄送人是否启用
    this.toEnable = data.toEnable;

    //收件人或抄送人是否包含
    this.toInclude = data.toInclude;

    //收件人或抄送人成员信息
    this.toMember = data.toMember;
};




// 邮件分类规则修改状态参数
xmail.pms.FilterStatusParam = function(data) {
    if (!data) {
        return;
    }


    //规则ID
    this.filterId = data.filterId;

    //规则状态
    this.status = data.status;
};




//
xmail.pms.FolderLimit = function(data) {
    if (!data) {
        return;
    }


    //文件夹名称
    this.folderName = data.folderName;
};




// 邮件转发信息结果
xmail.pms.ForwardMailInfoResult = function(data) {
    if (!data) {
        return;
    }


    //文件ID
    this.fileId = data.fileId;

    //文件名称
    this.fileName = data.fileName;

    //文件大小
    this.fileSize = data.fileSize;

    //预览路径
    this.preViewPath = data.preViewPath;
};




// 转发邮件结果
xmail.pms.ForwardMailResult = function(data) {
    if (!data) {
        return;
    }


    //转发邮件信息
    this.forwardMailInfos = [];
    if (data.forwardMailInfos) {
        for (let i = 0; i < data.forwardMailInfos.length; i++) {
            this.forwardMailInfos.push(new xmail.pms.ForwardMailInfoResult(data.forwardMailInfos[i]));
        }
    }
};




// 生成随机授权码返回结果
xmail.pms.GetAuthCodeResult = function(data) {
    if (!data) {
        return;
    }


    //授权码
    this.passwd = data.passwd;
};




// 获取超大文件列表参数
xmail.pms.GetFileListParam = function(data) {
    if (!data) {
        return;
    }


    //当前页
    this.currentPage = data.currentPage;

    //每页条数
    this.pageSize = data.pageSize;
};




// 获取文件列表结果
xmail.pms.GetFileListResult = function(data) {
    if (!data) {
        return;
    }


    //大附件信息列表
    this.mailAccountFilePage = data.mailAccountFilePage;
};




// 获取文件夹参数
xmail.pms.GetMailFolderParam = function(data) {
    if (!data) {
        return;
    }


    //
    this.folderId = data.folderId;

    //
    this.mailFolderFields = data.mailFolderFields;
};




//
xmail.pms.GetMailIndexParam = function(data) {
    if (!data) {
        return;
    }


    //邮件ID
    this.mailIndexId = data.mailIndexId;

    //index字段[过滤用]
    this.mailIndexFields = data.mailIndexFields;
};




// 获取空间信息结果
xmail.pms.GetSpaceInfoResult = function(data) {
    if (!data) {
        return;
    }


    //总大小(字节)
    this.totalSize = data.totalSize;

    //已使用大小(字节)
    this.usedSize = data.usedSize;

    //空闲大小(字节)
    this.freeSize = data.freeSize;
};




// 联系人参数
xmail.pms.GetUserContactInfoParam = function(data) {
    if (!data) {
        return;
    }


    //联系人ID
    this.userContactId = data.userContactId;
};




// 通讯录单个人返回结果
xmail.pms.GetUserContactInfoResult = function(data) {
    if (!data) {
        return;
    }


    //联系人ID
    this.userContactId = data.userContactId;

    //联系人所在组
    this.groups = [];
    if (data.groups) {
        for (let i = 0; i < data.groups.length; i++) {
            this.groups.push(new xmail.pms.UserGroupResult(data.groups[i]));
        }
    }

    //电子邮件
    this.emails = data.emails;

    //电话号码
    this.telephones = data.telephones;

    //传真号码
    this.faxs = data.faxs;

    //自定义
    this.customs = [];
    if (data.customs) {
        for (let i = 0; i < data.customs.length; i++) {
            this.customs.push(new xmail.pms.CustomResult(data.customs[i]));
        }
    }

    //联系人所在组id
    this.groupIds = data.groupIds;

    //电子邮件
    this.email = data.email;

    //电话号码
    this.telephone = data.telephone;

    //传真号码
    this.fax = data.fax;

    //自定义|分隔示例:key1¶value1§key2¶value2
    this.custom = data.custom;

    //姓氏
    this.surname = data.surname;

    //名字
    this.givenName = data.givenName;

    //性别
    this.gender = data.gender;

    //生日
    this.birthday = data.birthday;

    //昵称
    this.nickname = data.nickname;

    //微信
    this.wechat = data.wechat;

    //msn
    this.msn = data.msn;

    //QQ
    this.qq = data.qq;

    //公司名称
    this.company = data.company;

    //部门名称
    this.departName = data.departName;

    //职位
    this.position = data.position;

    //公司-网址
    this.workWebsite = data.workWebsite;

    //公司-国家
    this.workCountry = data.workCountry;

    //公司-省
    this.workProvince = data.workProvince;

    //公司-市
    this.workCity = data.workCity;

    //公司-街道
    this.workStreet = data.workStreet;

    //公司-邮编
    this.workPostalCode = data.workPostalCode;

    //家庭-国家
    this.homeCountry = data.homeCountry;

    //家庭-省
    this.homeProvince = data.homeProvince;

    //家庭-市
    this.homeCity = data.homeCity;

    //家庭-街道
    this.homeStreet = data.homeStreet;

    //家庭-邮编
    this.homePostalCode = data.homePostalCode;

    //备注
    this.memo = data.memo;
};




// 获取联系人列表参数
xmail.pms.GetUserContactListParam = function(data) {
    if (!data) {
        return;
    }


    //个人通讯录版本号
    this.contactVersion = data.contactVersion;
};




// 获取用户联系人列表结果
xmail.pms.GetUserContactListResult = function(data) {
    if (!data) {
        return;
    }


    //用户联系人列表
    this.userContactTrees = [];
    if (data.userContactTrees) {
        for (let i = 0; i < data.userContactTrees.length; i++) {
            this.userContactTrees.push(new xmail.pms.UserContactGroupResult(data.userContactTrees[i]));
        }
    }

    //版本是否改变,未改变则不返回树结构
    this.versionChange = data.versionChange;

    //个人通讯录版本号
    this.contactVersion = data.contactVersion;
};




//
xmail.pms.GlobalConfig = function(data) {
    if (!data) {
        return;
    }


    //字段长度限制
    this.fieldLengthLimit = new FieldLengthLimit(data.fieldLengthLimit);

    //最大数量限制
    this.maximumLimit = new SystemMaximum(data.maximumLimit);
};




// 上传通讯录文件头字段对应位置信息
xmail.pms.HeaderResult = function(data) {
    if (!data) {
        return;
    }


    //文件头名字
    this.headerName = data.headerName;

    //文件头位置
    this.position = data.position;
};




// 主页结果
xmail.pms.HomeInfoResult = function(data) {
    if (!data) {
        return;
    }


    //头像
    this.headImgUrl = data.headImgUrl;

    //用户名称
    this.userName = data.userName;

    //用户邮箱
    this.userEmail = data.userEmail;

    //上一次登录ip信息
    this.lastTimeLoginIpInfo = new IpInfo(data.lastTimeLoginIpInfo);

    //当前登录的ip信息
    this.presentLoginIpInfo = new IpInfo(data.presentLoginIpInfo);

    //最后修改密码时间
    this.lastUpdatePass = data.lastUpdatePass;

    //未读邮件数量
    this.unreadNum = data.unreadNum;

    //星标邮件数量
    this.staredNum = data.staredNum;

    //代办邮件数量
    this.waitedNum = data.waitedNum;

    //邮箱总数
    this.mailTotalNum = data.mailTotalNum;

    //已使用邮件数量
    this.useMailNum = data.useMailNum;

    //邮箱总容量大小（B）
    this.mailMaxSize = data.mailMaxSize;

    //已使用邮件容量大小（B）
    this.useMailSize = data.useMailSize;

    //域公告邮件
    this.announcedMails = [];
    if (data.announcedMails) {
        for (let i = 0; i < data.announcedMails.length; i++) {
            this.announcedMails.push(new xmail.pms.AnnouncedMail(data.announcedMails[i]));
        }
    }

    //问候语
    this.greetingType = data.greetingType;
};




// 导入联系人对应关系参数
xmail.pms.ImportContactUserParam = function(data) {
    if (!data) {
        return;
    }


    //要导入的组,不传默认为全部
    this.groupId = data.groupId;

    //文件名
    this.fileName = data.fileName;

    //编码格式,不传默认为GB18030
    this.charset = data.charset;

    //名字对应文件位置
    this.givenName = data.givenName;

    //电子邮件对应文件位置
    this.email = data.email;

    //电话号码对应文件位置
    this.telephone = data.telephone;

    //传真号码对应文件位置
    this.fax = data.fax;

    //公司对应文件位置
    this.company = data.company;

    //部门名称对应文件位置
    this.departName = data.departName;

    //职位对应文件位置
    this.position = data.position;

    //公司-网址对应文件位置
    this.workWebsite = data.workWebsite;

    //公司-国家对应文件位置
    this.workCountry = data.workCountry;

    //公司-省对应文件位置
    this.workProvince = data.workProvince;

    //公司-市对应文件位置
    this.workCity = data.workCity;

    //公司-街道对应文件位置
    this.workStreet = data.workStreet;

    //公司-邮编对应文件位置
    this.workPostalCode = data.workPostalCode;

    //昵称对应文件位置
    this.nickname = data.nickname;

    //性别对应文件位置
    this.gender = data.gender;

    //生日对应文件位置
    this.birthday = data.birthday;

    //微信对应文件位置
    this.wechat = data.wechat;

    //QQ对应文件位置
    this.qq = data.qq;

    //msn对应文件位置
    this.msn = data.msn;

    //家庭-国家对应文件位置
    this.homeCountry = data.homeCountry;

    //家庭-省对应文件位置
    this.homeProvince = data.homeProvince;

    //家庭-市对应文件位置
    this.homeCity = data.homeCity;

    //家庭-街道对应文件位置
    this.homeStreet = data.homeStreet;

    //家庭-邮编对应文件位置
    this.homePostalCode = data.homePostalCode;

    //备注对应文件位置
    this.memo = data.memo;
};




//
xmail.pms.InnerFileInfo = function(data) {
    if (!data) {
        return;
    }


    //
    this.emailId = data.emailId;

    //
    this.folderId = data.folderId;

    //
    this.innerCid = data.innerCid;

    //
    this.contentType = data.contentType;

    //
    this.head = data.head;

    //
    this.end = data.end;

    //
    this.innerType = data.innerType;

    //
    this.file = data.file;
};




//
xmail.pms.IpInfo = function(data) {
    if (!data) {
        return;
    }


    //
    this.ip = data.ip;

    //
    this.city = data.city;

    //
    this.loginTime = data.loginTime;

    //
    this.ipLocation = data.ipLocation;

    //
    this.isInnerIp = data.isInnerIp;
};




// 大附件ID参数
xmail.pms.LargeFileIdsParam = function(data) {
    if (!data) {
        return;
    }


    //大附件文件ID
    this.mailAccountFileIds = data.mailAccountFileIds;
};




// 常规布局参数
xmail.pms.LayoutParam = function(data) {
    if (!data) {
        return;
    }


    //窗口布局|layout|LR(1, "左右布局"),LIST(2, "列表布局");
    this.layout = data.layout;
};




//
xmail.pms.ListMailIndexParam = function(data) {
    if (!data) {
        return;
    }


    //
    this.folderId = data.folderId;

    //邮件索引ID
    this.mailIndexIds = data.mailIndexIds;

    //当前页
    this.currentPage = data.currentPage;

    //每页条数
    this.pageSize = data.pageSize;

    //索引过滤器参数
    this.mailIndexFilterParam = new MailIndexFilterParam(data.mailIndexFilterParam);

    //索引查询参数
    this.mailIndexQueryParam = new MailIndexQueryParam(data.mailIndexQueryParam);

    //索引排序参数
    this.mailIndexSortParam = new MailIndexSortParam(data.mailIndexSortParam);

    //index字段[返回字段]
    this.mailIndexFields = data.mailIndexFields;
};




// 请求参数
xmail.pms.LoggerFindParam = function(data) {
    if (!data) {
        return;
    }


    //
    this.keyword = data.keyword;

    //
    this.time = data.time;

    //
    this.module = data.module;

    //
    this.level = data.level;

    //
    this.lineNum = data.lineNum;
};




//
xmail.pms.MailCalendarInfo = function(data) {
    if (!data) {
        return;
    }


    //
    this.startTime = data.startTime;

    //
    this.startTimeL = data.startTimeL;

    //
    this.endTime = data.endTime;

    //
    this.endTimeL = data.endTimeL;

    //
    this.position = data.position;

    //
    this.isAccept = data.isAccept;

    //
    this.isCalendar = data.isCalendar;

    //
    this.currentTime = data.currentTime;

    //
    this.tzoffSetFrom = data.tzoffSetFrom;

    //
    this.tzoffSetTo = data.tzoffSetTo;

    //
    this.timeZoon = data.timeZoon;

    //
    this.currentTimeZone = data.currentTimeZone;

    //
    this.prodId = data.prodId;

    //
    this.cstFlag = data.cstFlag;
};




// 邮件分类规则参数
xmail.pms.MailFilterParam = function(data) {
    if (!data) {
        return;
    }


    //规则状态|filter_info_status|ENABLE(1, "启用"),DISABLE(2, "禁用");
    this.status = data.status;

    //规则名称
    this.name = data.name;

    //发件人是否开启
    this.fromEnable = data.fromEnable;

    //发件人是否包含
    this.fromInclude = data.fromInclude;

    //发件人成员信息
    this.fromMember = data.fromMember;

    //主题是否启用
    this.subjectEnable = data.subjectEnable;

    //主题是否包含
    this.subjectInclude = data.subjectInclude;

    //
    this.subjectMatchAll = data.subjectMatchAll;

    //主题匹配内容
    this.subjectVal = data.subjectVal;

    //邮件大小是否启用
    this.mailSizeEnable = data.mailSizeEnable;

    //邮件大小最大值 单位：KB
    this.mailSizeMax = data.mailSizeMax;

    //邮件大小规则最小值 单位：KB
    this.mailSizeMin = data.mailSizeMin;

    //相应操作|filter_execute_opt_type|DELETE(1, "删除邮件"),FORWARD(2, "转发至"),DEL_FORWARD(3, "删除并转发至"),SAFETIP(4, "添加安全提示"),RUN(5,"执行以下操作");
    this.executeOptType = data.executeOptType;

    //移动到指定文件夹是否启用
    this.moveFolderEnable = data.moveFolderEnable;

    //移动规则-要移动到的文件夹ID
    this.moveFolderId = data.moveFolderId;

    //转发是否启用
    this.forwardEnable = data.forwardEnable;

    //转发地址
    this.forwardAddr = data.forwardAddr;

    //丢弃已自动转发的邮件是否启用
    this.forwardDiscardEnable = data.forwardDiscardEnable;

    //自动回复是否启用
    this.replyEnable = data.replyEnable;

    //自动回复内容
    this.replyContent = data.replyContent;

    //收件人或抄送人是否启用
    this.toEnable = data.toEnable;

    //收件人或抄送人是否包含
    this.toInclude = data.toInclude;

    //收件人信息
    this.toMember = data.toMember;
};




//MailFolder对象 邮件文件夹信息表
xmail.pms.MailFolder = function(data) {
    if (!data) {
        return;
    }


    //
    this.id = data.id;

    //企业ID
    this.corpId = data.corpId;

    //邮箱ID
    this.mailAccountId = data.mailAccountId;

    //文件夹ID
    this.folderId = data.folderId;

    //父文件夹ID （0表示根）
    this.parentFolderId = data.parentFolderId;

    //状态|mail_folder_status|NORMAL(1, "正常"), WAIT_DELETE(2,"邮箱已删除、等待后续异步删除");
    this.status = data.status;

    //文件夹名称（IMAP-UTF7）
    this.name = data.name;

    //文件夹名称（显示使用-UTF8）
    this.displayName = data.displayName;

    //此文件夹下一个IMAP_UID（历史最大+1）
    this.nextImapUid = data.nextImapUid;

    //是否计数标记（文件夹内邮件未读、星标等标记是否计入邮箱计数）
    this.flagCounted = data.flagCounted;

    //是否占用容量（文件夹内邮件是否计入邮箱使用总封数、空间）
    this.spaceCounted = data.spaceCounted;

    //是否已订阅（IMAP）
    this.subscribed = data.subscribed;

    //是否隐藏
    this.hidden = data.hidden;

    //创建时间
    this.createTime = data.createTime;

    //修改时间
    this.updateTime = data.updateTime;

    //排序值
    this.sortVal = data.sortVal;

    //文件夹的层级从0开始（收件箱等顶层目录层级是0）
    this.depth = data.depth;

    //当前文件夹内直属邮件总大小（字节数, 不包括子孙文件夹）
    this.mailSize = data.mailSize;

    //当前文件夹内直属邮件数量（不包括子孙文件夹）
    this.mailCount = data.mailCount;

    //当前文件夹内直属新信数量（不包括子孙文件夹）
    this.recentCount = data.recentCount;

    //当前文件夹内直属未读邮件数量（不包括子孙文件夹）
    this.unseenCount = data.unseenCount;

    //当前文件夹内直属星标邮件数量（不包括子孙文件夹）
    this.starredCount = data.starredCount;

    //当前文件夹内直属代办邮件数量（不包括子孙文件夹）
    this.waitedCount = data.waitedCount;
};




// 文件夹列表结果
xmail.pms.MailFolderListResult = function(data) {
    if (!data) {
        return;
    }


    //
    this.version = data.version;

    //文件夹列表
    this.mailFolders = [];
    if (data.mailFolders) {
        for (let i = 0; i < data.mailFolders.length; i++) {
            this.mailFolders.push(new xmail.pms.MailFolder(data.mailFolders[i]));
        }
    }
};




// 获取信头信息
xmail.pms.MailHeadGetResult = function(data) {
    if (!data) {
        return;
    }


    //信头（原始内容、未解析）
    this.mailHead = data.mailHead;
};




// 邮件标识参数
xmail.pms.MailIdParam = function(data) {
    if (!data) {
        return;
    }


    //索引ID
    this.mailIndexId = data.mailIndexId;
};




// 下载邮件参数
xmail.pms.MailIdsParam = function(data) {
    if (!data) {
        return;
    }


    //邮件索引ID
    this.mailIndexIds = data.mailIndexIds;
};




//MailIndex对象 邮件索引信息表
xmail.pms.MailIndex = function(data) {
    if (!data) {
        return;
    }


    //
    this.id = data.id;

    //索引ID
    this.mailIndexId = data.mailIndexId;

    //企业id
    this.corpId = data.corpId;

    //邮箱账号ID
    this.mailAccountId = data.mailAccountId;

    //
    this.folderId = data.folderId;

    //IMAP UID
    this.imapUid = data.imapUid;

    //邮件原信fileId
    this.fileId = data.fileId;

    //状态|mail_index_status|NORMAL(1, "正常"), WAIT_DELETE(2,"邮箱已删除、等待后续异步删除");
    this.status = data.status;

    //邮件密码ID
    this.encryptId = data.encryptId;

    //OUTLOOK格式（winmail.dat）
    this.tnef = data.tnef;

    //邮件尺寸(字节数)
    this.mailSize = data.mailSize;

    //日期（信头）
    this.mailDate = data.mailDate;

    //发件人
    this.sender = data.sender;

    //发信人（smtp登录名）
    this.realSender = data.realSender;

    //发信人（smtp登录名的主名）
    this.primeSender = data.primeSender;

    //发信人（信头）
    this.mailFrom = data.mailFrom;

    //收信人（信头）
    this.mailTo = data.mailTo;

    //抄送
    this.cc = data.cc;

    //密送
    this.bcc = data.bcc;

    //优先级|mail_priority|URGENCY(1, "紧急"),NORMAL(3, "普通"),SLOW(5, "缓慢");
    this.priority = data.priority;

    //MSGID（信头）
    this.messageId = data.messageId;

    //主题
    this.subject = data.subject;

    //邮件索引属性标记:mail_index_attr_flag:1,unbelong_contacts,非常用联系人|2,auto_reply,自动回复标志|3,auto_forward,自动转发标志|4,decrypt,解密|5,send_later,定时发信
    this.attrFlag = new MailIndexAttrFlag(data.attrFlag);

    //标记垃圾邮件类别|mail_abs_type|NORMAL(1, "正常"), SPAM(2, "垃圾"), DOMAIN_INTERNAL(3, "同域"), DOMAIN_WHITELIST(4, "域白名单");
    this.absType = data.absType;

    //星标
    this.starred = data.starred;

    // 代办邮件
    this.waited = data.waited;

    //撤回状态类型|mail_undo_send_type|ALL_SUCC(1, "全部成功"),PART_SUCC(2, "部分成功"),ALL_FAIL(3, "全部失败"),PART_FAIL(4, "部分失败"),UNDOING(5,"撤回中"),NO_UNDO(6,"未撤回"); 
    this.undoSend = data.undoSend;

    //新信
    this.recent = data.recent;

    //已读
    this.seen = data.seen;

    //草稿
    this.draft = data.draft;

    //删除标记
    this.deleted = data.deleted;

    //回复
    this.answered = data.answered;

    //回执
    this.receipt = data.receipt;

    //转发
    this.forwarded = data.forwarded;

    //群发单显
    this.sendAlone = data.sendAlone;

    //域公告邮件
    this.announcedMail = data.announcedMail;

    //是否外域
    this.foreignDomain = data.foreignDomain;

    //附件数量
    this.attachCount = data.attachCount;

    //所有附件名称（用于搜索）
    this.attachNames = data.attachNames;

    //跟踪ID(MD5(CONCAT(mail_from,'|',message_id,'|',`subject`,'|',UNIX_TIMESTAMP(mail_date))))
    this.traceId = data.traceId;

    //存信时间(同createtime，搬家例外)
    this.receivedTime = data.receivedTime;

    //创建时间
    this.createTime = data.createTime;

    //更新时间
    this.updateTime = data.updateTime;
};




// 邮件索引属性标记
xmail.pms.MailIndexAttrFlag = function(data) {
    if (!data) {
        return;
    }


    //
    this.value = data.value;
};




// 索引过滤参数
xmail.pms.MailIndexFilterParam = function(data) {
    if (!data) {
        return;
    }


    //已读、未读
    this.seen = data.seen;

    //回复
    this.answered = data.answered;

    //转发
    this.forwarded = data.forwarded;

    //星标
    this.starred = data.starred;

    //代办邮件
    this.waited = data.waited;

    //附件标识
    this.attached = data.attached;

    //优先级标识
    this.priority = data.priority;

    //撤回状态类型
    this.undoSend = data.undoSend;

    //公告邮件
    this.announced = data.announced;

    //删除标记
    this.deleted = data.deleted;

    //新信
    this.recent = data.recent;

    //草稿
    this.draft = data.draft;

    //回执
    this.receipt = data.receipt;
};




// 获取邮件索引ID结果
xmail.pms.MailIndexIdResult = function(data) {
    if (!data) {
        return;
    }


    //邮件索引ID
    this.mailIndexId = data.mailIndexId;
};




// 文件夹索引结果
xmail.pms.MailIndexListResult = function(data) {
    if (!data) {
        return;
    }


    //索引列表分页
    this.mailIndexPage = data.mailIndexPage;

    //文件夹信息
    this.mailFolder = new MailFolder(data.mailFolder);
};




// 索引查询参数
xmail.pms.MailIndexQueryParam = function(data) {
    if (!data) {
        return;
    }


    //发件人
    this.from = data.from;

    //收件人
    this.to = data.to;

    //抄送人
    this.cc = data.cc;

    //密送人
    this.bcc = data.bcc;

    //主题
    this.subject = data.subject;

    //开始时间
    this.startTime = data.startTime;

    //结束时间
    this.endTime = data.endTime;

    //附件标识
    this.attached = data.attached;

    //读取标识
    this.seen = data.seen;

    //搜索类型
    this.searchType = data.searchType;

    //快捷搜索字段名
    this.searchKeyword = data.searchKeyword;

    //往来邮件
    this.mutual = data.mutual;

    //正文（全文检索）
    this.fullText = data.fullText;

    //附件名
    this.attachName = data.attachName;

    //IMAP UID 最小值
    this.minImapUid = data.minImapUid;

    //IMAP UID 最大值
    this.maxImapUid = data.maxImapUid;

    //最小邮件尺寸（字节数）
    this.minMailSize = data.minMailSize;

    //最大邮件尺寸（字节数）
    this.maxMailSize = data.maxMailSize;

    //最小附件数量
    this.minAttachCount = data.minAttachCount;

    //最大附件数量
    this.maxAttachCount = data.maxAttachCount;
};




// 索引排序参数
xmail.pms.MailIndexSortParam = function(data) {
    if (!data) {
        return;
    }


    //时间排序
    this.timeSortType = data.timeSortType;

    //发件人排序
    this.senderSortType = data.senderSortType;

    //主题排序
    this.subjectSortType = data.subjectSortType;

    //邮件大小排序
    this.mailSizeSortType = data.mailSizeSortType;

    //IMAP UID 排序
    this.imapUidSortType = data.imapUidSortType;
};




// 邮件账号版本结果
xmail.pms.MailIndexVersionResult = function(data) {
    if (!data) {
        return;
    }


    //版本号
    this.version = data.version;
};




//
xmail.pms.MailInfo = function(data) {
    if (!data) {
        return;
    }


    //
    this.headCharset = data.headCharset;

    //
    this.parseImageFlag = data.parseImageFlag;

    //
    this.parseAttachFlag = data.parseAttachFlag;

    //
    this.attachPath = data.attachPath;

    //
    this.imagePath = data.imagePath;

    //
    this.user = data.user;

    //
    this.mailIndexId = data.mailIndexId;

    //
    this.folderId = data.folderId;

    //
    this.from = data.from;

    //
    this.to = data.to;

    //
    this.cc = data.cc;

    //
    this.mailSize = data.mailSize;

    //
    this.needReceipt = data.needReceipt;

    //
    this.priority = data.priority;

    //
    this.sendDate = data.sendDate;

    //
    this.messageId = data.messageId;

    //
    this.references = data.references;

    //
    this.mailText = data.mailText;

    //
    this.subject = data.subject;

    //
    this.bcc = data.bcc;

    //
    this.replayTo = data.replayTo;

    //
    this.sender = data.sender;

    //
    this.realSender = data.realSender;

    //
    this.primeSender = data.primeSender;

    //
    this.multiAttachDownUrl = data.multiAttachDownUrl;

    //
    this.sendIndividually = data.sendIndividually;

    //
    this.encryptMail = data.encryptMail;

    //
    this.encryptId = data.encryptId;

    //
    this.mtaTime = data.mtaTime;

    //
    this.mailPasswdStatus = data.mailPasswdStatus;

    //
    this.replyPreviousEmailId = data.replyPreviousEmailId;

    //
    this.mailOperateType = data.mailOperateType;

    //
    this.xtraceEid = data.xtraceEid;

    //
    this.strangerRemindFlag = data.strangerRemindFlag;

    //
    this.selfMailFlag = data.selfMailFlag;

    //
    this.attachInfos = [];
    if (data.attachInfos) {
        for (let i = 0; i < data.attachInfos.length; i++) {
            this.attachInfos.push(new xmail.pms.AttachInfo(data.attachInfos[i]));
        }
    }

    //
    this.innerFileInfos = [];
    if (data.innerFileInfos) {
        for (let i = 0; i < data.innerFileInfos.length; i++) {
            this.innerFileInfos.push(new xmail.pms.InnerFileInfo(data.innerFileInfos[i]));
        }
    }

    //
    this.mcv = new MailCalendarInfo(data.mcv);
};




// 根据条件操作邮件结果
xmail.pms.MailOptByConditionResult = function(data) {
    if (!data) {
        return;
    }


    //
    this.mailIndexIds = data.mailIndexIds;
};




// 邮件回执
xmail.pms.MailReceiptParam = function(data) {
    if (!data) {
        return;
    }


    //邮件索引ID
    this.mailIndexId = data.mailIndexId;

    //邮件主题
    this.subject = data.subject;

    //发件人
    this.from = data.from;
};




// 邮件状态参数
xmail.pms.MailStatusParams = function(data) {
    if (!data) {
        return;
    }


    //已读标识(true已读，false未读)
    this.seen = data.seen;

    //回复标识(true回复，false未回复)
    this.answered = data.answered;

    //转发标识(true转发，false未转发)
    this.forwarded = data.forwarded;
};




// 移动邮件参数
xmail.pms.MoveMailByConditionParam = function(data) {
    if (!data) {
        return;
    }


    //目标文件夹
    this.targetFolderId = data.targetFolderId;

    //
    this.folderId = data.folderId;

    //索引过滤器参数
    this.mailIndexFilterParam = new MailIndexFilterParam(data.mailIndexFilterParam);

    //索引查询参数
    this.mailIndexQueryParam = new MailIndexQueryParam(data.mailIndexQueryParam);
};




// 移动邮件参数
xmail.pms.MoveMailParam = function(data) {
    if (!data) {
        return;
    }


    //邮件索引
    this.mailIndexIds = data.mailIndexIds;

    //目标文件夹
    this.targetFolderId = data.targetFolderId;
};




//
xmail.pms.MultipartFile = function(data) {
    if (!data) {
        return;
    }

};




//
xmail.pms.NonGarbageMailParam = function(data) {
    if (!data) {
        return;
    }


    //邮件ID
    this.mailIndexIds = data.mailIndexIds;
};




//
xmail.pms.Object = function(data) {
    if (!data) {
        return;
    }

};




// 
xmail.pms.OrgTreeNode = function(data) {
    if (!data) {
        return;
    }


    //
    this.id = data.id;

    //
    this.type = data.type;

    //
    this.name = data.name;

    //
    this.pinyin = data.pinyin;

    //
    this.sortVal = data.sortVal;

    //
    this.children = [];
    if (data.children) {
        for (let i = 0; i < data.children.length; i++) {
            this.children.push(new xmail.pms.OrgTreeNode(data.children[i]));
        }
    }
};




// 
xmail.pms.OrgTreeNodeDepart = function(data) {
    if (!data) {
        return;
    }


    //
    this.id = data.id;

    //
    this.type = data.type;

    //
    this.name = data.name;

    //
    this.pinyin = data.pinyin;

    //
    this.sortVal = data.sortVal;

    //
    this.children = [];
    if (data.children) {
        for (let i = 0; i < data.children.length; i++) {
            this.children.push(new xmail.pms.OrgTreeNode(data.children[i]));
        }
    }
};




// 分页请求参数
xmail.pms.PageParam = function(data) {
    if (!data) {
        return;
    }


    //页数(第几页)
    this.page = data.page;

    //条数
    this.limit = data.limit;
};




// 其他邮箱代收账号参数
xmail.pms.PopEmailParam = function(data) {
    if (!data) {
        return;
    }


    //其他邮箱账号
    this.popEmail = data.popEmail;
};




// 其他邮箱代收参数
xmail.pms.PopInfoParam = function(data) {
    if (!data) {
        return;
    }


    //其他邮箱账号
    this.popEmail = data.popEmail;

    //其他邮箱密码，非对称加密
    this.popPasswd = data.popPasswd;

    //pop服务器
    this.popHost = data.popHost;

    //端口号
    this.popPort = data.popPort;

    //ssl连接是否开启|0关闭 1开启
    this.sslEnable = data.sslEnable;

    //存放至的文件夹id
    this.folderId = data.folderId;

    //原邮箱是否丢弃副本|0 丢弃 1不丢弃
    this.discardEnable = data.discardEnable;

    //是否启用该账号
    this.status = data.status;
};




// 代收邮箱简要描述返回结果
xmail.pms.PopInfoResult = function(data) {
    if (!data) {
        return;
    }


    //其他邮箱账号id
    this.popEmail = data.popEmail;

    //其他邮箱密码
    this.popPasswd = data.popPasswd;

    //pop服务器
    this.popHost = data.popHost;

    //端口号
    this.popPort = data.popPort;

    //ssl连接是否开启|0关闭 1开启
    this.sslEnable = data.sslEnable;

    //存放至的文件夹id
    this.folderId = data.folderId;

    //原邮箱是否丢弃副本|0 丢弃 1不丢弃
    this.discardEnable = data.discardEnable;

    //账号状态|pop_emal_status|ENABLE(1, "启用"),DISABLE(2, "禁用");
    this.status = data.status;
};




//
xmail.pms.PopLimit = function(data) {
    if (!data) {
        return;
    }


    //其他邮箱账号
    this.popEmail = data.popEmail;

    //邮箱密码
    this.popPasswd = data.popPasswd;

    //POP服务器
    this.popHost = data.popHost;
};




// 附件预览参数
xmail.pms.PreviewAttachParam = function(data) {
    if (!data) {
        return;
    }


    //
    this.downloadUrl = data.downloadUrl;

    //
    this.fileName = data.fileName;
};




// 预览结果
xmail.pms.PreviewAttachResult = function(data) {
    if (!data) {
        return;
    }


    //
    this.viewUrl = data.viewUrl;
};




//
xmail.pms.Priviage = function(data) {
    if (!data) {
        return;
    }


    //权限1(privi_info表前64个privi_id )
    this.priviage1 = data.priviage1;

    //权限2(大于64的privi_id，对64取模，余数就是表名)
    this.priviage2 = data.priviage2;
};




//
xmail.pms.PwdWeakRule = function(data) {
    if (!data) {
        return;
    }


    //密码种类组合
    this.pwdClassify = data.pwdClassify;

    //密码组合种类
    this.pwdClassifyCount = data.pwdClassifyCount;

    //密码最小长度限制
    this.pwdLen = data.pwdLen;

    //最小密码长度
    this.minPwdLen = data.minPwdLen;

    //不能与原密码相同
    this.pwdDiffOriginal = data.pwdDiffOriginal;

    //不能包含三个连续或相同的字符
    this.pwdDiscontinuity = data.pwdDiscontinuity;

    //不能包含用户名或域名
    this.pwdIncDomainUser = data.pwdIncDomainUser;

    //不能用过于简单的密码
    this.pwdWeakForbidden = data.pwdWeakForbidden;
};




// 读信参数
xmail.pms.ReadMailParam = function(data) {
    if (!data) {
        return;
    }


    //索引ID
    this.mailIndexId = data.mailIndexId;

    //文件ID
    this.fileId = data.fileId;

    //邮件状态
    this.mailStatus = data.mailStatus;

    //加密邮件解密密码
    this.mailPasswd = data.mailPasswd;

    //是否点击邮件消息
    this.isClickMsg = data.isClickMsg;
};




// 读信参数
xmail.pms.ReadMailResult = function(data) {
    if (!data) {
        return;
    }


    //业务代码
    this.code = data.code;

    //邮件信息
    this.mailInfo = new MailInfo(data.mailInfo);

    //索引信息
    this.mailIndex = new MailIndex(data.mailIndex);
};




//异地登录提醒开关返回结果 
xmail.pms.RemoteEnableResult = function(data) {
    if (!data) {
        return;
    }


    //异地登录提醒开关
    this.remoteLoginRemind = data.remoteLoginRemind;

    //邮件异地登录提醒
    this.remoteLoginRemindEmail = data.remoteLoginRemindEmail;

    //手机异地登录提醒
    this.remoteLoginRemindSms = data.remoteLoginRemindSms;

    //登录二次验证开关标识
    this.secureLoginVerify = data.secureLoginVerify;

    //登录二次验证频率
    this.secureLoginVerifyFreq = data.secureLoginVerifyFreq;

    //安全登录验证方式|secure_login_verify_method|SMS(1,"短信")
    this.secureLoginVerifyMethod = data.secureLoginVerifyMethod;

    //账号绑定信息
    this.mobileBindInfo = new BindInfoResult(data.mobileBindInfo);
};




// 获取邮件结果
xmail.pms.SaveDraftResult = function(data) {
    if (!data) {
        return;
    }


    //
    this.mailIndexId = data.mailIndexId;
};




// 异地登录提醒开关参数
xmail.pms.SaveRemoteEnbleParam = function(data) {
    if (!data) {
        return;
    }


    //异地登录提醒开关标识
    this.remoteLoginRemind = data.remoteLoginRemind;

    //邮件异地登录提醒
    this.remoteLoginRemindEmail = data.remoteLoginRemindEmail;

    //手机异地登录提醒
    this.remoteLoginRemindSms = data.remoteLoginRemindSms;

    //登录二次验证开关标识
    this.secureLoginVerify = data.secureLoginVerify;

    //登录二次验证频率
    this.secureLoginVerifyFreq = data.secureLoginVerifyFreq;

    //安全登录验证方式|secure_login_verify_method|SMS(1,"短信")
    this.secureLoginVerifyMethod = data.secureLoginVerifyMethod;
};




// 搜索联系人参数
xmail.pms.SearchUserContactInfoParam = function(data) {
    if (!data) {
        return;
    }


    //搜索词
    this.keyWords = data.keyWords;
};




// 绑定手机参数
xmail.pms.SendCodeParam = function(data) {
    if (!data) {
        return;
    }


    //手机
    this.mobile = data.mobile;

    //验证码类型BIND_CODE(8, "绑定手机验证码"),UNBIND_CODE(27,"解绑手机验证码"),SAFE_LOGIN(9,"安全登录验证码")
    this.templateType = data.templateType;
};




// 发信开启标识参数
xmail.pms.SendMailEnbleParam = function(data) {
    if (!data) {
        return;
    }


    //发信开启标识
    this.mailEnble = data.mailEnble;

    //保存客户端发信权限
    this.saveClientLetter = data.saveClientLetter;
};




// 发送邮件请求参数
xmail.pms.SendMailParam = function(data) {
    if (!data) {
        return;
    }


    //发件人
    this.from = data.from;

    //收件人
    this.to = data.to;

    //抄送人
    this.cc = data.cc;

    //密送人
    this.bcc = data.bcc;

    //邮件主题
    this.subject = data.subject;

    //邮件正文
    this.text = data.text;

    //内容类型
    this.contentType = data.contentType;

    //保存到已发送
    this.saveSend = data.saveSend;

    //发送邮件类型
    this.sendMailType = data.sendMailType;

    //邮件ID
    this.mailIndexId = data.mailIndexId;

    //回复前一封邮件ID
    this.replyPreviousMailIndexId = data.replyPreviousMailIndexId;

    //回复前一封邮件信息
    this.replyPreviousMailStatus = new SendMailStatusParams(data.replyPreviousMailStatus);

    //转发前一封邮件信息(支持多个)
    this.forwardPreviousMailStatus = [];
    if (data.forwardPreviousMailStatus) {
        for (let i = 0; i < data.forwardPreviousMailStatus.length; i++) {
            this.forwardPreviousMailStatus.push(new xmail.pms.SendMailStatusParams(data.forwardPreviousMailStatus[i]));
        }
    }

    //邮件操作类型
    this.mailOperatorType = data.mailOperatorType;

    //是否需要回执
    this.needReceipt = data.needReceipt;

    //优先级
    this.priority = data.priority;

    //群发单显
    this.sendAlone = data.sendAlone;

    //当前邮件定时发送标识（提交时用户无法改变）
    this.mtaFlag = data.mtaFlag;

    //定时发送时间（提交时不为空即是定时发信）
    this.mtaTime = data.mtaTime;

    //加密邮件标识
    this.encryptMail = data.encryptMail;

    //加密密码
    this.mailPasswd = data.mailPasswd;

    //原信MessageId
    this.messageId = data.messageId;

    //参照的原信
    this.references = data.references;

    //内嵌图片
    this.innerFileInfos = [];
    if (data.innerFileInfos) {
        for (let i = 0; i < data.innerFileInfos.length; i++) {
            this.innerFileInfos.push(new xmail.pms.InnerFileInfo(data.innerFileInfos[i]));
        }
    }

    //附件信息
    this.attachInfos = [];
    if (data.attachInfos) {
        for (let i = 0; i < data.attachInfos.length; i++) {
            this.attachInfos.push(new xmail.pms.AttachInfo(data.attachInfos[i]));
        }
    }
};




// 更新状态参数
xmail.pms.SendMailStatusParams = function(data) {
    if (!data) {
        return;
    }


    //邮件索引ID
    this.mailIndexId = data.mailIndexId;

    //邮件状态
    this.mailStatus = new MailStatusParams(data.mailStatus);
};




//
xmail.pms.SerializedLambda = function(data) {
    if (!data) {
        return;
    }

};




// 设置邮件状态参数
xmail.pms.SetMailStatusByConditionParam = function(data) {
    if (!data) {
        return;
    }


    //邮件状态
    this.targetMailStatus = data.targetMailStatus;

    //
    this.folderId = data.folderId;

    //索引过滤器参数
    this.mailIndexFilterParam = new MailIndexFilterParam(data.mailIndexFilterParam);

    //索引查询参数
    this.mailIndexQueryParam = new MailIndexQueryParam(data.mailIndexQueryParam);
};




// 设置邮件状态参数
xmail.pms.SetMailStatusParam = function(data) {
    if (!data) {
        return;
    }


    //邮件索引
    this.mailIndexIds = data.mailIndexIds;

    //邮件状态
    this.targetMailStatus = data.targetMailStatus;
};




//
xmail.pms.SettingLimit = function(data) {
    if (!data) {
        return;
    }


    //自定义姓名
    this.customName = data.customName;
};




// 个性签名id参数
xmail.pms.SignIdParam = function(data) {
    if (!data) {
        return;
    }


    //签名id
    this.signId = data.signId;
};




//
xmail.pms.SignLimit = function(data) {
    if (!data) {
        return;
    }


    //签名名字
    this.name = data.name;
};




// 个性签名参数
xmail.pms.SignParam = function(data) {
    if (!data) {
        return;
    }


    //签名名字
    this.name = data.name;

    //签名内容
    this.content = data.content;

    //是否是邮箱默认签名
    this.mailAccountDef = data.mailAccountDef;
};




// 个性签名返回结果
xmail.pms.SignResult = function(data) {
    if (!data) {
        return;
    }


    //签名id
    this.signId = data.signId;

    //签名名字
    this.name = data.name;

    //签名内容（base64加密后）
    this.content = data.content;

    //是否是邮箱默认签名:0否 1是
    this.mailAccountDef = data.mailAccountDef;
};




// 单点登录解绑用户请求参数
xmail.pms.SsoUnBindParam = function(data) {
    if (!data) {
        return;
    }


    //企业id
    this.corpId = data.corpId;

    //账户id
    this.suiteId = data.suiteId;

    //时间戳
    this.timestamp = data.timestamp;

    //用户id
    this.userId = data.userId;

    //签名
    this.sign = data.sign;
};




// 单点解绑用户返回结果
xmail.pms.SsoUnbindResult = function(data) {
    if (!data) {
        return;
    }


    //返回结果码
    this.errCode = data.errCode;

    //返回结果描述
    this.errMsg = data.errMsg;
};




//
xmail.pms.String = function(data) {
    if (!data) {
        return;
    }


    //
    this.hash = data.hash;
};




// 超级管理员登录返回结果
xmail.pms.SysLoginResult = function(data) {
    if (!data) {
        return;
    }


    //后续操作QueryString（Get方式）要含有此sid
    this.sid = data.sid;

    //登录的邮箱帐号
    this.managerAccount = data.managerAccount;

    //登录的应用
    this.loginAppType = data.loginAppType;
};




// 超管登录登录参数
xmail.pms.SysMangerLoginParam = function(data) {
    if (!data) {
        return;
    }


    //管理员账户
    this.managerAccount = data.managerAccount;

    //登录密码
    this.password = data.password;

    //是否安全登录（ssl）
    this.safeLogin = data.safeLogin;
};




//
xmail.pms.SysSsoCorpLoginParam = function(data) {
    if (!data) {
        return;
    }


    //
    this.corpId = data.corpId;
};




//
xmail.pms.SystemMaximum = function(data) {
    if (!data) {
        return;
    }


    //收件人最大数量
    this.addressMaxTotal = data.addressMaxTotal;

    //文件夹层级最大数量
    this.folderLevelMax = data.folderLevelMax;

    //通讯录地址最大数量
    this.contactMax = data.contactMax;

    //部门层级最大数量
    this.deptLevelMax = data.deptLevelMax;

    //组织、外部联系人、层级最大数量
    this.orgLevelMax = data.orgLevelMax;

    //个性签名最大数量
    this.signMax = data.signMax;

    //客户端授权码最大数量
    this.clientCodeMax = data.clientCodeMax;

    //分类过滤规则最大数量
    this.filterRuleMax = data.filterRuleMax;

    //自动转发地址最大数量
    this.forwardAddrMax = data.forwardAddrMax;

    //代收邮箱账号最大数量
    this.popEmailMax = data.popEmailMax;

    //黑名单最大数量
    this.blackListMax = data.blackListMax;

    //默认抄送密送地址最大数量
    this.ccEmailMax = data.ccEmailMax;

    //分类过滤发件人,收件人最大数量
    this.filterMemberMax = data.filterMemberMax;

    //个人通讯录邮箱，电话，手机最大数量
    this.userContactMemberMax = data.userContactMemberMax;

    //导入联系人文件最大限制（kb）
    this.userContactFileMax = data.userContactFileMax;

    //邮件撤回时间限制
    this.undoTimeLimit = data.undoTimeLimit;
};




// 添加信任地参数
xmail.pms.TrustLocationParam = function(data) {
    if (!data) {
        return;
    }


    //信任地址添加类型|trust_location_add_type|AUTO(1, "自动"),INTELLECT(2, "智能"),MANUAL(3, "手动");
    this.addType = data.addType;

    //国家编码
    this.countryCode = data.countryCode;

    //省编码
    this.provinceCode = data.provinceCode;

    //市编码
    this.cityCode = data.cityCode;
};




//
xmail.pms.UndoSentMailInfoResult = function(data) {
    if (!data) {
        return;
    }


    //撤回标识
    this.result = data.result;

    //撤回邮箱
    this.emailName = data.emailName;

    //撤回提示代码
    this.code = data.code;
};




//
xmail.pms.UndoSentMailParam = function(data) {
    if (!data) {
        return;
    }


    //邮件ID
    this.mailIndexId = data.mailIndexId;
};




//
xmail.pms.UndoSentMailResult = function(data) {
    if (!data) {
        return;
    }


    //撤回结果
    this.undoSentMailInfo = [];
    if (data.undoSentMailInfo) {
        for (let i = 0; i < data.undoSentMailInfo.length; i++) {
            this.undoSentMailInfo.push(new xmail.pms.UndoSentMailInfoResult(data.undoSentMailInfo[i]));
        }
    }
};




// 修改通讯录组参数
xmail.pms.UpdateContactGroupParam = function(data) {
    if (!data) {
        return;
    }


    //通讯组ID
    this.userGroupId = data.userGroupId;

    //通讯组名称
    this.name = data.name;

    //联系人唯一Id集合
    this.userContactIds = data.userContactIds;
};




// 开启默认个性签名参数
xmail.pms.UpdateDefSignParam = function(data) {
    if (!data) {
        return;
    }


    //签名id
    this.signId = data.signId;

    //是否是邮箱默认签名
    this.mailAccountDef = data.mailAccountDef;
};




// 修改邮件分类规则参数
xmail.pms.UpdateMailFilterParam = function(data) {
    if (!data) {
        return;
    }


    //规则ID
    this.filterId = data.filterId;

    //规则状态|filter_info_status|ENABLE(1, "启用"),DISABLE(2, "禁用");
    this.status = data.status;

    //规则名称
    this.name = data.name;

    //发件人是否开启
    this.fromEnable = data.fromEnable;

    //发件人是否包含
    this.fromInclude = data.fromInclude;

    //发件人成员信息
    this.fromMember = data.fromMember;

    //主题是否启用
    this.subjectEnable = data.subjectEnable;

    //主题是否包含
    this.subjectInclude = data.subjectInclude;

    //
    this.subjectMatchAll = data.subjectMatchAll;

    //主题匹配内容
    this.subjectVal = data.subjectVal;

    //邮件大小是否启用
    this.mailSizeEnable = data.mailSizeEnable;

    //邮件大小最大值 单位：KB
    this.mailSizeMax = data.mailSizeMax;

    //邮件大小规则最小值 单位：KB
    this.mailSizeMin = data.mailSizeMin;

    //相应操作|filter_execute_opt_type|DELETE(1, "删除邮件"),FORWARD(2, "转发至"),DEL_FORWARD(3, "删除并转发至"),SAFETIP(4, "添加安全提示"),RUN(5,"执行以下操作");
    this.executeOptType = data.executeOptType;

    //移动到指定文件夹是否启用
    this.moveFolderEnable = data.moveFolderEnable;

    //移动规则-要移动到的文件夹ID
    this.moveFolderId = data.moveFolderId;

    //转发是否启用
    this.forwardEnable = data.forwardEnable;

    //转发地址
    this.forwardAddr = data.forwardAddr;

    //丢弃已自动转发的邮件是否启用
    this.forwardDiscardEnable = data.forwardDiscardEnable;

    //自动回复是否启用
    this.replyEnable = data.replyEnable;

    //自动回复内容
    this.replyContent = data.replyContent;

    //收件人或抄送人是否启用
    this.toEnable = data.toEnable;

    //收件人或抄送人是否包含
    this.toInclude = data.toInclude;

    //收件人信息
    this.toMember = data.toMember;
};




// 更新文件夹参数
xmail.pms.UpdateMailFolderParam = function(data) {
    if (!data) {
        return;
    }


    //
    this.folderId = data.folderId;

    //
    this.name = data.name;

    //
    this.parentFolderId = data.parentFolderId;

    //
    this.subscribed = data.subscribed;
};




// 修改密码参数
xmail.pms.UpdatePasswordParam = function(data) {
    if (!data) {
        return;
    }


    //新密码
    this.newPassword = data.newPassword;

    //旧密码
    this.oldPassword = data.oldPassword;
};




// 修改其他邮箱代收参数
xmail.pms.UpdatePopInfoParam = function(data) {
    if (!data) {
        return;
    }


    //原始pop邮箱
    this.oldPopEmail = data.oldPopEmail;

    //其他邮箱账号
    this.popEmail = data.popEmail;

    //其他邮箱密码，非对称加密
    this.popPasswd = data.popPasswd;

    //pop服务器
    this.popHost = data.popHost;

    //端口号
    this.popPort = data.popPort;

    //ssl连接是否开启|0关闭 1开启
    this.sslEnable = data.sslEnable;

    //存放至的文件夹id
    this.folderId = data.folderId;

    //原邮箱是否丢弃副本|0 丢弃 1不丢弃
    this.discardEnable = data.discardEnable;

    //是否启用该账号
    this.status = data.status;
};




// 个性签名参数
xmail.pms.UpdateSignParam = function(data) {
    if (!data) {
        return;
    }


    //签名id
    this.signId = data.signId;

    //签名名字
    this.name = data.name;

    //签名内容（base64加密后）
    this.content = data.content;

    //是否是邮箱默认签名
    this.mailAccountDef = data.mailAccountDef;
};




// 修改联系人参数
xmail.pms.UpdateUserContactInfoParam = function(data) {
    if (!data) {
        return;
    }


    //联系人ID
    this.userContactId = data.userContactId;

    //联系人所在组id
    this.groupIds = data.groupIds;

    //电子邮件
    this.email = data.email;

    //电话号码
    this.telephone = data.telephone;

    //传真号码
    this.fax = data.fax;

    //自定义|分隔示例:key1¶value1§key2¶value2
    this.custom = data.custom;

    //姓氏
    this.surname = data.surname;

    //名字
    this.givenName = data.givenName;

    //性别
    this.gender = data.gender;

    //生日
    this.birthday = data.birthday;

    //昵称
    this.nickname = data.nickname;

    //微信
    this.wechat = data.wechat;

    //msn
    this.msn = data.msn;

    //QQ
    this.qq = data.qq;

    //公司名称
    this.company = data.company;

    //部门名称
    this.departName = data.departName;

    //职位
    this.position = data.position;

    //公司-网址
    this.workWebsite = data.workWebsite;

    //公司-国家
    this.workCountry = data.workCountry;

    //公司-省
    this.workProvince = data.workProvince;

    //公司-市
    this.workCity = data.workCity;

    //公司-街道
    this.workStreet = data.workStreet;

    //公司-邮编
    this.workPostalCode = data.workPostalCode;

    //家庭-国家
    this.homeCountry = data.homeCountry;

    //家庭-省
    this.homeProvince = data.homeProvince;

    //家庭-市
    this.homeCity = data.homeCity;

    //家庭-街道
    this.homeStreet = data.homeStreet;

    //家庭-邮编
    this.homePostalCode = data.homePostalCode;

    //备注
    this.memo = data.memo;
};




// 上传通讯录导入文件返回结果
xmail.pms.UploadContactUserResult = function(data) {
    if (!data) {
        return;
    }


    //导入文件头部信息
    this.headerResults = [];
    if (data.headerResults) {
        for (let i = 0; i < data.headerResults.length; i++) {
            this.headerResults.push(new xmail.pms.HeaderResult(data.headerResults[i]));
        }
    }

    //文件名
    this.fileName = data.fileName;
};




// 上传文件开始参数
xmail.pms.UploadFileStartParam = function(data) {
    if (!data) {
        return;
    }


    //文件名称
    this.fileName = data.fileName;

    //上传文件大小（字节）
    this.size = data.size;

    //文件全量MD5
    this.md5 = data.md5;
};




// 上传文件开始结果
xmail.pms.UploadFileStartResult = function(data) {
    if (!data) {
        return;
    }


    //accToken
    this.accToken = data.accToken;

    //
    this.existed = data.existed;

    //
    this.fileId = data.fileId;
};




// 用户联系组
xmail.pms.UserContactGroupResult = function(data) {
    if (!data) {
        return;
    }


    //id
    this.id = data.id;

    //类型
    this.type = data.type;

    //名称
    this.name = data.name;

    //姓名拼音
    this.pinyin = data.pinyin;

    //邮件
    this.email = data.email;

    //用户联系人集合
    this.children = [];
    if (data.children) {
        for (let i = 0; i < data.children.length; i++) {
            this.children.push(new xmail.pms.UserContactGroupResult(data.children[i]));
        }
    }
};




// 联系人参数
xmail.pms.UserContactInfoParam = function(data) {
    if (!data) {
        return;
    }


    //联系人所在组id
    this.groupIds = data.groupIds;

    //电子邮件
    this.email = data.email;

    //电话号码
    this.telephone = data.telephone;

    //传真号码
    this.fax = data.fax;

    //自定义|分隔示例:key1¶value1§key2¶value2
    this.custom = data.custom;

    //姓氏
    this.surname = data.surname;

    //名字
    this.givenName = data.givenName;

    //性别
    this.gender = data.gender;

    //生日
    this.birthday = data.birthday;

    //昵称
    this.nickname = data.nickname;

    //微信
    this.wechat = data.wechat;

    //msn
    this.msn = data.msn;

    //QQ
    this.qq = data.qq;

    //公司名称
    this.company = data.company;

    //部门名称
    this.departName = data.departName;

    //职位
    this.position = data.position;

    //公司-网址
    this.workWebsite = data.workWebsite;

    //公司-国家
    this.workCountry = data.workCountry;

    //公司-省
    this.workProvince = data.workProvince;

    //公司-市
    this.workCity = data.workCity;

    //公司-街道
    this.workStreet = data.workStreet;

    //公司-邮编
    this.workPostalCode = data.workPostalCode;

    //家庭-国家
    this.homeCountry = data.homeCountry;

    //家庭-省
    this.homeProvince = data.homeProvince;

    //家庭-市
    this.homeCity = data.homeCity;

    //家庭-街道
    this.homeStreet = data.homeStreet;

    //家庭-邮编
    this.homePostalCode = data.homePostalCode;

    //备注
    this.memo = data.memo;
};




//
xmail.pms.UserContactLimit = function(data) {
    if (!data) {
        return;
    }


    //电子邮件
    this.email = data.email;

    //电话号码
    this.telephone = data.telephone;

    //传真号码
    this.fax = data.fax;

    //名字
    this.givenName = data.givenName;

    //昵称
    this.nickname = data.nickname;

    //性别
    this.gender = data.gender;

    //公司-国家
    this.workCountry = data.workCountry;

    //公司-省
    this.workProvince = data.workProvince;

    //公司-街道
    this.workStreet = data.workStreet;

    //公司-市
    this.workCity = data.workCity;

    //公司-邮编
    this.workPostalCode = data.workPostalCode;

    //家庭-国家
    this.homeCountry = data.homeCountry;

    //家庭-省
    this.homeProvince = data.homeProvince;

    //家庭-市
    this.homeCity = data.homeCity;

    //家庭-街道
    this.homeStreet = data.homeStreet;

    //家庭-邮编
    this.homePostalCode = data.homePostalCode;

    //生日
    this.birthday = data.birthday;

    //QQ
    this.qq = data.qq;

    //微信
    this.wechat = data.wechat;

    //msn
    this.msn = data.msn;

    //公司名称
    this.company = data.company;

    //部门名称
    this.departName = data.departName;

    //职位
    this.position = data.position;

    //备注
    this.memo = data.memo;

    //组名称
    this.groupName = data.groupName;
};




// 用户联系人所属组
xmail.pms.UserGroupResult = function(data) {
    if (!data) {
        return;
    }


    //组Id
    this.groupId = data.groupId;

    //组名字
    this.groupName = data.groupName;
};




//
xmail.pms.UserInfoLimit = function(data) {
    if (!data) {
        return;
    }


    //手机
    this.mobile = data.mobile;

    //座机
    this.tel = data.tel;

    //传真
    this.fax = data.fax;
};




// 账户信息参数
xmail.pms.UserInfoParam = function(data) {
    if (!data) {
        return;
    }


    //座机
    this.tel = data.tel;

    //手机
    this.mobile = data.mobile;

    //传真
    this.fax = data.fax;

    //备注
    this.memo = data.memo;
};




// 账户信息返回结果
xmail.pms.UserInfoResult = function(data) {
    if (!data) {
        return;
    }


    //名字
    this.name = data.name;

    //座机
    this.tel = data.tel;

    //手机
    this.mobile = data.mobile;

    //传真
    this.fax = data.fax;

    //员工编号
    this.employeeId = data.employeeId;

    //备注
    this.memo = data.memo;
};




// 用户登录返回结果
xmail.pms.UserLoginResult = function(data) {
    if (!data) {
        return;
    }


    //后续操作QueryString（Get方式）要含有此sid
    this.sid = data.sid;

    //登录的用户名称
    this.userName = data.userName;

    //登录的邮箱帐号
    this.userEmail = data.userEmail;

    //主名登录的邮箱帐号
    this.primeUserEmail = data.primeUserEmail;

    //登录的应用
    this.loginAppType = data.loginAppType;

    //登录时使用的凭证方式
    this.loginTokenType = data.loginTokenType;

    //退出的登录地址
    this.logoutAddress = data.logoutAddress;

    //企业密码规则
    this.corpRulePasswd = new PwdWeakRule(data.corpRulePasswd);

    //wm语言|language|CN(1, "中文简体"),HK(2, "中文繁体"),EN(3, "英文"),JP(4, "日语"),KR(5, "韩语");
    this.webLanguage = data.webLanguage;

    //需要修改密码(首次)
    this.modifyPwdFirst = data.modifyPwdFirst;

    //需要修改密码(定期)
    this.modifyPwdCycle = data.modifyPwdCycle;

    //需要修改密码(弱密码)
    this.modifyPwdWeak = data.modifyPwdWeak;

    //绑定信息
    this.bindInfo = new BindInfoResult(data.bindInfo);
};




// 用户密码登录参数
xmail.pms.UserPwdLoginParam = function(data) {
    if (!data) {
        return;
    }


    //邮箱地址
    this.userEmail = data.userEmail;

    //登录密码
    this.password = data.password;

    //登录应用类型
    this.loginAppType = data.loginAppType;

    //是否安全登录（ssl）
    this.safeLogin = data.safeLogin;

    //登录ip,测试异地登录使用
    this.loginIp = data.loginIp;
};




// 用户单点登录参数
xmail.pms.UserSsoLoginParam = function(data) {
    if (!data) {
        return;
    }


    //Token
    this.token = data.token;
};




// 绑定类型
xmail.enums.AccountBindType = {
    UNKNOWN: 0,         //UNKNOWN
    SSO: 1,         //SSO单点登录
    OPEN_APP: 2,         //开放平台
    PHONE: 3,         //手机
};

// 账户到期执行动作
xmail.enums.AccountExpireOperateType = {
    UNKNOWN: 0,         //UNKNOWN
    DISABLE: 1,         //禁用
    DELETE: 2,         //删除
};

// 规则状态
xmail.enums.AccountFilterRuleStatus = {
    UNKNOWN: 0,         //UNKNOWN
    ENABLE: 1,         //启用
    DISABLE: 2,         //禁用
};

// 登录方式IMAP收信
xmail.enums.AccountLoginImapRecv = {
    UNKNOWN: 0,         //UNKNOWN
    ENABLE: 1,         //允许
    DISABLE: 2,         //禁止
    SSL: 3,         //只允许SSL
};

// 登录方式POP收信
xmail.enums.AccountLoginPopRecv = {
    UNKNOWN: 0,         //UNKNOWN
    ENABLE: 1,         //允许
    DISABLE: 2,         //禁止
    SSL: 3,         //只允许SSL
};

// 登录方式SMTP发信
xmail.enums.AccountLoginSmtpSend = {
    UNKNOWN: 0,         //UNKNOWN
    ENABLE: 1,         //允许
    DISABLE: 2,         //禁止
    SSL: 3,         //只允许SSL
};

// 登录方式WEB手机限制
xmail.enums.AccountLoginWebMobile = {
    UNKNOWN: 0,         //UNKNOWN
    ENABLE: 1,         //允许
    DISABLE: 2,         //禁止
    SSL: 3,         //只允许SSL
};

// 登录方式WEBPC限制
xmail.enums.AccountLoginWebPc = {
    UNKNOWN: 0,         //UNKNOWN
    ENABLE: 1,         //允许
    DISABLE: 2,         //禁止
    SSL: 3,         //只允许SSL
};

// 用户状态
xmail.enums.AccountStatus = {
    UNKNOWN: 0,         //UNKNOWN
    ENABLE: 1,         //启用
    DISABLE: 2,         //禁用
};

// 用户类型
xmail.enums.AccountUserType = {
    UNKNOWN: 0,         //UNKNOWN
    USER: 1,         //用户
    ALIAS: 2,         //别名
    LIST: 3,         //列表
};

// 匹配地址类型
xmail.enums.AddrMatchType = {
    UNKNOWN: 0,         //UNKNOWN
    XSENDER: 1,         //按照XSENDER匹配
    FROM: 2,         //按照FROM匹配
    XSENDER_OR_FROM: 3,         //按照FROM或者XSENDER匹配
};

// 地址类型
xmail.enums.AddrType = {
    UNKNOWN: 0,         //UNKNOWN
    BLACK: 1,         //黑名单
    WHITE: 2,         //白名单
};

// 收件人类型
xmail.enums.AddresseeEnum = {
    CORP: 1,         //所有部门人员
    DEPART: 3,         //按部门选择
};

//
xmail.enums.ApiPrivilege = {
    ORG: 1,         //组织通讯录
    SSO: 2,         //单点
    DISK: 3,         //网盘
    UMT: 4,         //搬家
};

// API接口状态
xmail.enums.ApiStatus = {
    UNKNOWN: 0,         //UNKNOWN
    ENABLE: 1,         //启用
    DISABLE: 2,         //禁用
};

// API接口类型
xmail.enums.ApiType = {
    UNKNOWN: 0,         //UNKNOWN
    CORP: 1,         //企业
    SUPER: 2,         //超级
};

//
xmail.enums.AppType = {
    MAIL: 1,         //邮件
    DRAFT: 2,         //草稿
    SIGN: 3,         //签名
    TEMP: 4,         //临时
    LOGO: 5,         //企业logo
    LARGE_FILE: 6,         //大文件
};

//
xmail.enums.AttachDownType = {
    SINGLE: 1,         //单个下载
    MULTI: 2,         //多个下载
};

// 执行条件
xmail.enums.AuditCondType = {
    UNKNOWN: 0,         //UNKNOWN
    ALL: 1,         //满足所有
    ANY: 2,         //满足任一
};

// 多人审核裁决结果
xmail.enums.AuditInfoAuditType = {
    UNKNOWN: 0,         //UNKNOWN
    FIRST: 1,         //最先裁决为结果
    ALL: 2,         //所有人通过结果
};

// 审核结果通知类型
xmail.enums.AuditInfoResultNoticeType = {
    UNKNOWN: 0,         //UNKNOWN
    AGREE: 1,         //同意
    REJECT: 2,         //拒绝
    ALL: 3,         //全部
};

// 规则状态
xmail.enums.AuditInfoStatus = {
    UNKNOWN: 0,         //UNKNOWN
    ENABLE: 1,         //启用
    DISABLE: 2,         //禁用
};

// 多人审核裁决结果
xmail.enums.AuditLogAuditType = {
    UNKNOWN: 0,         //UNKNOWN
    FIRST: 1,         //最先裁决为结果
    ALL: 2,         //所有人通过结果
};

// 审核结果通知类型
xmail.enums.AuditLogResultNoticeType = {
    UNKNOWN: 0,         //UNKNOWN
    AGREE: 1,         //同意
    REJECT: 2,         //拒绝
    ALL: 3,         //全部
};

// 审核状态
xmail.enums.AuditLogStatus = {
    UNKNOWN: 0,         //UNKNOWN
    AGREE: 1,         //同意
    DISABLE: 2,         //拒绝
    AUDITING: 3,         //审核中
    FAIL: 4,         //失败
    SCHEDULE: 5,         //定时任务
};

// 执行范围
xmail.enums.AuditScopeType = {
    UNKNOWN: 0,         //UNKNOWN
    SEND: 1,         //发信阶段
    RECIVE: 2,         //收信阶段
    SENDRECIVE: 3,         //收信和发信阶段
};

// 审核邮件类型
xmail.enums.AuditSendRetryAuditMailType = {
    UNKNOWN: 0,         //UNKNOWN
    RECV: 1,         //收信审核
    SEND: 2,         //发信审核
};

// 多人审核裁决结果
xmail.enums.AuditSendRetryScopeType = {
    UNKNOWN: 0,         //UNKNOWN
    FIRST: 1,         //最先裁决为结果
    ALL: 2,         //所有人通过结果
};

// 审核状态
xmail.enums.AuditorLogStatus = {
    UNKNOWN: 0,         //UNKNOWN
    AGREE: 1,         //同意
    DISABLE: 2,         //拒绝
    AUDITING: 3,         //审核中
    FAIL: 4,         //失败
};

// 邮箱账号信息表（backup_mail_account_info）- 字段编号枚举
xmail.enums.BackupMailAccountInfoField = {
    ID: 3719,         //
    USER_ID: 37163,         //用户ID
    MAIL_ACCOUNT_ID: 91885,         //邮件账号ID
    PRIME_ACCOUNT_ID: 3639,         //主名的MailAccountId
    CORP_ID: 16757,         //企业id
    DOMAIN_ID: 69476,         //域id
    ACCOUNT: 96511,         //账号(邮箱前缀)
    DOMAIN_NAME: 3260,         //域名
    USER_EMAIL: 11187,         //邮箱地址
    NAME: 9776,         //名字
    USER_TYPE: 27785,         //用户类型|account_user_type|USER(1,  用户 ),ALIAS(2,  别名 ),LIST(3,  列表 );
    PASSWD: 71955,         //密码
    PASSWD_TYPE: 82007,         //密码加密类型|passwd_type|SM4(1, 国4加密 ),BCRYPT(2,  bcrypt加密 ),NO_CRYPT(3, 不加密 ),SM3(4, 国3加密 ),MD5(5, MD5加密 ),MD5_SALT(6, MD5加盐 );
    SPEC_ID: 30330,         //规格id
    STATUS: 91903,         //用户状态|account_status|ENABLE(1,  启用 ),DISABLE(2,  禁用 );
    ABILITY_FLAG: 23109,         //邮箱功能标记:mail_account_ability_flag:1,client_sent,客户端保存已发信 | 2,client_code_enable,客户授权码
    LOGIN_WEB_PC: 35169,         //登录方式WEBPC限制|account_login_web_pc|ENABLE(1,  允许 ),DISABLE(2,  禁止 ),SSL(3,  只允许SSL );
    LOGIN_WEB_MOBILE: 53183,         //登录方式WEB手机限制|account_login_web_mobile|ENABLE(1,  允许 ),DISABLE(2,  禁止 ),SSL(3,  只允许SSL );
    LOGIN_SMTP_SEND: 99583,         //登录方式SMTP发信|account_login_smtp_send|ENABLE(1,  允许 ),DISABLE(2,  禁止 ),SSL(3,  只允许SSL );
    LOGIN_POP_RECV: 99691,         //登录方式POP收信|account_login_pop_recv|ENABLE(1,  允许 ),DISABLE(2,  禁止 ),SSL(3,  只允许SSL );
    LOGIN_IMAP_RECV: 77720,         //登录方式IMAP收信|account_login_imap_recv|ENABLE(1,  允许 ),DISABLE(2,  禁止 ),SSL(3,  只允许SSL );
    LOGIN_IP_CONTENT: 38315,         //登录限制ip或ip段
    IMAP_LANGUAGE: 50560,         //语言|language|CN(1,  中文简体 ),HK(2,  中文繁体 ),EN(3,  英文 ),JP(4,  日语 ),KR(5,  韩语 );
    ORG_VISIBLE: 50177,         //是否在通讯录显示
    FIRST_MODIFY_PWD_ENABLE: 2360,         //是否首次登录修改密码
    OVER_SPACE: 95523,         //是否超容
    WORKBENCH_FLAG: 578,         //应用功能:mail_account_workbench_flag:1,FLAGA,需要修改DB注释以便生成（位数从1开始） | 2,FLAGB,第二位表示样例
    VIEW_ID: 66043,         //视图id
    RULE_LOGIN_ID: 55537,         //登录限制规则
    RULE_DELIVER_ID: 93979,         //邮件收发规则
    RULE_PRIVI_ID: 93283,         //用户权限规则id
    LIST_MEMBER_SELECTOR_ID: 2970,         //列表成员id
    LIST_PRIVI_FLAG: 677,         //列表权限: 1,all_user,所有用户都可以给此列表发信 | 2,custom_user,只有指定范围内的用户才能给此列表发信 | 3,user_of_list,只有列表内的用户才能给此列表发信
    PRIVI_MEMBER_SELECTOR_ID: 59755,         //列表权限成员id
    EXPIRE_TIME: 28313,         //账号到期时间
    EXPIRE_OPERATE_TYPE: 83410,         //账户到期执行动作|account_expire_operate_type|DISABLE(1,  禁用 ),DELETE(2,  删除 );
    CREATE_TIME: 82559,         //创建时间
    UPDATE_TIME: 77635,         //更新时间
    OPT_USER_ID: 11620,         //
    OPT_USER_EMAIL: 71958,         //
    OPT_USER_NAME: 59166,         //
    OPT_TIME: 47943,         //操作时间
    OPT_IP: 2672,         //
    OPT_VISIBLE: 65565,         //
    CLIENT_TYPE: 74401,         //客户端类型|client_type|MA(1,  ma ),WM_PC(2,  WEB_PC ),WM_MOBILE(12,  WEB_MOBILE ),SYS_MANAGER_PC(13, super_ma ),POP(3,  pop ),IMAP(4,  imap ),SMTP(5,  smtp ),EAS(6,  eas ),UMT(7,  umt ),API(8,  接口 ),UBD(10,  ubd ),UDUTIL(11,  ud工具 ),SCHEDULE(14, 定时任务 ),CALWEB(15, 日程 ),SSO_PC(16, SSO_PC ),SSO_MOBILE(17, SSO_MOBILE );
};

// 邮箱使用情况表（backup_mail_used_info）- 字段编号枚举
xmail.enums.BackupMailUsedInfoField = {
    ID: 3719,         //
    CORP_ID: 16757,         //企业id
    MAIL_ACCOUNT_ID: 91885,         //邮箱id
    USER_EMAIL: 11187,         //邮箱地址
    USER_NAME: 94299,         //邮箱名字
    CREATE_TIME: 82559,         //创建时间
    UPDATE_TIME: 77635,         //更新时间
    FOLDER_ID_MAX: 72375,         //当前邮箱文件夹ID最大值（新建文件夹同步加1；用于支持IMAP协议）
    CUSTOM_FOLDER_COUNT: 37116,         //当前邮箱账号存在自定义文件夹的数量
    MAX_SPACE: 27429,         //最大空间
    USED_SPACE: 18116,         //已使用空间
    MAX_NUM: 26206,         //最大邮件数量
    USED_NUM: 92503,         //已使用数量
    UNSEEN_COUNT: 58780,         //未读邮件总数
    STARRED_COUNT: 17985,         //星标邮件总数
    WAITED_COUNT: 74869,         //代办邮件总数
    LAST_MAIL_INDEX_ID: 62982,         //收信箱最新存入的邮件索引ID
};

// 用户信息表（backup_user_info）- 字段编号枚举
xmail.enums.BackupUserInfoField = {
    ID: 3719,         //
    USER_ID: 37163,         //用户id
    CORP_ID: 16757,         //企业id
    NAME: 9776,         //名字
    CREATE_TIME: 82559,         //创建时间
    UPDATE_TIME: 77635,         //更新时间
    GENDER: 61230,         //性别|gender|MALE(1,  男性 ),FEMALE(2,  女性 );
    BIRTHDAY: 55906,         //生日
    POSITION: 14793,         //职位
    TEL: 43700,         //座机
    MOBILE: 86202,         //手机
    FAX: 72446,         //传真
    EMPLOYEE_ID: 24630,         //员工编号
    MEMO: 67825,         //备注
    HIREDATE: 56824,         //入职时间
    WEB_LANGUAGE: 19979,         //语言|language|CN(1,  中文简体 ),HK(2,  中文繁体 ),EN(3,  英文 ),JP(4,  日语 ),KR(5,  韩语 );
};

// 账户日历关系表表（cal_account_calendar）- 字段编号枚举
xmail.enums.CalAccountCalendarField = {
    ID: 3719,         //
    ACCOUNT_ID: 67223,         //帐号ID（目前先填主帐号邮件地址）
    CORP_ID: 16757,         //帐号所属组织机构ID(企事业单位)
    CALENDAR_ID: 31023,         //日历ID
    CREATOR_ACCOUNT_ID: 54121,         //此关系的创建者ID
    STATUS: 91903,         //状态|cal_account_calendar_status|NORMAL(1,  正常 ), DISABLE(2,  禁用 ), INVALID(3,  无效 ), DELETED(4,  已删除 ), LOCKED(5,  已锁定 )
    NOTIFY_STATUS: 36205,         //通知状态|cal_notify_type|INIT(1,  初始 ), ACCEPTED(2,  接受 ), DECLINED(3,  拒绝 ), COMPLETED(4,  已完成 )
    UPDATE_TIME: 77635,         //更新时间
    CREATE_TIME: 82559,         //创建时间
    ACCOUNT_EMAIL: 16081,         //账号邮箱地址
    ACCOUNT_NAME: 2368,         //账号姓名
    MAJOR: 25886,         //是否主日历
    PERMISSION: 23995,         //状态|cal_permission|FREE_BUSY(1,  忙闲 ), READ_ONLY(2,  只读 ), READ_WRITE(3,  读写 ), MANAGER(4,  管理 ), OWNER(5,  拥有 )
    SUBSCRIPTION: 3633,         //是否订阅
    VISIBLED: 64832,         //是否在日历列表中显示
    DISPLAY: 57448,         //是否在日程控件UI中显示对应的组件
    NOTIFY_AUTH_ID: 82665,         //通知邮件中用户交互连接认证ID
    SORT_VAL: 1981,         //排序
    COLOR: 37119,         //颜色
    DISPLAYNAME: 27256,         //名称
    DISCRIPTION: 23173,         //日历描述
};

// 状态
xmail.enums.CalAccountCalendarStatus = {
    UNKNOWN: 0,         //UNKNOWN
    NORMAL: 1,         //正常
    DISABLE: 2,         //禁用
    INVALID: 3,         //无效
    DELETED: 4,         //已删除
    LOCKED: 5,         //已锁定
};

// 账户信息表表（cal_account_info）- 字段编号枚举
xmail.enums.CalAccountInfoField = {
    ID: 3719,         //
    ACCOUNT_ID: 67223,         //帐号ID（目前先填主帐号邮件地址）
    CORP_ID: 16757,         //组织机构ID(企事业单位)
    ACCOUNT_TYPE: 8106,         //状态|cal_account_type|MAIL_ACCOUNT(1,  邮箱帐号 ), USER(2,  用户 ), DEPART(3,  部门 ), GROUP(4,  组 ), ROOM(5,  会议室 ), RESOURCE(6,  设备 )
    CALENDAR_ID: 31023,         //主日历ID
    STATUS: 91903,         //状态|cal_account_info_status|NORMAL(1,  正常 ), DISABLE(2,  禁用 ), INVALID(3,  无效 ), DELETED(4,  已删除 ), LOCKED(5,  已锁定 )
    UPDATE_TIME: 77635,         //更新时间
    CREATE_TIME: 82559,         //创建时间
    TIMEZONE_ID: 65590,         //时区ID //TODO discard
    LANGUAGE: 85691,         //语言|cal_language|CN(1,  中文 ), HK(2,  繁体 ), EN(3,  英文 )
    TIMEZONE_OFFSET: 14032,         //时区时差（-12～12 单位小时）
    TIMEZONE_DST: 96848,         //夏令时（0代表没有夏令时； 单位小时）
    VIEW_TYPE: 89986,         //用户当前选择的日程展现视图|cal_view_type|LIST(1,  列表 ), DAY(2,  日 ), WEEK(3,  周 ), MONTH(4,  月 ), YEAR(5,  年 )
    BLOCK_SHARED_NOTIFY: 38990,         //日历共享通知免打扰
    BLOCK_ADD_INVITE_NOTIFY: 92961,         //新的邀请通知免打扰
    BLOCK_MODIFY_COMPONENT_NOTIFY: 47493,         //事件更改通知免打扰
    BLOCK_CANCEL_COMPONENT_NOTIFY: 83544,         //事件取消通知免打扰
};

// 状态
xmail.enums.CalAccountInfoStatus = {
    UNKNOWN: 0,         //UNKNOWN
    NORMAL: 1,         //正常
    DISABLE: 2,         //禁用
    INVALID: 3,         //无效
    DELETED: 4,         //已删除
    LOCKED: 5,         //已锁定
};

// 状态
xmail.enums.CalAccountType = {
    UNKNOWN: 0,         //UNKNOWN
    MAIL_ACCOUNT: 1,         //邮箱帐号
    USER: 2,         //用户
    DEPART: 3,         //部门
    GROUP: 4,         //组
    ROOM: 5,         //会议室
    RESOURCE: 6,         //设备
};

// 提醒方式
xmail.enums.CalAlarmType = {
    UNKNOWN: 0,         //UNKNOWN
    NONE: 1,         //不提醒
    AUDIO: 2,         //客户端（声音）
    DISPLAY: 3,         //客户端（弹窗）
    EMAIL: 4,         //邮件
    SMS: 5,         //短信
    IM: 6,         //即时通讯
};

// 日历提醒设置表表（cal_calendar_alarm）- 字段编号枚举
xmail.enums.CalCalendarAlarmField = {
    ID: 3719,         //
    ALARM_ID: 5839,         //日历提醒ID
    CALENDAR_ID: 31023,         //日历ID
    ACCOUNT_ID: 67223,         //提醒设置者帐号ID
    CORP_ID: 16757,         //提醒设置者所属组织机构ID(企事业单位)
    STATUS: 91903,         //状态|cal_calendar_alarm_status|NORMAL(1,  正常 ), DISABLE(2,  禁用 ), INVALID(3,  无效 ), DELETED(4,  已删除 ), LOCKED(5,  已锁定 )
    UPDATE_TIME: 77635,         //更新时间
    CREATE_TIME: 82559,         //创建时间
    ALARM_TYPE: 65976,         //提醒方式|cal_alarm_type|NONE(1,  不提醒 ), AUDIO(2,  客户端（声音） ), DISPLAY(3,  客户端（弹窗） ), EMAIL(4,  邮件 ), SMS(5,  短信 ), IM(6,  即时通讯 )
    TRIGGER_SEC: 72178,         //提前多少秒提醒
    REPEAT_COUNT: 85591,         //重复提醒次数
    REPEAT_INTERVAL_SEC: 29457,         //重复提醒间隔时间
};

// 状态
xmail.enums.CalCalendarAlarmStatus = {
    UNKNOWN: 0,         //UNKNOWN
    NORMAL: 1,         //正常
    DISABLE: 2,         //禁用
    INVALID: 3,         //无效
    DELETED: 4,         //已删除
    LOCKED: 5,         //已锁定
};

// 日历信息表表（cal_calendar_info）- 字段编号枚举
xmail.enums.CalCalendarInfoField = {
    ID: 3719,         //
    CALENDAR_ID: 31023,         //日历ID
    ACCOUNT_ID: 67223,         //拥有者帐号ID
    CORP_ID: 16757,         //拥有者所属组织机构ID(企事业单位)
    CREATOR_ACCOUNT_ID: 54121,         //创建者ID
    STATUS: 91903,         //状态|cal_calendar_info_status|NORMAL(1,  正常 ), DISABLE(2,  禁用 ), INVALID(3,  无效 ), DELETED(4,  已删除 ), LOCKED(5,  已锁定 )
    UPDATE_TIME: 77635,         //更新时间
    CREATE_TIME: 82559,         //创建时间
    ACCOUNT_EMAIL: 16081,         //拥有者邮箱
    ACCOUNT_NAME: 2368,         //拥有者姓名
    MAJOR: 25886,         //是否主日历
    COMPONENT_TYPE: 99866,         //包含组件类别|cal_component_type|VEVENT(1,  事件 ), VTODO(2,  代办 ), VAVAILABILITY(3,   ), VPOLL(4,   )
    DOMAIN_INTERNAL_VISIBLE: 13598,         //组织内可见选项|cal_visible_type|CORP_DEF(1,  企业默认 ), PRIVATELY(2,  私有 ), FREE_BUSY(3,  忙闲 ), READ(4,  只读 )
    DOMAIN_EXTERNAL_VISIBLE: 39236,         //组织外可见选项|cal_visible_type|CORP_DEF(1,  企业默认 ), PRIVATELY(2,  私有 ), FREE_BUSY(3,  忙闲 ), READ(4,  只读 )
    AUTO_ACCEPT: 48912,         //是否自动接收邀请
    DISCRIPTION: 23173,         //说明
};

// 状态
xmail.enums.CalCalendarInfoStatus = {
    UNKNOWN: 0,         //UNKNOWN
    NORMAL: 1,         //正常
    DISABLE: 2,         //禁用
    INVALID: 3,         //无效
    DELETED: 4,         //已删除
    LOCKED: 5,         //已锁定
};

// 访问级别
xmail.enums.CalClassification = {
    UNKNOWN: 0,         //UNKNOWN
    PRIVATE: 1,         //私有
    CONFIDENTIAL: 2,         //保密
    PUBLIC: 3,         //公开
};

// 组件提醒设置表表（cal_component_alarm）- 字段编号枚举
xmail.enums.CalComponentAlarmField = {
    ID: 3719,         //
    ALARM_ID: 5839,         //组件提醒设置ID
    COMPONENT_ID: 30046,         //组件ID
    CALENDAR_ID: 31023,         //组件所在日历ID
    ACCOUNT_CALENDAR_ID: 79766,         //用户设置提醒时，操作的日历ID
    ACCOUNT_ID: 67223,         //提醒设置者帐号ID
    CORP_ID: 16757,         //提醒设置者所属组织机构ID(企事业单位)
    STATUS: 91903,         //状态|cal_component_alarm_status|NORMAL(1,  正常 ), DISABLE(2,  禁用 ), INVALID(3,  无效 ), DELETED(4,  已删除 ), LOCKED(5,  已锁定 )
    UPDATE_TIME: 77635,         //更新时间
    CREATE_TIME: 82559,         //创建时间
    ALARM_TYPE: 65976,         //提醒方式|cal_alarm_type|NONE(1,  不提醒 ), AUDIO(2,  客户端（声音） ), DISPLAY(3,  客户端（弹窗） ), EMAIL(4,  邮件 ), SMS(5,  短信 ), IM(6,  即时通讯 )
    TRIGGER_SEC: 72178,         //提前多少秒提醒
    REPEAT_COUNT: 85591,         //重复提醒次数
    REPEAT_INTERVAL_SEC: 29457,         //重复提醒间隔时间
};

// 状态
xmail.enums.CalComponentAlarmStatus = {
    UNKNOWN: 0,         //UNKNOWN
    NORMAL: 1,         //正常
    DISABLE: 2,         //禁用
    INVALID: 3,         //无效
    DELETED: 4,         //已删除
    LOCKED: 5,         //已锁定
};

// 组件附件表表（cal_component_attach）- 字段编号枚举
xmail.enums.CalComponentAttachField = {
    ID: 3719,         //
    ATTACH_ID: 95337,         //组件附件ID
    COMPONENT_ID: 30046,         //组件ID
    CALENDAR_ID: 31023,         //组件所在日历ID
    ACCOUNT_ID: 67223,         //拥有者帐号ID
    CORP_ID: 16757,         //拥有者所属组织机构ID(企事业单位)
    STATUS: 91903,         //状态|cal_component_attach_status|NORMAL(1,  正常 ), DISABLE(2,  禁用 ), INVALID(3,  无效 ), DELETED(4,  已删除 ), LOCKED(5,  已锁定 )
    UPDATE_TIME: 77635,         //更新时间
    CREATE_TIME: 82559,         //创建时间
    CONTENT_TYPE: 35405,         //文件类别（content/type）
    SIZE: 80628,         //文件尺寸
    NAME: 9776,         //文件名称
    URL: 33124,         //文件连接
};

// 状态
xmail.enums.CalComponentAttachStatus = {
    UNKNOWN: 0,         //UNKNOWN
    NORMAL: 1,         //正常
    DISABLE: 2,         //禁用
    INVALID: 3,         //无效
    DELETED: 4,         //已删除
    LOCKED: 5,         //已锁定
};

// 组件参与者表表（cal_component_attendee）- 字段编号枚举
xmail.enums.CalComponentAttendeeField = {
    ID: 3719,         //
    COMPONENT_ID: 30046,         //组件ID
    CORP_ID: 16757,         //企业ID
    ATTENDEE_ACCOUNT_ID: 5841,         //参与者帐号ID
    CALENDAR_ID: 31023,         //组件所在日历ID
    ATTENDEE_MAJOR_CALENDAR_ID: 92078,         //参与者主日历ID
    ORGANIZER_ACCOUNT_ID: 60522,         //组织者帐号ID
    CREATOR_ACCOUNT_ID: 54121,         //此关系的创建者帐号ID
    STATUS: 91903,         //状态|cal_component_attendee_status|NORMAL(1,  正常 ), DISABLE(2,  禁用 ), INVALID(3,  无效 ), DELETED(4,  已删除 ), LOCKED(5,  已锁定 )
    UPDATE_TIME: 77635,         //更新时间
    ATTENDEE_ACCOUNT_EMAIL: 86864,         //参与人邮箱
    ORGANIZER_ACCOUNT_EMAIL: 95894,         //组织者邮箱
    ORGANIZER_ACCOUNT_NAME: 35796,         //组织者姓名
    ATTENDEE_ACCOUNT_NAME: 26169,         //参与者的姓名
    CREATE_TIME: 82559,         //创建时间
    ACCOUNT_TYPE: 8106,         //状态|cal_account_type|MAIL_ACCOUNT(1,  邮箱帐号 ), USER(2,  用户 ), DEPART(3,  部门 ), GROUP(4,  组 ), ROOM(5,  会议室 ), RESOURCE(6,  设备 )
    PARTICIPATION_STATUS: 9528,         //参与者参与状态|cal_participation_status|NEEDS_ACTION(1,  待定 ), ACCEPTED(2,  接受 ), DECLINED(3,  拒绝 ), TENTATIVE(4,  临时 ), DELEGATED(5,   ), COMPLETED(6,   ), IN_PROCESS(7,   )
    PARTICIPATION_ROLE: 55860,         //参与者角色|cal_participation_role|CHAIR(1,  主持 ), REQUIRED(2,  必须参加 ), OPTIONAL(3,  可参加 ), INFORMED(4,  知情 )
    EXPECT_REPLY: 87766,         //是否期待参与者确认参与状态
    NOTIFY_AUTH_ID: 82665,         //通知邮件中用户交互连接认证ID
    MEMO: 67825,         //简要描述
    NOTIFY_STATUS: 36205,         //通知状态|cal_notify_type|INIT(1,  初始 ), ACCEPTED(2,  接受 ), DECLINED(3,  拒绝 ), COMPLETED(4,  已完成 )
};

// 状态
xmail.enums.CalComponentAttendeeStatus = {
    UNKNOWN: 0,         //UNKNOWN
    NORMAL: 1,         //正常
    DISABLE: 2,         //禁用
    INVALID: 3,         //无效
    DELETED: 4,         //已删除
    LOCKED: 5,         //已锁定
};

// 日历组件信息表表（cal_component_info）- 字段编号枚举
xmail.enums.CalComponentInfoField = {
    ID: 3719,         //
    COMPONENT_ID: 30046,         //组件ID
    CALENDAR_ID: 31023,         //所在日历ID
    CREATOR_ACCOUNT_ID: 54121,         //此事件的创建者ID
    CORP_ID: 16757,         //企业ID
    STATUS: 91903,         //状态|cal_component_info_status|NORMAL(1,  正常 ), DISABLE(2,  禁用 ), INVALID(3,  无效 ), DELETED(4,  已删除 ), LOCKED(5,  已锁定 )
    UPDATE_TIME: 77635,         //更新时间
    ALARM_TASK_TIME: 1998,         //事件时间相关属性的最后修改时间
    CREATE_TIME: 82559,         //创建时间
    CREATOR_ACCOUNT_EMAIL: 98088,         //创建者邮箱
    CREATOR_ACCOUNT_NAME: 19898,         //创建者姓名
    COMPONENT_TYPE: 99866,         //组件类别|cal_component_type|VEVENT(1,  事件 ), VTODO(2,  代办 ), VAVAILABILITY(3,   ), VPOLL(4,   )
    FREE_BUSY: 48638,         //闲忙类别（空闲、忙碌）
    TIME_TRANSPARENCY: 78813,         //是否可被闲忙查询
    CLASSIFICATION: 53482,         //访问级别|cal_classification|PRIVATE(1,  私有 ), CONFIDENTIAL(2,  保密 ), PUBLIC(3,  公开 )
    PRIORITY: 48929,         //优先级
    START_TIME: 71462,         //整个事件的起始时间（用于report查询）
    END_TIME: 29797,         //整个事件的截至时间；循环无截至时间为9999-01-01（用于report查询）
    SUMMARY: 74775,         //组件标题
    LOCATION: 83785,         //地点
    DESCRIPTION: 43138,         //描述
    COMMENTS: 63006,         //评论
    LATITUDE: 55818,         //纬度
    LONGITUDE: 33098,         //经度
    PERCENT_COMPLETE: 50936,         //进度
    RESOURCES: 80390,         //资源
    STATE: 38559,         //状况（待定、已确认、进行中、已完成、已取消）
    COMPLETED: 53214,         //实际完成时间
    DUE: 67275,         //预期完成时间
    DURATION: 61270,         //持续时间（秒）
    DTSTART: 88679,         //开始时间
    DTEND: 72362,         //结束时间
    TIMEZONE_ID: 65590,         //时区ID
    FULL_DAY: 81351,         //是否全天
    REPEATED: 39618,         //是否循环
    REPEAT_TYPE: 40429,         //循环类型|cal_repeat_type|ONCE(1,  单次不循环 ), DAILY(2,  每天 ), WEEKLY(3,  每周 ), MONTHLY(4,  每月 ), YEARLY(5,  每年 )
    REPEAT_BYDAY: 28635,         //
    REPEAT_BYSETPOS: 76704,         //循环指定某个月份的第几周
    REPEAT_BYMONTH: 70343,         //循环指定某几个月份
    REPEAT_BYMONTHDAY: 23337,         //循环指定一个月中的某几日
    REPEAT_INTERVAL: 1900,         //循环间隔
    REPEAT_COUNT: 85591,         //循环次数
    REPEAT_UNTIL: 84938,         //循环截至时间
};

// 状态
xmail.enums.CalComponentInfoStatus = {
    UNKNOWN: 0,         //UNKNOWN
    NORMAL: 1,         //正常
    DISABLE: 2,         //禁用
    INVALID: 3,         //无效
    DELETED: 4,         //已删除
    LOCKED: 5,         //已锁定
};

// 组件类别
xmail.enums.CalComponentType = {
    UNKNOWN: 0,         //UNKNOWN
    VEVENT: 1,         //事件
    VTODO: 2,         //代办
    VAVAILABILITY: 3,         //
    VPOLL: 4,         //
};

// 语言
xmail.enums.CalLanguage = {
    UNKNOWN: 0,         //UNKNOWN
    CN: 1,         //中文
    HK: 2,         //繁体
    EN: 3,         //英文
};

// 通知状态
xmail.enums.CalNotifyType = {
    UNKNOWN: 0,         //UNKNOWN
    INIT: 1,         //初始
    ACCEPTED: 2,         //接受
    DECLINED: 3,         //拒绝
    COMPLETED: 4,         //已完成
};

// 参与者角色
xmail.enums.CalParticipationRole = {
    UNKNOWN: 0,         //UNKNOWN
    CHAIR: 1,         //主持
    REQUIRED: 2,         //必须参加
    OPTIONAL: 3,         //可参加
    INFORMED: 4,         //知情
};

// 参与者参与状态
xmail.enums.CalParticipationStatus = {
    UNKNOWN: 0,         //UNKNOWN
    NEEDS_ACTION: 1,         //待定
    ACCEPTED: 2,         //接受
    DECLINED: 3,         //拒绝
    TENTATIVE: 4,         //临时
    DELEGATED: 5,         //
    COMPLETED: 6,         //
    IN_PROCESS: 7,         //
};

// 状态
xmail.enums.CalPermission = {
    UNKNOWN: 0,         //UNKNOWN
    FREE_BUSY: 1,         //忙闲
    READ_ONLY: 2,         //只读
    READ_WRITE: 3,         //读写
    MANAGER: 4,         //管理
    OWNER: 5,         //拥有
};

// 循环类型
xmail.enums.CalRepeatType = {
    UNKNOWN: 0,         //UNKNOWN
    ONCE: 1,         //单次不循环
    DAILY: 2,         //每天
    WEEKLY: 3,         //每周
    MONTHLY: 4,         //每月
    YEARLY: 5,         //每年
};

// 用户当前选择的日程展现视图
xmail.enums.CalViewType = {
    UNKNOWN: 0,         //UNKNOWN
    LIST: 1,         //列表
    DAY: 2,         //日
    WEEK: 3,         //周
    MONTH: 4,         //月
    YEAR: 5,         //年
};

// 组织外可见选项
xmail.enums.CalVisibleType = {
    UNKNOWN: 0,         //UNKNOWN
    CORP_DEF: 1,         //企业默认
    PRIVATELY: 2,         //私有
    FREE_BUSY: 3,         //忙闲
    READ: 4,         //只读
};

// 客户端类型
xmail.enums.ClientType = {
    UNKNOWN: 0,         //UNKNOWN
    MA: 1,         //MA
    WM_PC: 2,         //WEB_PC
    WM_MOBILE: 12,         //WEB_MOBILE
    SYS_MANAGER_PC: 13,         //SUPER_MA
    POP: 3,         //POP
    IMAP: 4,         //IMAP
    SMTP: 5,         //SMTP
    EAS: 6,         //EAS
    UMT: 7,         //UMT
    API: 8,         //接口
    UBD: 10,         //UBD
    UDUTIL: 11,         //UD工具
    SCHEDULE: 14,         //定时任务
    CALWEB: 15,         //日程
    SSO_PC: 16,         //SSO_PC
    SSO_MOBILE: 17,         //SSO_MOBILE
};

// 企业反垃圾设置表（corp_antispam_info）- 字段编号枚举
xmail.enums.CorpAntispamInfoField = {
    ID: 3719,         //
    CORP_ID: 16757,         //
    SPAM_LEVEL: 88364,         //反垃圾级别|spam_level|IGNORE(1,  不过滤 ),LOW(2,  低级 ),MEDIUM_LOW(3,  中低 ),MEDIUM(4,  中级 ),MEDIUM_HIGH(5,  中高 ),HIGH(6,  高级 );
    REMIND_CYCLE: 29670,         //反垃圾提醒周期
    REMIND_START_TIME: 99739,         //提醒开始时间
    REMIND_END_TIME: 33830,         //提醒结束时间
    MAIL_PICTURE_VISIABLE: 13904,         //邮件图片|mail_picture_visiable|ENABLE(1,  企业邮件图片 ),DISABLE(2,  禁用所有邮件中的图片，手动点击后显示 ),DISABLE_SPAM(3,  禁用垃圾邮件中的图片，手动点击后显示 );
    CREATE_TIME: 82559,         //创建时间
    UPDATE_TIME: 77635,         //更新时间
};

// 企业API接口表（corp_api_info）- 字段编号枚举
xmail.enums.CorpApiInfoField = {
    ID: 3719,         //
    NAME: 9776,         //接口名称
    CORP_ID: 16757,         //企业id
    SUITE_ID: 14869,         //账户
    SUITE_SECRET: 77227,         //第三方应用密钥
    PASSWD_TYPE: 82007,         //密码加密类型|passwd_type|SM4(1, 国4加密 ),BCRYPT(2,  bcrypt加密 ),NO_CRYPT(3, 不加密 ),SM3(4, 国3加密 ),MD5(5, MD5加密 ),MD5_SALT(6, MD5加盐 );
    API_TYPE: 25487,         //API接口类型|api_type|CORP(1,  企业 ),SUPER(2,  超级 );
    STATUS: 91903,         //API接口状态|api_status|ENABLE(1,  启用 ),DISABLE(2,  禁用 );
    PRIVI_FLAG: 27485,         //API接口权限类型:api_privi_flag:1,ORG,组织通讯录 | 2,SSO,单点 | 3,DISK,网盘
    API_IP_LIMIT_ENABLE: 17088,         //是否启用apiIP限制
    API_IP_CONTENT: 93376,         //apiIP或ip段
    MEMO: 67825,         //描述
    CREATE_TIME: 82559,         //创建时间
    UPDATE_TIME: 77635,         //更新时间
};

// 审核功能组表（corp_audit_group）- 字段编号枚举
xmail.enums.CorpAuditGroupField = {
    ID: 3719,         //
    AUDIT_GROUP_ID: 8065,         //审核功能组id
    CORP_ID: 16757,         //企业id
    CREATE_TIME: 82559,         //创建时间
    UPDATE_TIME: 77635,         //更新时间
    NAME: 9776,         //名字
    MEMBER_SELECTOR_ID: 11159,         //功能组成员id
    MEMO: 67825,         //描述
    OPERATE_EMAIL: 69521,         //操作邮箱
};

// 企业审核信息表（corp_audit_info）- 字段编号枚举
xmail.enums.CorpAuditInfoField = {
    ID: 3719,         //
    AUDIT_ID: 54429,         //
    CORP_ID: 16757,         //企业id
    CREATE_TIME: 82559,         //创建时间
    UPDATE_TIME: 77635,         //更新时间
    NAME: 9776,         //名字
    SORT_VAL: 1981,         //排序值
    AUDITOR_MEMBER_SELECTOR_ID: 16987,         //审核人成员id
    STATUS: 91903,         //规则状态|audit_info_status|ENABLE(1,  启用 ),DISABLE(2,  禁用 );
    SCOPE_TYPE: 3987,         //执行范围|audit_scope_type|SEND(1,  发信阶段 ),RECIVE(2,  收信阶段 ),SENDRECIVE(3,  收信和发信阶段 );
    COND_TYPE: 59853,         //执行条件|audit_cond_type|ALL(1,  满足所有 ),ANY(2,  满足任一 );
    FROM_ENABLE: 62834,         //发件人是否启用
    FROM_INCLUDE: 56025,         //发件人是否包含
    FROM_MATCH_ALL: 2068,         //发件人是否符合全部
    FROM_MEMBER_SELECTOR_ID: 5974,         //发件人成员选择id
    TO_ENABLE: 18580,         //收件人是否启用
    TO_INCLUDE: 60489,         //收件人或抄送人是否包含
    TO_MATCH_ALL: 47329,         //收件人或抄送人是否符合全部
    TO_MEMBER_SELECTOR_ID: 53809,         //收件人或抄送人成员选择id
    SUBJECT_ENABLE: 56235,         //主题是否启用
    SUBJECT_INCLUDE: 59362,         //主题是否包含
    SUBJECT_MATCH_ALL: 63588,         //主题是否符合全部
    SUBJECT_VAL: 38194,         //主题匹配的关键字内容
    CONTENT_ENABLE: 11336,         //正文是否启用
    CONTENT_INCLUDE: 11999,         //正文是否包含
    CONTENT_MATCH_ALL: 64285,         //正文是否匹配全部
    CONTENT_VAL: 27277,         //正文匹配的关键字内容
    ATTACH_NAME_ENABLE: 10721,         //附件名是否启用
    ATTACH_NAME_INCLUDE: 7046,         //附件名是否包含
    ATTACH_NAME_MATCH_ALL: 34430,         //附件名是否匹配全部
    ATTACH_NAME_VAL: 96346,         //附件名匹配的关键字内容
    ATTACH_ENABLE: 82182,         //是否启用包含附件选项
    ATTACH_INCLUDE: 63556,         //是否包含附件
    MAIL_SIZE_ENABLE: 70308,         //是否启用邮件大小选项
    MAIL_SIZE_MAX: 59258,         //邮件大小项最大值  单位：KB
    MAIL_SIZE_MIN: 5265,         //邮件大小项最小值  单位：KB
    TO_NUM_ENABLE: 27239,         //是否启用收件人数量选项
    TO_NUM_MAX: 64825,         //收件人数量选项最大值
    TO_NUM_MIN: 845,         //收件人数量选项最小值
    RCPT_FOREIGN_ADDR_ENABLE: 39999,         //是否启用收件人或者抄送人包含外域选项
    RCPT_TRUST_ADDR_ENABLE: 27074,         //是否收件人或抄送人的信任地址选项
    RCPT_TRUST_ADDR_MEMBER_SELECTOR_ID: 62186,         //收件人或抄送人的信任地址成员id
    AUDIT_TYPE: 86384,         //多人审核裁决结果|audit_info_audit_type|FIRST(1,  最先裁决为结果 ),ALL(2,  所有人通过结果 );
    TIME_LIMIT_ENABLE: 9603,         //是否启用审核时限选项
    TIME_LIMIT: 92149,         //审核时限小时
    AUDITING_NOTICE_ENABLE: 28678,         //是否启用当邮件处于审核状态时,通知原发件人
    RESULT_NOTICE_ENABLE: 59063,         //是否启用审核结果通知选项
    RESULT_NOTICE_TYPE: 67846,         //审核结果通知类型|audit_info_result_notice_type|AGREE(1,  同意 ),REJECT(2,  拒绝 ),ALL(3, 全部 );
};

// 企业审核记录表（corp_audit_log）- 字段编号枚举
xmail.enums.CorpAuditLogField = {
    ID: 3719,         //
    AUDIT_LOG_ID: 54158,         //审核日志id
    CORP_ID: 16757,         //企业id
    CREATE_TIME: 82559,         //创建时间
    UPDATE_TIME: 77635,         //更新时间
    SCOPE_TYPE: 3987,         //执行范围|audit_scope_type|SEND(1,  发信阶段 ),RECIVE(2,  收信阶段 ),SENDRECIVE(3,  收信和发信阶段 );
    STATUS: 91903,         //审核状态|audit_log_status|AGREE(1,  同意 ),DISABLE(2,  拒绝 ),AUDITING(3,  审核中 ),FAIL(4, 失败 ),SCHEDULE(5, 定时任务 );
    FILE_ID: 28684,         //邮件唯一id
    MAIL_FROM: 9793,         //邮件发件人
    REAL_SENDER: 80025,         //邮件真实发件人
    PRIME_SENDER: 9193,         //邮件真实发件人主名
    RCPT: 81475,         //
    MAIL_TO: 33648,         //邮件收件人
    CC: 8822,         //邮件抄送人
    BCC: 38498,         //
    SUBJECT: 8685,         //邮件主题
    MAIL_SIZE: 44383,         //邮件大小
    MAIL_DATE: 22460,         //邮件时间
    AUDITORS: 35613,         //审核人
    AUDIT_TYPE: 86384,         //多人审核裁决结果|audit_log_audit_type|FIRST(1,  最先裁决为结果 ),ALL(2,  所有人通过结果 );
    AUDIT_EXPIRED_TIME: 63322,         //审核到期时间
    AUDITING_NOTICE_ENABLE: 28678,         //是否启用当邮件处于审核状态时,通知原发件人
    RESULT_NOTICE_ENABLE: 59063,         //是否启用审核结果通知选项
    RESULT_NOTICE_TYPE: 67846,         //审核结果通知类型|audit_log_result_notice_type|AGREE(1,  同意 ),REJECT(2,  拒绝 ),ALL(3, 全部 );
    ERROR_CODE: 38477,         //
    MEMO: 67825,         //备注
};

// 企业审核重试表（corp_audit_send_retry）- 字段编号枚举
xmail.enums.CorpAuditSendRetryField = {
    ID: 3719,         //
    AUDIT_LOG_ID: 54158,         //审核日志id
    CORP_ID: 16757,         //企业id
    CREATE_TIME: 82559,         //创建时间
    UPDATE_TIME: 77635,         //更新时间
    AUDITOR: 63944,         //审核人
    MAIL_IDENTITY: 79994,         //邮件id
    MAIL_FROM: 9793,         //邮件发件人
    MAIL_TO: 33648,         //邮件收件人
    MAIL_SIZE: 44383,         //邮件大小
    MAIL_SUBJECT: 71919,         //邮件主题
    AUDITOR_PWD: 6996,         //审核人密码
    RETRY_TIMES: 63285,         //重试次数
    AUDIT_MAIL_TYPE: 74605,         //审核邮件类型|audit_send_retry_audit_mail_type|RECV(1,  收信审核 ),SEND(2,  发信审核 );
    SEND_SUCC: 30281,         //是否发送成功
    SEND_TIME: 54732,         //发送时间
    SCOPE_TYPE: 3987,         //多人审核裁决结果|audit_send_retry_scope_type|FIRST(1,  最先裁决为结果 ),ALL(2,  所有人通过结果 );
    MEMO: 67825,         //
};

// 企业审核人记录表（corp_auditor_log）- 字段编号枚举
xmail.enums.CorpAuditorLogField = {
    ID: 3719,         //
    AUDIT_LOG_ID: 54158,         //审核人日志的id
    CORP_ID: 16757,         //企业id
    CREATE_TIME: 82559,         //创建时间
    UPDATE_TIME: 77635,         //更新时间
    AUDITOR_TIME: 12733,         //审核人审核时间
    AUDITOR_ACCOUNT_ID: 77728,         //审核人的邮箱id
    AUDITOR_USER_EMAIL: 71223,         //审核人邮箱地址
    AUDITOR_PWD: 6996,         //审核人密码
    STATUS: 91903,         //审核状态|auditor_log_status|AGREE(1,  同意 ),DISABLE(2,  拒绝 ),AUDITING(3,  审核中 ),FAIL(4, 失败 );
    MEMO: 67825,         //审核备注
    AUDITOR_ERROR_CODE: 72302,         //审核人错误码
};

// 企业黑白名单表（corp_black_white_list）- 字段编号枚举
xmail.enums.CorpBlackWhiteListField = {
    ID: 3719,         //
    CORP_ID: 16757,         //
    ADDR: 89351,         //地址(如果含有@为EMAIL地址； 否则是域名)
    ADDR_TYPE: 22284,         //地址类型|addr_type|BLACK(1,  黑名单 ),WHITE(2, 白名单 );
    ADDR_MATCH_TYPE: 69109,         //匹配地址类型|addr_match_type|XSENDER(1,  按照Xsender匹配 ),FROM(2, 按照from匹配 ),XSENDER_OR_FROM(3, 按照from或者Xsender匹配 );
    CREATE_TIME: 82559,         //创建时间
    UPDATE_TIME: 77635,         //更新时间
};

// 企业常规设置表（corp_common_setting）- 字段编号枚举
xmail.enums.CorpCommonSettingField = {
    ID: 3719,         //
    CORP_ID: 16757,         //企业id
    LOGO_FILE_ID: 10517,         //logo文件id
    LOGOUT_URL: 87498,         //退出url
    TITLE_DEF: 19896,         //是否使用默认浏览器title
    CUSTOM_TITLE: 79882,         //自定义title
    LOGIN_ROUTER_PAGE: 34119,         //登录后默认显示|login_router_page|HOME(1,  首页 ),INBOX(2,  收件箱 );
    CREATE_TIME: 82559,         //创建时间
    UPDATE_TIME: 77635,         //更新时间
};

// 企业地址簿通讯组表表（corp_contact_group）- 字段编号枚举
xmail.enums.CorpContactGroupField = {
    ID: 3719,         //主键
    GROUP_ID: 83103,         //通讯组ID
    CORP_ID: 16757,         //企业ID
    PARENT_ID: 60732,         //父通讯组ID
    NAME: 9776,         //通讯组名称
    CREATE_TIME: 82559,         //创建日期
    UPDATE_TIME: 77635,         //修改日期
    SORT_VAL: 1981,         //排序值
    MEMO: 67825,         //备注
};

// 企业地址簿联系人表表（corp_contact_info）- 字段编号枚举
xmail.enums.CorpContactInfoField = {
    ID: 3719,         //主键
    CORP_CONTACT_ID: 27172,         //联系人ID
    CORP_ID: 16757,         //企业ID
    CREATE_TIME: 82559,         //创建时间
    UPDATE_TIME: 77635,         //修改时间
    SURNAME: 33177,         //姓氏
    GIVEN_NAME: 69284,         //名字
    GENDER: 61230,         //性别
    BIRTHDAY: 55906,         //生日
    NICKNAME: 64650,         //昵称
    WECHAT: 90256,         //微信
    QQ: 95053,         //QQ
    EMAIL: 26761,         //电子邮件
    MOBILE: 86202,         //手机
    TELEPHONE: 93290,         //电话号码
    FAX: 72446,         //传真号码
    COMPANY: 87021,         //公司名称
    DEPART_NAME: 62910,         //部门名称
    POSITION: 14793,         //职位
    WORK_WEBSITE: 22385,         //公司-网址
    WORK_COUNTRY: 80878,         //公司-国家
    WORK_PROVINCE: 18400,         //公司-省
    WORK_CITY: 14416,         //公司-市
    WORK_STREET: 54683,         //公司-街道
    WORK_POSTAL_CODE: 18430,         //公司-邮编
    HOME_COUNTRY: 66250,         //家庭-国家
    HOME_PROVINCE: 30822,         //家庭-省
    HOME_CITY: 87176,         //家庭-市
    HOME_STREET: 83407,         //家庭-街道
    HOME_POSTAL_CODE: 57550,         //家庭-邮编
    MEMO: 67825,         //备注
};

// 企业地址簿关系表表（corp_contact_relation）- 字段编号枚举
xmail.enums.CorpContactRelationField = {
    ID: 3719,         //主键
    CORP_ID: 16757,         //企业ID
    GROUP_ID: 83103,         //通讯组ID
    CORP_CONTACT_ID: 27172,         //联系人ID
    SORT_VAL: 1981,         //排序值
};

// 企业域信息表（corp_domain）- 字段编号枚举
xmail.enums.CorpDomainField = {
    ID: 3719,         //
    CORP_ID: 16757,         //企业id
    DOMAIN_ID: 69476,         //域名的id
    PRIME_DOMAIN_ID: 4904,         //主域名的domaniId
    DOMAIN_NAME: 3260,         //域名
    STATUS: 91903,         //域状态|corp_domain_status|NO_VERIFY (1,  未验证MX解析 ),NORMAL(2,  添加成功 ),DELETED(4,  已删除 );
    USED_NUM: 92503,         //已分配的邮箱数量
    CORP_DEF: 1890,         //是否是企业默认的主名
    PRIMED: 94634,         //是否是主名
    VERSION: 89499,         //版本号
    UMT_STATUS_ENABLE: 35647,         //是否开通搬家
    UMT_EXPIRE_TIME: 58453,         //搬家到期时间
    SERVER_TYPE: 66185,         //服务器类型|umt_server_type|POP(1,  POP ),IMAP(2,  IMAP );
    HOST: 82989,         //服务器地址
    PORT: 35210,         //服务器端口
    SSL_ENABLE: 43144,         //是否是SSL
    AUTH_CONTAINS_DOMAIN_ENABLE: 89871,         //认证是否包含域名
    DIFF_DOMAIN_ENABLE: 82726,         //是否是不同域名间搬家
    UMT_DOMAIN_NAME: 44877,         //搬家的域名
    FOLDER_ID: 47295,         //文件夹id
    UMT_START_TIME: 18139,         //搬家开始时间
    UMT_END_TIME: 38269,         //搬家结束时间
    CREATE_TIME: 82559,         //创建时间
    UPDATE_TIME: 77635,         //更新时间
};

// 域状态
xmail.enums.CorpDomainStatus = {
    UNKNOWN: 0,         //UNKNOWN
    NO_VERIFY: 1,         //未验证MX解析
    NORMAL: 2,         //添加成功
    DELETED: 4,         //已删除
};

// 企业分类过滤表（corp_filter_info）- 字段编号枚举
xmail.enums.CorpFilterInfoField = {
    ID: 3719,         //
    FILTER_ID: 296,         //分类过滤id
    CORP_ID: 16757,         //企业id
    CREATE_TIME: 82559,         //创建时间
    UPDATE_TIME: 77635,         //更新时间
    SORT_VAL: 1981,         //排序值
    NAME: 9776,         //名字
    STATUS: 91903,         //规则状态|filter_info_status|ENABLE(1,  启用 ),DISABLE(2,  禁用 );
    SCOPE_TYPE: 3987,         //执行范围|filter_scope_type|SEND(1,  发信阶段 ),RECIVE(2,  收信阶段 ),SENDRECIVE(3,  收信和发信阶段 );
    COND_TYPE: 59853,         //执行条件|filter_cond_type|ALL(1,  满足所有 ),ANY(2,  满足任一 );
    FROM_ENABLE: 62834,         //发件人是否启用
    FROM_INCLUDE: 56025,         //发件人是否包含
    FROM_MATCH_ALL: 2068,         //发件人是否符合全部
    FROM_MEMBER_SELECTOR_ID: 5974,         //发件人成员id
    TO_ENABLE: 18580,         //收件人是否启用
    TO_INCLUDE: 60489,         //收件人或抄送人是否包含
    TO_MATCH_ALL: 47329,         //收件人或抄送人是否符合全部
    TO_MEMBER_SELECTOR_ID: 53809,         //收件人或抄送人成员id
    SUBJECT_ENABLE: 56235,         //主题是否启用
    SUBJECT_INCLUDE: 59362,         //主题是否包含
    SUBJECT_MATCH_ALL: 63588,         //主题是否符合全部
    SUBJECT_VAL: 38194,         //主题匹配的关键字内容
    CONTENT_ENABLE: 11336,         //正文是否启用
    CONTENT_INCLUDE: 11999,         //正文是否包含
    CONTENT_MATCH_ALL: 64285,         //正文是否匹配全部
    CONTENT_VAL: 27277,         //正文匹配的关键字内容
    ATTACH_NAME_ENABLE: 10721,         //附件名是否启用
    ATTACH_NAME_INCLUDE: 7046,         //
    ATTACH_NAME_MATCH_ALL: 34430,         //附件名称是否匹配全部
    ATTACH_NAME_VAL: 96346,         //
    ATTACH_ENABLE: 82182,         //是否启用包含附件选项
    ATTACH_INCLUDE: 63556,         //是否包含附件
    MAIL_SIZE_ENABLE: 70308,         //是否启用邮件大小选项
    MAIL_SIZE_MAX: 59258,         //邮件大小选项最大值  单位：KB
    MAIL_SIZE_MIN: 5265,         //邮件大小选项最小值  单位：KB
    TO_NUM_ENABLE: 27239,         //是否启用收件人数量选项
    TO_NUM_MAX: 64825,         //收件人数量选项最大值
    TO_NUM_MIN: 845,         //收件人数量选项最小值
    RCPT_FOREIGN_ADDR_ENABLE: 39999,         //是否启用收件人或者抄送人包含外域选项
    RCPT_TRUST_ADDR_ENABLE: 27074,         //是否收件人或抄送人的信任地址选项
    RCPT_TRUST_ADDR_MEMBER_SELECTOR_ID: 62186,         //收件人或抄送人的信任地址成员id
    EXECUTE_OPT_TYPE: 68708,         //相应操作|filter_execute_opt_type|DELETE(1,  删除邮件 ),FORWARD(2,  转发至 ),DEL_FORWARD(3,  删除并转发至 ),SAFETIP(4,  添加安全提示 ),RUN(5, 执行以下操作 ),BOUNCE(6, 退信 );
    FORWARD_MEMBER_SELECTOR_ID: 1897,         //转发地址成员id
    SMTP_HOST: 55074,         //投递地址
    SMTP_PORT: 18600,         //投递端口
    SAFE_TIP_TYPE: 53913,         //安全提示样式|filter_safe_tip_type|DEFAULT(1,  默认样式 ),CUSTOM(2,  自定义样式 );
    SAFE_TIP_CONTENT: 98365,         //安全提示内容
    BOUNCE_TIP: 47029,         //退信提示
    BOUNCE_ADVICE: 23559,         //退信建议
};

// 企业信息表（corp_info）- 字段编号枚举
xmail.enums.CorpInfoField = {
    ID: 3719,         //
    CORP_ID: 16757,         //企业ID
    CREATE_TIME: 82559,         //创建时间
    UPDATE_TIME: 77635,         //更新时间
    SPEC_IDS: 91571,         //邮箱规格id
    DEFAULT_SPEC_ID: 64934,         //默认邮箱规格id
    MAX_SPACE_LIMIT: 26895,         //是否限制最大空间
    MAX_SPACE: 27429,         //邮箱最大空间 单位MB
    USED_SPACE: 18116,         //已使用空间 单位MB
    MAX_NUM: 26206,         //最大人数
    USED_NUM: 92503,         //已使用人数
    STATUS: 91903,         //企业状态|corp_info_status|ENABLE(1,  启用 ),DISABLE(2,  禁用 ),DELETED(3, 已删除 )
    VERSION_SYNC_SERIAL: 72602,         //版本同步序列值（用于数据同步递进；任何XXX版本字段更新时都要更新此值；此值不是简单+1，而是保证全表越晚更新记录的值大于先前更新记录的值； 如何数据库支持“自增序列”则使用“自增序列”， 如不支持则暂时更新为数据库当前时间毫秒数（unix_timestamp(current_timestamp(3))*1000）
    INFO_VERSION: 53068,         //企业基本信息版本号
    ORG_VERSION: 19857,         //企业组织结构版本号
    MEMBER_SELECTOR_VERSION: 60219,         //企业成员选择器版本号
    SETTING_VERSION: 1734,         //企业相关设置版本号
    ABILITY_FLAG: 23109,         //邮箱功能标记:corp_ability_flag:1,FLAGA,需要修改DB注释以便生成（位数从1开始） | 2,FLAGB,第二位表示样例
    WORKBENCH_FLAG: 578,         //应用功能:corp_workbench_flag:1,FLAGA,需要修改DB注释以便生成（位数从1开始） | 2,FLAGB,第二位表示样例
    NAME: 9776,         //名字
    CONTACT_NAME: 75141,         //联系人名字
    CONTACT_EMAIL: 45370,         //联系人邮箱
    CONTACT_TEL: 60822,         //联系人座机
    CONTACT_MOBILE: 88683,         //联系人手机
    CONTACT_FAX: 38630,         //联系人传真
    CONTACT_ADDR: 78147,         //联系人地址
    POSTADDR: 32023,         //公司通讯地址
    POSTCODE: 3194,         //邮政编码
    REG_TIME: 6612,         //注册时间
    EXPIRE_TIME: 28313,         //到期时间
    MAX_LIST_NUM: 32882,         //邮件列表最大个数
    TRUSTED: 71916,         //是否是可信版本
};

// 企业状态
xmail.enums.CorpInfoStatus = {
    UNKNOWN: 0,         //UNKNOWN
    ENABLE: 1,         //启用
    DISABLE: 2,         //禁用
    DELETED: 3,         //已删除
};

// 企业管理员信息表（corp_manager_info）- 字段编号枚举
xmail.enums.CorpManagerInfoField = {
    ID: 3719,         //
    CORP_ID: 16757,         //企业id
    USER_ID: 37163,         //用户id
    MAIL_ACCOUNT_ID: 91885,         //邮箱id
    USER_EMAIL: 11187,         //邮箱地址
    CORP_PRIVI_GROUP_ID: 49570,         //域权限功能组id
    CORP_PRIVI_GROUP_NAME: 56095,         //域权限功能组名字
    STATUS: 91903,         //管理员状态|manager_info_status|ENABLE(1,  启用 ),DISABLE(2,  禁用 );
    LAST_LOGIN_IP: 7759,         //上一次登录ip
    LAST_LOGIN_TIME: 94451,         //上一次登录时间
    SYS_DEF: 19271,         //是否是系统默认
    CURRENT_LOGIN_IP: 21873,         //当前登录ip
    CURRENT_LOGIN_TIME: 65200,         //当前登录时间
    OP_EMAIL: 7735,         //
    DEPT_MEMBER_SELECTOR_ID: 86887,         //部门成员id
    CREATE_TIME: 82559,         //创建时间
    UPDATE_TIME: 77635,         //更新时间
    MEMO: 67825,         //描述
};

// 第三方应用信息表表（corp_open_app）- 字段编号枚举
xmail.enums.CorpOpenAppField = {
    ID: 3719,         //
    CORP_ID: 16757,         //企业id
    APP_ID: 27022,         //第三方应用id
    APP_SECRET: 49366,         //第三方应用凭证
    APP_TYPE: 49941,         //应用类型|open_app_type|FS(1,  飞书 );
    SUITE_ID: 14869,         //api的应用密钥
    ENCRYPT_KEY: 52800,         //第三方应秘钥
    DECRYPT_TYPE: 8939,         //解密算法类型|decrypt_type|AES(1,  aes解密 );
    OAUTH_URL: 58778,         //应用oauth地址
    REDIRECT_URL: 54452,         //应用回调地址(私有云提供的接口)
    APP_TOKEN_URL: 52589,         //获取app的token地址
    USER_TOKEN_URL: 20375,         //获取用户token地址
    PUSH_MSG_URL: 77345,         //消息推送地址
    STATUS: 91903,         //状态
    CREATE_TIME: 82559,         //创建时间
    UPDATE_TIME: 77635,         //更新时间
    CLICK_MSG_URL: 56613,         //点击消息链接地址
};

// 企业管理员权限功能组表（corp_privi_group）- 字段编号枚举
xmail.enums.CorpPriviGroupField = {
    ID: 3719,         //
    CORP_ID: 16757,         //企业id
    CORP_PRIVI_GROUP_ID: 49570,         //企业权限组id
    NAME: 9776,         //权限组名字
    PRIVIAGE1: 47585,         //权限1(privi_info表<=50个privi_id )
    PRIVIAGE2: 78311,         //权限1(大于50privi_id，对64取模，余数就是表名 )
    CORP_DEF: 1890,         //是否是企业默认
    OP_EMAIL: 7735,         //操作邮箱地址
    CREATE_TIME: 82559,         //创建时间
    UPDATE_TIME: 77635,         //更新时间
    MEMO: 67825,         //备注
};

//
xmail.enums.CorpPrivilege = {
    HOME_PAGE: 1,         //首页
    ORG_USER: 2,         //组织及用户
    ADDRESS_BOOK: 3,         //通讯录
    CONTROL_CENTER: 4,         //管控中心
    LOG_CENTER: 5,         //日志中心
    APP_CENTER: 6,         //应用中心
    SECURITY_CENTER: 7,         //安全中心
    ADDRESS_VIEW: 8,         //通讯录视图
    MAIL_LIST: 9,         //邮件列表
    CONTACTS: 10,         //外部联系人
    MANAGER: 11,         //管理员账户管理
    USER_PRIVI: 12,         //用户权限管理
    ANTISPAM: 13,         //反垃圾设置
    MAIL_MONITOR: 14,         //用户邮箱监测
    MAIL_FILTER: 15,         //邮件分类过滤
    MAIL_AUDIT: 16,         //邮件审核管理
    MAIL_DEL: 17,         //域内邮件删除
    LOG_MANAGER: 18,         //管理员操作日志
    LOG_BATCH: 19,         //批量任务日志
    LOG_LOGIN_USER: 20,         //用户登录日志
    LOG_DELIVER: 21,         //邮件收发删日志
    MAIL_USAGE: 22,         //邮箱使用情况
    MAIL_TRAFFIC_STATIC: 23,         //邮件流量统计
    COMMON_SETTING: 24,         //常规设置
    MAIL_WELCOME: 25,         //欢迎信
    MAIL_BULLETIN: 26,         //域公告邮件
    MOD_MANAGE_PWD: 27,         //修改管理员密码
    CORP_BASIC: 28,         //企业基本信息设置
    DEPT_USER: 29,         //部门及用户
    ADD_DEPT_USER: 30,         //添加部门/用户
    EDIT_DEPT: 31,         //编辑部门
    DEL_DEPT_USER: 32,         //删除部门/用户
    ADVANCE_SEARCH: 33,         //高级搜索
    ORG_USER_EXPORT: 34,         //组织及用户导出
    ADD_ADDR_GROUP: 35,         //添加到通讯组
    DEPT_USER_SORT: 36,         //部门内排序
    MOVE_DEPT: 37,         //转移到部门
    LOG_LOGIN_MANAGER: 47,         //管理员登录日志
    RULE_LOGIN: 66,         //登录限制
    RULE_DELIVER: 67,         //收发限制
    BLACK_WHITE: 68,         //黑白名单设置
    RULE_PWD: 69,         //密码策略
    MANAGER_PRIVI: 70,         //管理员权限管理
    API: 71,         //API接口
    MORE_DOMAIN: 72,         //多域管理
    EDIT_USER_BASE: 74,         //编辑用户基本信息
    EDIT_USER_HIGHER: 75,         //编辑用户高级信息
    EDIT_USER_PWD: 76,         //编辑用户密码
    EDIT_USER_ALIAS: 77,         //编辑用户别名
    EDIT_MAILLIST: 78,         //编辑用户邮件列表
    EDIT_PERSON_INFO: 79,         //编辑用户个人信息
    BATCH_ADD_USER: 80,         //批量添加用户
    BATCH_EDIT_USER: 81,         //批量编辑用户
    BATCH_DEL_USER: 82,         //批量删除用户
    BATCH_ADD_DEPT: 83,         //批量添加部门
    BATCH_SAVE_ACCOUNT: 84,         //批量设置用户
    UMT: 85,         //邮件搬家
    BATCH_ADD_CONTACTINFO: 85,         //批量添加外部联系人
    MAIL_ACCOUNT_BACKUP: 86,         //邮箱备份
    LOG_REMOTE_LOGIN: 87,         //异地登录日志
    LOG_UPDATE_PWD: 88,         //修改密码日志
    LOG_DELIVER_SET: 89,         //自动转发设置日志
};

// 企业信任域表（corp_property）- 字段编号枚举
xmail.enums.CorpPropertyField = {
    ID: 3719,         //
    CORP_ID: 16757,         //企业id
    MEMBER_SELECTOR_ID: 11159,         //成员id
    TRUST_CORP_ID: 21626,         //信任企业id
    CREATE_TIME: 82559,         //创建时间
    UPDATE_TIME: 77635,         //更新时间
};

// 企业收发设置表（corp_rule_deliver）- 字段编号枚举
xmail.enums.CorpRuleDeliverField = {
    ID: 3719,         //
    RULE_DELIVER_ID: 93979,         //规则id
    CORP_ID: 16757,         //企业id
    NAME: 9776,         //名字
    PRIORITY: 48929,         //优先级
    RULE_DELIVER_MEMBER_SELECTOR_ID: 32172,         //收发规则范围选择器id
    RECV_FOREIGN_DOMAIN_ENABLE: 41815,         //禁止接收外域邮件
    SEND_TYPE: 89539,         //邮件发送设置|role_deliver_send_type|ENABLE_PART(1,  只允许发送到指定邮箱或域 ),DISABLE(2,  禁止发送 ),DISABLE_FOREIGN(3,  禁止发送外域 ),DISABLE_PART(4,  禁止发送到指定邮箱或域 ),DEFAULT(-1, 系统默认 );
    SEND_MEMBER_SELECTOR_ID: 34244,         //邮件发送成员id
    FORWARD_TYPE: 48470,         //自动转发设置|role_deliver_forward_type|DISABLE(1,  禁止发送1 ),DISABLE_FOREIGN(2,  禁止转发外域 ),DEFAULT(-1, 系统默认 );
    SEND_FORCE_REAL_ENABLE: 21090,         //是否启用强制真实姓名发信
    MAX_ATTACH_SIZE_SINGLE: 75488,         //单封附件总大小 单位MB
    MAX_TO_NUM_SINGLE: 40238,         //单封邮件最大收件人数量（人）
    MAX_SEND_NUM_DAILY: 533,         //邮件日最大发送量
    CREATE_TIME: 82559,         //创建时间
    UPDATE_TIME: 77635,         //更新时间
};

// 企业登录ip限制表（corp_rule_login）- 字段编号枚举
xmail.enums.CorpRuleLoginField = {
    ID: 3719,         //
    RULE_LOGIN_ID: 55537,         //规则id
    CORP_ID: 16757,         //企业id
    CREATE_TIME: 82559,         //创建时间
    UPDATE_TIME: 77635,         //更新时间
    NAME: 9776,         //规则名字
    PRIORITY: 48929,         //规则优先级
    RULE_LOGIN_MEMBER_SELECTOR_ID: 26959,         //登录规则范围选择器id
    LOGIN_IP_LIMIT: 41853,         //登录IP限制|rule_login_ip_limit|ENABLE_PART(1,  只允许 ), DISABLE_PART(2,  不允许 ), UNLIMITED(3,  不限制 ), DEFAULT(-1, 系统默认 );
    LOGIN_IP_CONTENT: 38315,         //登录限制ip或ip段
    LOGIN_AREA_CONTENT: 37785,         //登录限制地区
    LOGIN_TIME_LIMIT_ENABLE: 17241,         //是否开启登录时间限制
    LOGIN_TIME_DAY_FLAG: 92719,         //登录时间限制周几:login_time_day_flag: 1,MO,周一 | 2,TU,周二| 3,WE,周三| 4,TH,周四| 5,FR,周五| 6,SA,周六| 7,SU,周日
    LOGIN_TIME_START: 37932,         //登录限制开始时间
    LOGIN_TIME_END: 56108,         //登录限制结束时间
    AUTH_TIMEOUT: 43685,         //超时重新认证时长(分钟)
    LOGIN_ERROR_TIMES: 28735,         //登录连续错误次数
};

// 企业密码策略表（corp_rule_passwd）- 字段编号枚举
xmail.enums.CorpRulePasswdField = {
    ID: 3719,         //
    CORP_ID: 16757,         //企业id
    RULE_PASSWD_ID: 14609,         //密码规则id
    CORP_DEF: 1890,         //系统默认规则
    NAME: 9776,         //名称
    PRIORITY: 48929,         //优先级
    RULE_PASSWD_MEMBER_SELECTOR_ID: 81604,         //密码 规则范围选择器id
    REGULAR_CHANGE_PWD_ENABLE: 65401,         //是否启用定期修改密码
    CHANGE_PWD_CYCLE: 34435,         //定期修改密码周期
    REMIND_BEFORE_DAYS: 46855,         //提前几天提醒
    REMIND_CYCLE: 29670,         //每隔几天发送一次周期
    PWD_CLASSIFY_COUNT: 93935,         //密码组合种类
    MIN_PWD_LEN: 46134,         //最小密码长度
    PWD_DIFF_ORIGINAL: 34755,         //不能与原密码相同
    PWD_DISCONTINUITY: 7374,         //不能包含三个连续或相同的字符
    PWD_INC_DOMAIN_USER: 16087,         //不能包含用户名或域名
    PWD_WEAK_FORBIDDEN: 62847,         //不能使用弱密码
    CREATE_TIME: 82559,         //创建时间
    UPDATE_TIME: 77635,         // 更新时间
};

// 企业用户权限限制表（corp_rule_privi）- 字段编号枚举
xmail.enums.CorpRulePriviField = {
    ID: 3719,         //
    CORP_ID: 16757,         //企业id
    RULE_PRIVI_ID: 93283,         //用户权限id
    NAME: 9776,         //名字
    PRIORITY: 48929,         //优先级
    RULE_PRIVI_MEMBER_SELECTOR_ID: 50412,         //用户权限范围选择器id
    PRIVIAGE1: 47585,         //权限1(privi_info表<=50个privi_id )
    PRIVIAGE2: 78311,         //权限1(大于50privi_id，对64取模，余数就是表名 )
    CORP_DEF: 1890,         //是否是企业默认
    OP_EMAIL: 7735,         //创建人邮箱地址
    CREATE_TIME: 82559,         //创建时间
    UPDATE_TIME: 77635,         //更新时间
    MEMO: 67825,         //备注
};

// 企业单点登录表（corp_sso）- 字段编号枚举
xmail.enums.CorpSsoField = {
    ID: 3719,         //
    SUITE_ID: 14869,         //账户
    CORP_ID: 16757,         //企业id
    SSO_TYPE: 31077,         //模式|sso_type|SIMPLE(1,  简易模式 ),INTERFACE_BIND(2,  接口绑定模式 ),USER_BIND(3,  用户绑定模式 );
    CODE_URL: 72426,         //使用code获取用户信息回调地址
    CALLBACK_URL: 53380,         //获取用户详情回调地址
    PUSH_MSG_URL: 77345,         //消息推送地址
    CREATE_TIME: 82559,         //创建时间
    UPDATE_TIME: 77635,         //更新时间
};

// 批量任务表（corp_task_info）- 字段编号枚举
xmail.enums.CorpTaskInfoField = {
    ID: 3719,         //
    CORP_ID: 16757,         //企业id
    CREATE_TIME: 82559,         //创建时间
    UPDATE_TIME: 77635,         //更新时间
    TASK_ID: 77292,         //任务id
    TASK_SEQ: 10767,         //任务编号
    ANNOUNCEMENT_FILE_ID: 6181,         //域公告的文件id
    TASK_TYPE: 44913,         //任务类型|task_type|USER_BATCH_ADD(1,  批量添加用户 ),USER_BATCH_DEL(2,  批量删除用户 ),DEPT_BATCH_ADD(3,  批量添加部门 ),DEPT_BATCH_DEL(4,  批量删除部门 ),MAIL_DEL(5,  域内邮件删除 ),MAIL_ENS(6,  域内公告邮件 ),USER_BATCH_EDIT(7,  批量编辑用户 ),UMT(8,  手动触发搬家 ),USER_BATCH_RECOVER(9,  批量恢复用户 ),LIST_BATCH_ADD(10, 批量添加列表 ),USER_BATCH_SER(11,  批量设置用户 ),CONTACTINFO_BATCH_ADD(12,  批量添加外部联系人 );
    START_TIME: 71462,         //任务开始时间
    END_TIME: 29797,         //任务结束时间
    TASK_TOTAL: 7119,         //总共执行的个数
    TASK_SUCC: 96832,         //成功的个数
    TASK_FAIL: 53234,         //失败的个数
    TASK_STATUS: 49496,         //任务状态|task_status|SUCC(1,  完成 ),FAIL(2,  失败 ),FAIL_PART(3,  部分完成 ),DOING(5,  进行中 ),UN_EXEC(4, 未执行 )
    TASK_SUBJECT: 93239,         //任务主题
    OP_EMAIL: 7735,         //
    MEMO: 67825,         //任务描述
};

// 批量任务对应的人表（corp_task_user）- 字段编号枚举
xmail.enums.CorpTaskUserField = {
    ID: 3719,         //
    TASK_ID: 77292,         //任务id
    CORP_ID: 16757,         //企业id
    CREATE_TIME: 82559,         //创建时间
    UPDATE_TIME: 77635,         //更新时间
    USER_ID: 37163,         //邮箱id
    USER_EMAIL: 11187,         //邮箱地址
    TASK_ERRNUM: 70322,         //任务错误码
};

// 视图表（corp_view_info）- 字段编号枚举
xmail.enums.CorpViewInfoField = {
    ID: 3719,         //
    VIEW_ID: 66043,         //视图id
    CORP_ID: 16757,         //企业id
    NAME: 9776,         //视图名字
    CORP_DEF: 1890,         //是否为企业默认
    VIEW_MEMBER_SELECTOR_ID: 72734,         //视图成员选择ID（此视图对哪些部门成员生效）
    ORG_MEMBER_SELECTOR_ID: 32055,         //展现成员选择ID（此视图可以展现哪些部门成员）
    OP_EMAIL: 7735,         //创建者邮箱地址
    REMARK: 2866,         //视图描述
    CREATE_TIME: 82559,         //创建时间
    UPDATE_TIME: 77635,         //更新时间
};

// 企业弱密码表（corp_weak_passwd）- 字段编号枚举
xmail.enums.CorpWeakPasswdField = {
    ID: 3719,         //
    CORP_ID: 16757,         //企业id
    WEAK_PASSWD: 21079,         //
    CREATE_TIME: 82559,         //创建时间
    UPDATE_TIME: 77635,         //更新时间
};

// 企业欢迎信表（corp_welcome_eml）- 字段编号枚举
xmail.enums.CorpWelcomeEmlField = {
    ID: 3719,         //
    WELCOME_EML_ID: 68362,         // 欢迎信id
    CORP_ID: 16757,         //企业id
    STATUS: 91903,         //用户状态|welcome_eml_status|ENABLE(1,  启用 ),DISABLE(2,  禁用 );
    FILE_ID: 28684,         //文件id
    CREATE_TIME: 82559,         //创建时间
    UPDATE_TIME: 77635,         //更新时间
};

// 解密算法类型
xmail.enums.DecryptType = {
    UNKNOWN: 0,         //UNKNOWN
    AES: 1,         //AES解密
};

// 投递状态
xmail.enums.DeliverStatus = {
    UNKNOWN: 0,         //UNKNOWN
    RECENT: 1,         //RECENT
    SERVER: 3,         //SERVER
};

// 企业部门表（depart_info）- 字段编号枚举
xmail.enums.DepartInfoField = {
    ID: 3719,         //
    CORP_ID: 16757,         //企业id
    DEPART_ID: 33007,         //部门id
    PARENT_ID: 60732,         //父部门id
    CREATE_TIME: 82559,         //创建时间
    UPDATE_TIME: 77635,         //更新时间
    NAME: 9776,         //名字
    MEMO: 67825,         //描述
    SORT_VAL: 1981,         //排序值
    MAX_NUM: 26206,         //最大上限人数
    TOTAL_NUM: 30007,         //包含子节点的总共人数
    CURRENT_NUM: 8489,         //当前部门人数
    REF_DEPART_ID: 61741,         //第三方部门id
};

//
xmail.enums.ErrorCode = {
    UNKNOWN: -1,         //系统异常，请稍后重试
    SUCCESS: 0,         //success
    NOT_MODIFIED: 304,         //系统异常，请稍后重试
    BAD_REQUEST: 400,         //系统异常，请稍后重试
    UNAUTHORIZED: 401,         //您当前状态已失效，请重新登录!
    FORBIDDEN: 403,         //禁止访问
    NOT_FOUND: 404,         //Not Found
    METHOD_NOT_ALLOWED: 405,         //系统异常，请稍后重试
    NOT_ACCEPTABLE: 406,         //系统异常，请稍后重试
    PROXY_AUTHENTICATION_REQUIRED: 407,         //系统异常，请稍后重试
    REQUEST_TIMEOUT: 408,         //系统异常，请稍后重试
    PRECONDITION_FAILED: 412,         //系统异常，请稍后重试
    PAYLOAD_TOO_LARGE: 413,         //系统异常，请稍后重试
    UNSUPPORTED_MEDIA_TYPE: 415,         //系统异常，请稍后重试
    EXPECTATION_FAILED: 417,         //系统异常，请稍后重试
    PARAM_BUILDING_ERROR: 422,         //必须的参数未传入!
    LOCKED: 423,         //系统异常，请稍后重试
    FAILED_DEPENDENCY: 424,         //系统异常，请稍后重试
    UPGRADE_REQUIRED: 426,         //系统异常，请稍后重试
    TOO_MANY_REQUESTS: 429,         //系统异常，请稍后重试
    INTERNAL_SERVER_ERROR: 500,         //系统异常，请稍后重试!
    NOT_IMPLEMENTED: 501,         //系统异常，请稍后重试
    SERVICE_UNAVAILABLE: 503,         //系统异常，请稍后重试
    NOT_EXTENDED: 510,         //系统异常，请稍后重试
    GATEWAY_TIMEOUT: 504,         //网络连接超时，请稍后重试
    NETWORK_AUTHENTICATION_REQUIRED: 511,         //系统异常，请稍后重试
    UDR_INVALID_DATA: 901,         //系统异常，请稍后重试
    DB_DATA_ACCESS: 991,         //系统异常，请稍后重试
    DB_DATA_INTEGRITY_VIOLATION: 998,         //系统异常，请稍后重试
    UNIQ_KEY_ERROR: 999,         //系统异常，请稍后重试
    MAX_HARD_CODE: 1000,         //系统错误,请联系管理员!
    MA_NO_SPEC: 1001,         //邮箱规格不存在
    MA_ACCOUNT_EXIST: 1002,         //邮箱账号或者列表已经存在
    MA_PARENT_DEPT_NOT_EXIST: 1003,         //父部门不存在
    MA_DEPT_IDS_NOT_EXIST: 1004,         //有不存在的部门id
    MA_PARENT_DEPT_NOT_PROMIT: 1005,         //父部门id不能设置成自己的子部门id
    MA_DEL_DEPT_NOT_PROMIT: 1006,         //存在子部门不允许删除
    MA_DEL_DEPT_MEM_NOT_PROMIT: 1007,         //部门存在人员不允许删除
    MA_CORP_DOMAIN_NOT_EXIST: 1008,         //企业不存在此域名
    MA_ACCOUNT_NOT_EXIST: 1009,         //邮箱账号或者列表不存在
    MA_ACCOUNT_PRIME_NOT_EXIST: 1010,         //主邮箱账号不存在
    MA_OVER_ALIAS_COUNT: 1011,         //别名个数超出限制
    MA_ALIAS_NOT_EXIST: 1012,         //别名不存在
    MA_CONTACT_NOT_EXIST: 1013,         //通讯录不存在
    MA_PARENT_CONTACT_NOT_EXIST: 1014,         //父通讯录不存在
    MA_DEL_CONTACT_NOT_PROMIT: 1015,         //存在子部门不允许删除
    MA_DEL_CONTACT_INFO_NOT_PROMIT: 1016,         //存在通讯录信息不允许删除
    MA_PARENT_CONTACT_NOT_PROMIT: 1017,         //父通讯录id不能设置成自己的子通讯录id
    MA_CORP_NOT_EXIST: 1018,         //企业不存在
    MA_CORP_ID_NOT_EXIST: 1019,         //企业id不存在
    MA_SPEC_NOT_EXIST: 1020,         //邮箱规格不存在
    MA_ADD_DEPART_ERROR: 1021,         //添加部门错误
    MA_RULE_NOT_EXIST: 1022,         //此规则不存在
    MA_CORPID_DEPARTID_NULL: 1023,         //部门id为空
    MA_DEL_DEPART_USER_EXIST: 1024,         //部门下存在用户不允许删除
    MA_USER_NOT_EXIST: 1025,         //用户不存在
    MA_LOGIN_RULE_TIME_ERROR: 1026,         //登录时间限制参数不完整
    MA_LOGIN_RULE_NOT_EXIST: 1027,         //登录限制规则不存在
    MA_LOGIN_RULE_EXIST: 1028,         //登录限制规则已存在
    MA_SPEC_BE_USED: 1029,         //邮箱规格关联了{}个企业，请先修改关联企业的邮箱规格。
    MA_BLACK_WHITE_LIST_NOT_EXIST: 1030,         //黑白名单不存在
    MA_PRIVILEGE_NOT_ALLOW_UPDATE: 1031,         //默认管理员权限组不允许修改
    MA_PRIVILEGE_NOT_EXIST: 1032,         //管理员权限组不存在
    MA_CORP_DOMAIN_EXIST: 1033,         //企业域名已存在
    MA_SPEC_IS_DEFAULT: 1034,         //默认邮箱规则不允许删除
    MA_UPLOAD_FILE_FAIL: 1035,         //上传文件失败
    MA_CORP_DOMAIN_NAME_NOT_EXIST: 1036,         //企业不存在主域名
    MA_CORP_WELCOME_EMAIL_EXIST: 1037,         //欢迎信已经存在，不能重复添加
    MA_CORP_WELCOME_EMAIL_NOT_EXIST: 1038,         //欢迎信不存在
    MA_DOMAIN_ALREADY_EXIST: 1039,         //企业域名已经存在
    MA_API_NOT_EXIST: 1040,         //API账号不存在
    MA_API_EXIST: 1041,         //本企业API规则已经存在，不能重复添加
    MA_MAIN_DOMAIN_ALREADY_EXIST: 1042,         //企业主域名已经存在
    MA_DOMAIN_USER_EXIST: 1043,         //域名下还有用户存在
    MA_MAIN_DOMAIN_NOT_DELETE: 1044,         //企业主域名不能删除
    MA_DOMAIN_NOT_EXIST: 1045,         //企业域名不存在
    MA_DEFAULT_DOMAIN_NOT_EXIST: 1046,         //企业默认域名不存在
    MA_SPEC_NAME_EXIST: 1047,         //邮箱规格名称重复
    MA_SPEC_USER_USED: 1048,         //邮箱规格有关联用户，不允许删除
    MA_SYS_ACCOUNT_NOT_DELETE: 1049,         //系统账号不允许禁用或删除
    MA_SPEC_MAX_SPACE_NOT_EXIST: 1050,         //邮箱规格最大空间不存在
    MA_PASSWORD_SAME_ERROR: 1051,         //新密码不能与原密码相同
    MA_MAX_SPACE_ERROR: 1052,         //邮箱最大空间数过小
    MA_CORP_USER_EXCEEDED_ERROR: 1053,         //企业人数超出最大限制，不允许添加用户
    MA_MANAGER_ADMIN_CANT_NOT_MODIFY: 1054,         //默认管理员不允许编辑
    MA_MANAGER_ADMIN_CANT_NOT_DELETE: 1055,         //默认管理员不允许删除
    MA_NO_PERMISSION_MODIFY_PRIVILEGE: 1056,         //没有权限操作此权限组
    MA_PRIVILEGE_BE_USED: 1057,         //此权限组有关联用户，禁止删除
    MA_DOMAIN_MX_VALIDATE_FAILED: 1058,         //域名解析未验证成功，请核对解析记录
    MA_TASK_ID_NOT_EXIST: 1059,         //批量任务Id不能为空
    MA_CORP_VIEW_NOT_EXIST: 1060,         //企业视图不存在
    MA_CORP_VIEW_IS_DEF: 1061,         //默认企业视图不允许删除
    MA_CORP_VIEW_USER_IS_NULL: 1062,         //视图成员不能为空
    MA_SPEC_MAX_SPACE_ERROR: 1063,         //邮箱规格最大空间数过小
    MA_DEPT_EXIST_SAME_NAME: 1064,         //同一级下存在相同部门名
    MA_EXCEL_PARSE_ERROR: 1065,         //入职日期格式不正确
    MA_POP_TEST_ERROR: 1067,         //登录POP服务器失败
    MA_IMAP_TEST_ERROR: 1068,         //登录IMAP服务器失败
    MA_MAX_SPACE_IS_NULL: 1069,         //邮箱最大空间不能为空
    MA_PWD_ERROR: 1070,         //密码错误
    MA_PRIVILEGE_IS_EXIST: 1071,         //管理员权限组名称已经存在
    MA_DOMAIN_IS_OTHERS: 1072,         //视图成员中存在非本企业域账号
    MA_BATCH_PARAM_NOT_EMPTY: 1073,         //批量参数不能为空
    MA_BATCH_TASK_LOCK_EXIST: 1074,         //存在正在执行的批量任务，请稍后重试
    MA_BATCH_DEPTPATH_TOOLONG: 1075,         //excel部门路径过长
    MA_DEPT_OVER_DEEP: 1076,         //部门层级过多
    MA_DEPT_NAME_INVALID: 1077,         //部门名称不合法
    MA_USER_EMAIL_INVALID: 1078,         //必填用户邮箱不合法
    MA_USER_NAME_INVALID: 1079,         //必填用户姓名不合法
    MA_USER_MOBILE_INVALID: 1080,         //用户手机不合法
    MA_USER_TEL_INVALID: 1081,         //用户座机不合法
    MA_USER_FAX_INVALID: 1082,         //用户传真不合法
    MA_USER_MEMO_INVALID: 1083,         //用户备注不合法
    MA_USER_EMPLOYEEID_INVALID: 1084,         //用户员工编号不合法
    MA_USER_POSITION_INVALID: 1085,         //用户职位不合法
    MA_USER_SCOPE_ACCOUNT_CANNOT_EMPTY: 1086,         //用户范围账号信息不能为空
    MA_INVALID_TEPMLATE_TYPE: 1087,         //不合法的模板类型
    MA_BATCH_SPEC_ERROR: 1088,         //邮箱规格填写错误
    MA_BATCH_TASK_OVER_LIMIT: 1089,         //excel文件中的数量超限
    MA_BLACK_EXIST: 1090,         //此地址已经存在黑名单
    MA_RULE_PWD_CYCLE: 1091,         //定期修改密码周期必须大于0
    MA_RULE_PWD_BEFORE: 1092,         //提醒周期不能大于或等于密码修改周期
    MA_RULE_PWD_REMIND: 1093,         //提醒频率不能大于或等于提醒周期
    MA_API_IS_EXIST: 1094,         //API账号名称重复
    MA_DEPT_MEMO_INVALID: 1095,         //部门描述不合法
    MA_AUDIT_NAME_EXIST: 1096,         //审核名称已经存在
    MA_FILTER_NAME_EXIST: 1097,         //分类过滤名称已经存在
    MA_RULE_SAME_NAME: 1098,         //存在相同名称的规则
    MA_API_SAME_NAME: 1099,         //存在相同名称的api
    MA_DEPT_NOT_EXIST: 1100,         //部门不存在
    MA_MEMBER_CORRECT_ERROR: 1101,         //地址填写有误,不支持填写邮箱别名、辅域名
    MA_DOMAIN_COUNT_OVERFLOW: 1102,         //域名数量超过上限
    MA_CORP_USER_NUM_SMALL: 1103,         //企业最大人数过小
    MA_LICENSE_EXPIRED: 1104,         //证书过期
    MA_MANAGER_NOT_DELETE_SELF: 1105,         //不允许删除自己
    MA_MANAGER_NOT_UPDATE_SELF: 1106,         //不允许修改自己
    MA_PRIVILEGE_EXIST: 1107,         //管理员已经存在
    MA_EXIST_FOREIGN_DOMAIN: 1108,         //禁止发送外域
    MA_END_LESS_LOOP_LIST: 1109,         //嵌套列表存在死循环
    MA_MAIL_LIST_NOT_EXIST: 1110,         //嵌套列表不存在
    MA_MAIN_DOMAIN_NOT_NULL: 1111,         //主域名信息不能为空
    MA_AUDITOR_ERROR: 1112,         //审核人不存在
    MA_AUDIT_MS_INDEX_ERROR: 1113,         //ms存审核索引报错
    MA_CORP_MAIL_DEL_EMAIL_INVALID: 1114,         //填写本企业下的主名邮箱地址
    MA_EMAIL_IS_OTHERS: 1115,         //视图范围仅支持填写本企业下的主名邮箱地址
    MA_AUDIT_MS_ERROR: 1116,         //审核原信解析失败
    MA_AUDIT_AUDITOR_ERROR: 1117,         //审核人不存在
    MA_AUDIT_MIME_ERROR: 1118,         //审核原信解析失败
    MA_MANAGER_LOG_SUCCESS: 1119,         //操作成功
    MA_MANAGER_LOG_ERROR: 1120,         //操作失败
    MA_CORP_USER_SPACE_ERROR: 1121,         //企业空间超出最大限制
    MA_CORP_MANAGER_NOT_DEL: 1122,         //管理员不能对自己进行操作，如果需要请联系上级管理员。
    MA_TOP_NOT_DEL: 1123,         //根节点不允许删除
    MA_TO_FOREIGN_DOMAIN: 1124,         //收件人包含非本企业用户
    MA_WHITE_EXIST: 1125,         //此地址已经存在白名单
    MA_CORP_VIEW_EXIST: 1126,         //视图名称重复
    MA_CORP_USER_LIMIT: 1127,         //企业人数超过授权人数，请重新输入或者联系超级管理员
    MA_MAIL_STATUS_ERROR: 1128,         //邮箱状态错误
    MA_IP_FORMAT_ERROR: 1129,         //IP格式错误
    MA_USER_ID_NULL: 1130,         //用户id不能为空
    MA_USER_ID_ERROR: 1131,         //用户id不合法
    MA_EXPIRE_TYPE_ERROR: 1132,         //账户到期执行动作错误
    MA_ALIAS_REPEAT_ERROR: 1133,         //别名重复
    MA_GROUP_NAME_NOT_NULL: 1134,         //外部联系人群组名称不能为空
    MA_GROUP_NOT_EXISTS: 1135,         //外部联系人群组不存在
    MA_BACKUP_MAIL_ACCOUNT_NOT_EXISTS: 1136,         //备份邮箱信息不存在
    MA_BACKUP_USER_INFO_NOT_EXISTS: 1137,         //备份用户信息不存在
    MA_BACKUP_USER_USED_INFO_NOT_EXISTS: 1138,         //备份邮箱使用情况不存在
    MA_MAIL_LIST_YOURSELF: 1139,         //嵌套列表不能是自己
    WM_READ_MAIL_NOT_EXIST: 2001,         //邮件不存在
    WM_READ_MAIL_NON_GARBAGE_MAIL_LINK_EXPIRED: 2002,         //非法请求或邮件链接已经过期
    WM_READ_MAIL_NON_GARBAGE_MAIL: 2003,         //此邮件已被移至收件夹，如果您是邮件客户端用户，请收取到本地查看
    WM_READ_MAIL_FOLDER_NOT_EXIST: 2004,         //文件夹不存在
    WM_READ_MAX_LIMIT: 2005,         //操作数据超过最大限制
    WM_READ_UN_ENCRYPT_MAIL_ERROR: 2006,         //非加密邮件
    WM_READ_DECRYPT_MAIL_ERROR: 2007,         //加密邮件解密失败
    WM_READ_NO_HAS_PASSWORD_ERROR: 2008,         //首次解密，前端未传入密码
    WM_READ_NO_PASSWORD_ERROR: 2009,         //查询密码失败
    WM_SEND_MAIL_ERROR: 2051,         //发信失败,请联系管理员
    WM_SEND_MAIL_BUILD_PARAM_ERROR: 2052,         //参数提交异常
    WM_SEND_MAIL_BUILD_ADDRESS_ERROR: 2053,         //发信地址格式错误
    WM_SEND_MAIL_OVER_SPACE_ERROR: 2054,         //发件人超容
    WM_SEND_MAIL_SENDER_FORBID_ERROR: 2055,         //发件人已被禁止发信
    WM_SEND_MAIL_ADDRESS_TO_MAX_LIMIT_ERROR: 2056,         //收件人数量不能超过{count}个
    WM_SEND_MAIL_ATTACHMENT_MAX_LIMIT_ERROR: 2057,         //普通附件总大小超过限制
    WM_SEND_MAIL_POSTMASTER_FORBIDDEN_ERROR: 2058,         //postmaster账号被禁用
    WM_SEND_MAIL_INNER_FILE_EXPIRE: 2059,         //编辑器内图片已过期，请重新上传
    WM_SEND_MAIL_ATTACH_FILE_EXPIRE: 2060,         //附件文件已过期，请重新上传
    WM_SEND_UNDO_MAIL_ERROR: 2061,         //撤回失败，请稍后重试
    WM_SEND_UNDO_MAIL_EXECUTED_ERROR: 2062,         //完成撤回
    WM_SEND_UNDO_MAIL_NO_SELF_ERROR: 2063,         //发件人非本系统邮箱，不支持撤回
    WM_SEND_UNDO_MAIL_EXPIRED_ERROR: 2064,         //撤回失败，邮件超过{undo_time_limit}或已被收件人删除
    WM_SEND_UNDO_MAIL_SEND_ALONE_ENCRYPT_ERROR: 2065,         //撤回失败，群发单显加密邮件暂不支持撤回
    WM_ATTACH_UPLOAD_FAIL: 2201,         //附件分片上传失败
    WM_INNER_FILE_UPLOAD_FAIL: 2202,         //内嵌文件上传失败
    WM_INNER_FILE_CONTENT_TYPE_FAIL: 2203,         //不支持的内嵌文件类型
    WM_INNER_FILE_TOO_LARGE_FAIL: 2204,         //内嵌文件太大
    WM_ATTACH_DOWNLOAD_FREQUENCY_FAIL: 2205,         //对不起，您下载次数过于频繁，请稍后再试
    WM_MAILACCOUNTSIGN_ERROR: 2251,         //最多可创建{sign_max}个邮件签名
    WM_MAILACCOUNTSIGN_SAVE_ERROR: 2252,         //内容格式有误
    WM_PASSWORD_SAME_ERROR: 2254,         //新密码不能与原密码相同
    WM_PASSWORD_SIMPLE_ERROR: 2256,         //新密码过于简单，请重新输入
    WM_PASSWORD_INVALID_ERROR: 2257,         //您输入的旧密码有误
    WM_PASSWORD_WEAK_ERROR: 2260,         //新密码不符合规则
    WM_CONTACT_ADDUSER_ERROR: 2301,         //联系人已存在
    WM_CONTACT_EMAILFORMAT_ERROR: 2302,         //邮箱格式不符合规范
    WM_CONTACT_EXPORTCONTACT_ERROR: 2303,         //导出联系人失败
    WM_CONTACT_FILEFORMAT_ERROR: 2304,         //文件格式不符合规范
    WM_CONTACT_IMPORTCONTACT_ERROR: 2305,         //要导入的联系人数据为空
    WM_CONTACT_GROUPNAME_ERROR: 2306,         //组名称已存在
    WM_CONTACT_COUNTMAX_ERROR: 2307,         //个人通讯录联系人数量不能超过{contact_max}
    WM_CONTACT_IMPORT_ERROR: 2308,         //导入联系人失败
    WM_CONTACT_GETEMAILLIST_ERROR: 2309,         //未查询到邮件列表信息
    WM_CONTACT_EMAILREPEAT_ERROR: 2310,         //主邮箱不可重复添加
    WM_CONTACT_NOTNULLITEM_ERROR: 2340,         //至少有一项不为空
    WM_CONTACT_GETSELECTORID_ERROR: 2341,         //邮件列表不存在
    WM_CONTACT_FILEMAX_ERROR: 2342,         //导入文件大小超过限制
    WM_CONTACT_FILETYPE_ERROR: 2343,         //暂不支持导入此文件类型
    WM_CONTACT_EMAIL_MAX_ERROR: 2344,         //邮箱最多可添加{user_contact_member_max}条
    WM_CONTACT_TELEPHONE_MAX_ERROR: 2345,         //电话最多可添加{user_contact_member_max}条
    WM_CONTACT_FAX_MAX_ERROR: 2346,         //传真最多可添加{user_contact_member_max}条
    WM_ACCOUNT_NOSETTING_ERROR: 2351,         //未查询到常规设置
    WM_ACCOUNT_UPDATE_ERROR: 2352,         //修改常规设置失败
    WM_ACCOUNT_CC_MAX_ERROR: 2353,         //默认抄送地址最多可添加{cc_email_max}条
    WM_ACCOUNT_BCC_MAX_ERROR: 2354,         //默认密送地址最多可添加{cc_email_max}条
    WM_BLACKLIST_MAXCOUNT_ERROR: 2401,         //黑名单最多可添加{black_list_max}条
    WM_BLACKLIST_EXICT_ERROR: 2402,         //您添加的黑名单已经存在!
    WM_AUTHCODE_USERNOTEXIST_ERROR: 2451,         //账号信息不存在
    WM_AUTHCODE_MAXCOUNT_ERROR: 2452,         //授权码最多可添加{client_code_max}条
    WM_ANTISPAM_NODEF_ERROR: 2501,         //未查询到反垃圾设置
    WM_ANTISPAM_SAVEREDIS_ERROR: 2502,         //系统异常,请稍后重试
    WM_ANTISPAM_REMINDER_ERROR: 2503,         //时间不能为空,请设置提醒时间
    WM_POP_EMAILCOUNT_ERROR: 2551,         //POP邮箱已存在，请勿重复添加
    WM_POP_EMAILCOUNT_MAX_ERROR: 2552,         //POP邮箱最多添加{pop_email_max}个
    WM_POP_EMAIL_FORMAT_ERROR: 2553,         //邮箱格式不正确
    WM_POP_AUTH_ERROR: 2554,         //POP邮箱账号验证失败!请检查设置
    WM_POP_FOLDER_ERROR: 2555,         //存放至文件夹不存在
    WM_POP_RETR_ERROR: 2556,         //POP邮箱账号验证失败!请检查设置
    WM_DELIVER_EMAIL_ERROR: 2601,         //邮箱格式有误，示例：name@example.com
    WM_DELIVER_DISABLE_ERROR: 2602,         //自动转发与回复设置发禁止修改，如有问题请及时联系管理员
    WM_DELIVER_FOREIGN_ERROR: 2603,         //禁止转发到外域
    WM_DELIVER_ADDRMAX_ERROR: 2604,         //自动转发地址最多可添加{forward_addr_max}个
    WM_DELIVER_FORWARDADDR_ERROR: 2605,         //禁止添加自己的邮箱
    WM_FILTER_MAXCOUNT_ERROR: 2651,         //分类过滤规则最多可添加{filter_rule_max}个
    WM_FILTER_NAMESAME_ERROR: 2652,         //分类过滤规则名字已存在
    WM_FILTER_FOLDER_ERROR: 2653,         //指定文件夹不存在
    WM_FILTER_FROM_MEMBER_ERROR: 2654,         //发件人最多可添加{filter_member_max}个
    WM_FILTER_TO_MEMBER_ERROR: 2655,         //收件人最多可添加{filter_member_max}个
    WM_LARGE_FILE_NOT_FOUND_ERROR: 2701,         //文件不存在
    WM_AUDIT_MAIL_STATUS_FINISH: 2751,         //邮件审核已完成
    WM_FOLDER_NAME_MAX_LIMIT: 2801,         //文件夹名称长度超出限制
    WM_FOLDER_UNIQ_KEY_ERROR: 2802,         //可能存在同名文件夹
    WM_SMTP_512_1: 2851,         //邮件日发送数量超限
    WM_SMTP_512_2: 2852,         //发件人在收件人{invalidAddress}的黑名单中
    WM_SMTP_513: 2853,         //禁止向无权限的邮件列表发信
    WM_SMTP_515: 2854,         //发件人在{invalidAddress}黑名单中
    WM_SMTP_535: 2855,         //域或用户被禁用
    WM_SMTP_550_1: 2856,         //用户{invalidAddress}不存在
    WM_SMTP_550_2: 2857,         //用户{invalidAddress}已锁定
    WM_SMTP_552: 2858,         //禁止发送邮件
    WM_SMTP_554: 2859,         //禁止发送到外域邮箱{invalidAddress}
    WM_SMTP_555: 2860,         //禁止发送到指定域或用户{invalidAddress}
    WM_SMTP_556: 2861,         //不允许发送到以下地址{invalidAddress}
    WM_SMTP_557: 2862,         //收件人数量超限
    WM_SMTP_558: 2863,         //{invalidAddress}禁止接收外域邮箱发来的邮件
    WM_SMTP_559_1: 2864,         //邮件大小超过角色上限
    WM_SMTP_559_2: 2865,         //邮件大小超过系统上限
    WM_SMTP_573: 2866,         //用户{invalidAddress}邮箱容量超限
    WM_SMTP_598: 2867,         //主题或内容中包含关键字，禁止发送
    WM_SMTP_599: 2868,         //疑似钓鱼邮件，禁止发送
    WM_TRUST_LOCATION_MAX_ERROR: 2901,         //手动添加信任地最多可添加{trust_location_manual_max}个
    WM_BIND_PHONE_MAX_ERROR: 2902,         //此手机号码绑定邮箱个数已达上限
    WM_SAFE_LOGIN_BIND_INFO_NOT_EXSIT: 2903,         //当前用户未绑定此手机号
    UDCD_PERMISSION_DENIED: 3001,         //无权限
    UDCD_AUTHENTICATION_ERROR: 3002,         //认证失败
    UDR_CORP_NOT_FOUND: 3101,         //客户不存在
    UDR_CORP_FORBIDDEN: 3102,         //客户已被禁用
    UDR_MAIL_CORP_FORBIDDEN: 3106,         //企业已被禁用
    UDR_MAIL_ACCOUNT_FORBIDDEN: 3107,         //用户已被禁用
    UDR_API_USER_NOT_FOUND: 3108,         //接口ID不存在或密钥错误
    UDR_API_USER_FORBIDDEN: 3109,         //该应用已被禁用
    UDR_API_IP_ERROR: 3110,         //不允许该ip登录
    UDR_API_WEB_ERROR: 3111,         //不允许Web登录
    UDR_REFRESH_TOKEN_ERROR: 3112,         //刷新token不存在
    UDR_USER_PASSWORD_ERROR: 3113,         //用户名或密码错误
    UDR_USER_PASSWORD_LOCK_ERROR: 3114,         //用户名密码错误次数过多，已被临时锁定，请稍后再试或联系管理员修改密码
    UDR_USER_PASSWORD_FIRST_ERROR: 3115,         //用户首次修改密码
    UDR_USER_PASSWORD_CYCLE_ERROR: 3116,         //用户定期修改密码
    UDR_USER_PASSWORD_WEAK_ERROR: 3117,         //新密码过于简单，请重新输入
    UDR_USER_IP_LIMITED_ERROR: 3118,         //登录IP被限制
    UDR_USER_TIME_LIMITED_ERROR: 3119,         //登录时间被限制
    UDR_USER_LOGIN_SUCCESS: 3120,         //登录成功
    UDR_CORP_NOT_EXIST: 3121,         //企业不存在
    UDR_CORP_STATUS_ERROR: 3122,         //企业已被删除
    UDR_CORP_EXPIRE_ERROR: 3123,         //企业已到期
    UDR_API_SSL_ERROR: 3124,         //只允许ssl登录
    UDR_API_POP_ERROR: 3125,         //不允许POP登录
    UDR_API_IMAP_ERROR: 3126,         //不允许IMAP登录
    UDR_API_SMTP_ERROR: 3127,         //不允许SMTP登录
    UDR_USER_AUTHCODE_ERROR: 3128,         //客户端授权码认证失败
    UDR_MANAGER_FORBIDDEN: 3129,         //管理员已被禁用
    UDR_CORP_ID_NOT_FOUND: 3141,         //企业ID不存在
    UDR_DOMIAN_ID_NOT_FOUND: 3142,         //域名ID不存在
    UDR_DOMIAN_NOT_FOUND: 3143,         //域名不存在
    UDR_USER_ID_NOT_FOUND: 3144,         //用户ID不存在
    UDR_USER_EMAIL_NOT_FOUND: 3145,         //用户不存在
    UDR_MAIL_ACCOUNT_ID_NOT_FOUND: 3146,         //邮箱帐号ID不存在
    UDR_MAIL_ACCOUNT_EMAIL_NOT_FOUND: 3147,         //邮箱不存在
    UDR_MEMBER_SELECTOR_ID_NOT_FOUND: 3148,         //地址不存在
    UDR_PWD_DECRYPT_ERROR: 3149,         //用户名或密码错误
    UDR_USER_LOCATION_LIMITED_ERROR: 3150,         //登录地区被限制
    UDR_SSO_TIMESTAMP_ERROR: 3151,         //时间戳不合法
    UDR_SSO_API_ERROR: 3152,         //接口信息不存在
    UDR_SSO_INTERFACE_ERROR: 3153,         //无接口权限
    UDR_SSO_SIGN_ERROR: 3154,         //签名不合法
    UDR_SSO_PARTNER_ERROR: 3155,         //企业无此接口权限
    UDR_SSO_GETUSERINFO_ERROR: 3156,         //获取用户信息错误
    UDR_SSO_EMAIL_ERROR: 3157,         //账号异常
    UDR_SSO_EMAILBIND_ERROR: 3158,         //此邮箱已绑定
    UDR_SSO_BIND_ERROR: 3159,         //不可绑定多个邮箱
    UDR_SSO_USERINFO_ERROR: 3160,         //用户信息不合法
    UDR_SSO_INFO_ERROR: 3161,         //应用配置信息不合法
    UDR_SSO_REDIRECT_ERROR: 3162,         //应用重定向失败
    UDR_SSO_READMSG_ERROR: 3163,         //打开邮件失败，邮件收件人与绑定邮箱不一致
    UDR_SSO_BINDED_ERROR: 3164,         //此邮箱已绑定用户
    UDR_SSO_BIND_RELATION_ERROR: 3165,         //用户未绑定邮箱
    UDR_SSO_EVENT_EMAIL_ERROR: 3166,         //用户邮箱为空
    UDR_SSO_EVENT_EMAIL_DOMAIN: 3167,         //用户邮箱域名不合法
    UDR_SSO_EVENT_PARENTDEP_ERROR: 3168,         //未查询到父级部门
    UDR_SSO_EVENT_BIND_ERROR: 3169,         //此邮箱已存在绑定关系
    UDR_SSO_EVENT_USER_API_ERROR: 3170,         //调用ma创建用户失败
    UDR_SSO_EVENT_DEP_ERROR: 3171,         //未查询到部门信息
    UDR_SSO_GETMATOKEN_ERROR: 3172,         //获取ma接口token失败
    UDR_SSO_EVENT_FSDEP_ERROR: 3173,         //事件未返回部门信息
    UDR_SECURE_LOGIN: 3174,         //需要用户进行二次验证登录
    FS_VOLUME_INFO_NOT_FOUND: 4001,         //未获取到卷信息
    FS_FILE_NOT_FOUND: 4010,         //未发现文件
    FS_FILE_ID_INVALID: 4012,         //文件ID无效
    FS_FILE_STATUS_INVALID: 4013,         //文件状态无效
    FS_FILE_MIME_NOT_FOUND: 4014,         //
    FS_FILE_GET_FAIL: 4021,         //您查看的邮件已不存在
    FS_FILE_GET_INVALID_POS_SIZE: 4023,         //获取文件指定偏移量及长度无效
    FS_FILE_SAVE_FAIL: 4031,         //保存文件失败
    FS_FILE_SAVE_EXIST: 4032,         //保存文件已经存在
    FS_FILE_UPLOAD_FAIL: 4033,         //文件上传失败
    FS_FILE_UPLOAD_CHUNK_CHECK_FAIL: 4034,         //文件上传分片校验失败
    FS_FILE_DOWNLOAD_FAIL: 4037,         //对不起，您访问的链接已经过期或者失效!
    FS_FILE_DEL_FAIL: 4039,         //删除文件失败
    FS_FILE_HEAD_NOT_FOUND: 4041,         //存储文件没有发现头信息
    FS_FILE_HEAD_INVALID: 4042,         //存储文件头信息无效
    FS_FILE_CHUNK_SIZE_INVALID: 4053,         //存储文件分片长度无效
    FS_MAIL_ACCOUNT_FILE_ID_INVALID: 4062,         //邮箱帐号文件ID无效
    FS_MAIL_ACCOUNT_FILE_STATUS_INVALID: 4063,         //邮箱帐号文件状态无效
    MS_GET_MAIL_HEADER: 4101,         //获取信头失败
    MS_CORP_INVALID: 4102,         //企业无效
    MS_CORP_ID_INVALID: 4103,         //企业ID无效
    MS_CORP_EXIST: 4104,         //企业存在
    MS_MAIL_ACCOUNT_INVALID: 4105,         //邮箱帐号无效
    MS_MAIL_ACCOUNT_ID_INVALID: 4106,         //邮箱帐号ID无效
    MS_MAIL_ACCOUNT_EXIST: 4107,         //邮箱帐号存在
    MS_FOLDER_INVALID: 4111,         //文件夹无效
    MS_FOLDER_ID_INVALID: 4112,         //文件夹ID无效
    MS_FOLDER_EXIST: 4113,         //存在同名文件夹
    MS_FOLDER_NOT_EXIST: 4114,         //文件夹不存在
    MS_FOLDER_INVALID_PARENT: 4115,         //无效的父文件夹
    MS_FOLDER_DATA_INVALID: 4116,         //文件夹空间占用标记不一致
    MS_FOLDER_DEPTH_MAX_LIMIT: 4121,         //文件夹层级超限
    MS_FOLDER_COUNT_MAX_LIMIT: 4122,         //文件夹数量超限
    MS_FOLDER_DENY_CHANGE_SYS_FOLDER: 4131,         //不能修改系统文件夹
    MS_FOLDER_BACKUP_CREATE_SUBFOLDER: 4132,         //不能在已备份文件夹中创建文件夹
    MS_FOLDER_DENY_DEL_SYS_FOLDER: 4133,         //不能删除系统文件夹
    MS_FOLDER_DENY_DEL_MAIL_EXIST: 4134,         //文件夹内存在邮件， 故不能删除
    MS_FOLDER_DENY_DEL_SUBFOLDER_EXISTED: 4135,         //文件夹存在子文件夹，故不能删除
    MS_INDEX_PROC_FAIL: 4201,         //邮件索引处理失败
    MS_INDEX_INVALID: 4202,         //邮件索引无效
    MS_INDEX_ID_INVALID: 4203,         //邮件索引ID无效
    MS_INDEX_NOT_FOUND: 4204,         //邮件索引未发现
    MS_INDEX_OVER_SPACE_LIMIT: 4221,         //邮箱容量超限
    MS_INDEX_OVER_NUM_LIMIT: 4222,         //用户邮箱封数超容
    MS_INDEX_VERIFY_PASSWORD_FAIL: 4231,         //密码验证失败
    NOTIFIER_SMS_SEND_FAIL: 5001,         //短信发送失败
    NOTIFIER_SMS_TEMPLATE_NOT_FOUND: 5002,         //短信模板不存在
    NOTIFIER_CODE_ERROR: 5003,         //验证码无效或已过期
    NOTIFIER_CAN_NOT_NULL: 5004,         //验证码不能为空
    NOTIFIER_CODE_LIMIT_ERROR: 5005,         //获取验证码过于频繁
    NOTIFIER_MD_SERVER_ERROR: 5006,         //短信通道拥堵，请稍后再试！
    NOTIFIER_MD_SEND_ERROR: 5007,         //漫道发送短信失败
    NOTIFIER_CODE_DAY_LIMIT_ERROR: 5008,         //当日获取验证码次数已达上限
    SCHEDULE_FEIGN_MS_FAIL: 6001,         //调用ms失败
    PUSH_MESSAGE_BUILDMSG_ERROR: 7001,         //组装消息内容失败
    ATTACH_TRANSFER_FILE_ERROR: 8001,         //文件转换失败
    SYSTEM_CONFIG_INFO_ERROR: 9001,         //系统配置信息异常
    LICENSE_JSON_DEVICE_INFO: 9100,         //未查询到有效的许可证文件
    LICENSE_JSON_LICENSE: 9101,         //未查询到有效的许可证文件
    LICENSE_JSON_BOSS_CONTRACTS: 9102,         //未查询到有效的许可证文件
    LICENSE_JSON_DEVICE_INFOS: 9103,         //未查询到有效的许可证文件
    LICENSE_JSON_UPDATE: 9104,         //未查询到有效的许可证文件
    LICENSE_JSON_LICENSE_INCOMPLETE: 9105,         //未查询到有效的许可证文件
    LICENSE_RSA_PRI_NULL: 9120,         //未查询到有效的许可证文件
    LICENSE_RSA_PUB_NULL: 9121,         //未查询到有效的许可证文件
    LICENSE_RSA_PUBLIC_ENCRYPT: 9122,         //未查询到有效的许可证文件
    LICENSE_RSA_PUBLIC_DECRYPT: 9123,         //未查询到有效的许可证文件
    LICENSE_RSA_PRIVATE_ENCRYPT: 9124,         //未查询到有效的许可证文件
    LICENSE_RSA_PRIVATE_DECRYPT: 9125,         //未查询到有效的许可证文件
    LICENSE_AES_KEY: 9130,         //未查询到有效的许可证文件
    LICENSE_PACK_START_END_LINE: 9140,         //未查询到有效的许可证文件
    LICENSE_PACK_DATA_SIZE: 9141,         //未查询到有效的许可证文件
    LICENSE_PACK_DATA_SIZE_RSA: 9142,         //未查询到有效的许可证文件
    LICENSE_PACK_DATA_FALSIFIED: 9143,         //未查询到有效的许可证文件
    LICENSE_DEVICE_INFOS_DATA_SIZE: 9150,         //未查询到有效的许可证文件
    LICENSE_DEVICE_ID_DISMATCH: 9151,         //未查询到有效的许可证文件
    LICENSE_DEVICE_INFO_INCOMPLETE: 9152,         //未查询到有效的许可证文件
    LICENSE_DEVICE_INFOS_EMPTY: 9153,         //未查询到有效的许可证文件
    LICENSE_DEVICE_GET_INFO: 9154,         //未查询到有效的许可证文件
    LICENSE_TIME_UPDATE: 9160,         //未查询到有效的许可证文件
    LICENSE_TIME_PURCHASE: 9161,         //未查询到有效的许可证文件
    LICENSE_TIME_EXPIRY: 9162,         //未查询到有效的许可证文件
    LICENSE_TIME_NULL: 9163,         //未查询到有效的许可证文件
    LICENSE_TIME_EXPIRED: 9164,         //未查询到有效的许可证文件
    LICENSE_REDIS_HOST_STR: 9170,         //未查询到有效的许可证文件
    LICENSE_REDIS_HSET: 9171,         //未查询到有效的许可证文件
    LICENSE_REDIS_HGET: 9172,         //未查询到有效的许可证文件
    LICENSE_IMPORT_ERROR: 9180,         //许可证导入失败
    LICENSE_UNKNOWN_ERROR: 9199,         //许可证失败
    UMT_AUTH_ERR: 9200,         //认证失败
    UMT_PARAMETER_ERR: 9201,         //参数失败
    UMT_ACL_ERR: 9203,         //acl异常
    UMT_LIST_FOLDER_ERR: 9204,         //查询文件夹失败
    UMT_ADD_FOLDER_ERR: 9205,         //添加文件夹异常
    UMT_SAVE_EMAIL_ERR: 9206,         //ms存信异常
    UMT_IMAP_ERR: 9207,         //imap异常
    UMT_POP_ERR: 9217,         //pop异常
    UMT_UNKNOWN_ERROR: 9299,         //搬家异常
    MIDS_SYSTEM_ERROR: 9300,         //系统异常
    MIGRATE_ERROR_PARAMERROR: -100,         //参数错误
    MIGRATE_ERROR_PASSWDERROR: -101,         //测试账号验证失败，请检查服务器信息和测试账号及密码
    MIGRATE_ERR_OR_NETERROR: -102,         //网络错误
    UN_SUPPORT: 9999,         //功能尚未支持，敬请期待!
    LAST_ERROR: 10000,         //last error
};

//
xmail.enums.ExportType = {
    CSV: 1,         //CSV格式
    VCF: 2,         //VCF格式
};

// 邮件存储信息表表（file_info）- 字段编号枚举
xmail.enums.FileInfoField = {
    ID: 3719,         //
    FILE_ID: 28684,         //文件ID
    STATUS: 91903,         //状态|file_info_status|NORMAL(1, 正常 ),WAIT_DEL(2,  待删除 ),DELETED(3,  已删除 ),UPLOADING(4, 上传中 ),UPLOAD_FAIL(5, 失败 )
    FILE_SIZE: 30987,         //文件字节数
    MD5: 31524,         //文件摘要值
    REFERENCE_COUNT: 62392,         //文件引用计数
    CREATE_TIME: 82559,         //创建时间
    UPDATE_TIME: 77635,         //修改时间
    VOLUME_ID: 90986,         //文件卷ID
    SYS_DEF: 19271,         //文件是否是系统默认
    PATH: 84216,         //相对路径（不包括卷目录） /000/fff/file_id
};

// 状态
xmail.enums.FileInfoStatus = {
    UNKNOWN: 0,         //UNKNOWN
    NORMAL: 1,         //正常
    WAIT_DEL: 2,         //待删除
    DELETED: 3,         //已删除
    UPLOADING: 4,         //上传中
    UPLOAD_FAIL: 5,         //失败
};

// 卷信息表（file_volume_info）- 字段编号枚举
xmail.enums.FileVolumeInfoField = {
    ID: 3719,         //
    VOLUME_ID: 90986,         //文件卷ID
    PATH: 84216,         //文件卷Mount点路径 （列如： /data/v01/）
    WEIGHT: 14411,         //写入权重（0表示不能写入； 值越大表示有空闲空间可以保存）
    STATUS: 91903,         //状态|file_volume_info_status|NORMAL(1, 正常 ),DISABLE(2, 禁用 )
    CREATE_TIME: 82559,         //创建时间
    UPDATE_TIME: 77635,         //修改时间
};

// 状态
xmail.enums.FileVolumeInfoStatus = {
    UNKNOWN: 0,         //UNKNOWN
    NORMAL: 1,         //正常
    DISABLE: 2,         //禁用
};

// 执行条件
xmail.enums.FilterCondType = {
    UNKNOWN: 0,         //UNKNOWN
    ALL: 1,         //满足所有
    ANY: 2,         //满足任一
};

// 相应操作
xmail.enums.FilterExecuteOptType = {
    UNKNOWN: 0,         //UNKNOWN
    DELETE: 1,         //删除邮件
    FORWARD: 2,         //转发至
    DEL_FORWARD: 3,         //删除并转发至
    SAFETIP: 4,         //添加安全提示
    RUN: 5,         //执行以下操作
    BOUNCE: 6,         //退信
};

// 规则状态
xmail.enums.FilterInfoStatus = {
    UNKNOWN: 0,         //UNKNOWN
    ENABLE: 1,         //启用
    DISABLE: 2,         //禁用
};

//
xmail.enums.FilterPriorityType = {
    MOVE_UP: 1,         //上移
    MOVE_DOWN: 2,         //下移
};

// 安全提示样式
xmail.enums.FilterSafeTipType = {
    UNKNOWN: 0,         //UNKNOWN
    DEFAULT: 1,         //默认样式
    CUSTOM: 2,         //自定义样式
};

// 执行范围
xmail.enums.FilterScopeType = {
    UNKNOWN: 0,         //UNKNOWN
    SEND: 1,         //发信阶段
    RECIVE: 2,         //收信阶段
    SENDRECIVE: 3,         //收信和发信阶段
};

//
xmail.enums.FolderType = {
    RECEIVE_BOX_FOLDER_ID: 1,         //收件箱
    SEND_BOX_FOLDER_ID: 2,         //发件箱
    GARBAGE_BOX_FOLDER_ID: 3,         //已删除
    DRAFT_BOX_FOLDER_ID: 4,         //草稿箱
    GARBAGE_MAIL_BOX_FOLDER_ID: 5,         //垃圾箱
    ARCHIVE_BOX_FOLDER_ID: 10,         //归档文件夹
    BACKUP_BOX_FOLDER_ID: 16,         //备份文件夹
    STAR_BOX_FOLDER_ID: 64,         //星标邮件
    WAITING_BOX_FOLDER_ID: 65,         //待办邮件
};

// 性别
xmail.enums.Gender = {
    UNKNOWN: 0,         //UNKNOWN
    MALE: 1,         //男性
    FEMALE: 2,         //女性
};

//
xmail.enums.GreetingType = {
    HOWDY: 1,         //您好!
    DEEPNIGHT: 2,         //夜深了，早休息!
    MORNING: 3,         //早上好！
    FORENOON: 4,         //上午好！
    AFTERNOON: 5,         //下午好！
    NIGHT: 6,         //晚上好！
};

//
xmail.enums.ImapArchiveFolderType = {
    UNKNOWN: 0,         //未定义
    HIDDEN_ALL: 1,         //隐藏归档文件夹
    HIDDEN_UNSUBSCRIBED: 2,         //仅隐藏未订阅的归档文件夹
};

//
xmail.enums.InnerFileType = {
    IMG: 1,         //image/jpeg
    GIF: 2,         //image/gif
    PNG: 3,         //image/png
    FLASH: 4,         //application/x-shockwave-flash
};

// 语言
xmail.enums.Language = {
    UNKNOWN: 0,         //UNKNOWN
    CN: 1,         //中文简体
    HK: 2,         //中文繁体
    EN: 3,         //英文
    JP: 4,         //日语
    KR: 5,         //韩语
};

//
xmail.enums.LanguageType = {
    cn: 1,         //中文
    en: 2,         //英文
};

// 窗口布局
xmail.enums.Layout = {
    UNKNOWN: 0,         //UNKNOWN
    LR: 1,         //左右布局
    LIST: 2,         //列表布局
};

//
xmail.enums.LicenseVerifyResultType = {
    UNKNOWN: 0,         //未查询到有效的许可证文件
    VALID: 1,         //许可证有效
    NOT_FOUND: 2,         //未查询到有效的许可证文件
    PARSE_ERROR: 3,         //未查询到有效的许可证文件
    EXPIRED: 4,         //许可证已过期
    DEVICE_ID_DISMATCH: 5,         //当前主机不在许可证授权的主机列表中
};

// 删除日志表（log_delete）- 字段编号枚举
xmail.enums.LogDeleteField = {
    ID: 3719,         //主键
    CORP_ID: 16757,         //企业id
    MAIL_ACCOUNT_ID: 91885,         //邮件账号ID
    MAIL_FROM: 9793,         //发信人（信头）
    SENDER: 45755,         //发信人
    REAL_SENDER: 80025,         //发信人（smtp登录名）
    PRIME_SENDER: 9193,         //发信人（smtp登录名的主名）
    MAIL_TO: 33648,         //收件人（信头）
    MAIL_SIZE: 44383,         //邮件尺寸(字节数)
    CLIENT_TYPE: 74401,         //客户端类型|client_type|MA(1,  ma ),WM_PC(2,  WEB_PC ),WM_MOBILE(12,  WEB_MOBILE ),SYS_MANAGER_PC(13, super_ma ),POP(3,  pop ),IMAP(4,  imap ),SMTP(5,  smtp ),EAS(6,  eas ),UMT(7,  umt ),API(8,  接口 ),UBD(10,  ubd ),UDUTIL(11,  ud工具 ),SCHEDULE(14, 定时任务 ),CALWEB(15, 日程 ),SSO_PC(16, SSO_PC ),SSO_MOBILE(17, SSO_MOBILE );
    OPERATE_IP: 72444,         //操作IP
    OPERATE_TIME: 41374,         //操作时间
    OPERATE_EMAIL: 69521,         //操作人邮件地址
    OPERATE_DEPART_NAME: 47771,         //操作人部门名字（全路径）
    OPERATE_NAME: 5828,         //操作人名字
    USER_EMAIL: 11187,         //被操作人邮件地址
    FOLDER_NAME: 98268,         //文件夹名字
    DEPART_NAME: 62910,         //被操作人部门名字（全路径）
    SUBJECT: 8685,         //邮件主题
};

// 投递状态日志表（log_deliver）- 字段编号枚举
xmail.enums.LogDeliverField = {
    ID: 3719,         //
    MAIL_DELIVER_ID: 92172,         //邮件投递状态跟踪id
    RCPT_TO: 80507,         //收信人（真实）
    STATUS: 91903,         //投递状态|deliver_status|RECENT(1,  recent ),SERVER(3,  server );
};

// 登录日志表（log_login）- 字段编号枚举
xmail.enums.LogLoginField = {
    ID: 3719,         //主键
    CORP_ID: 16757,         //企业id
    MAIL_ACCOUNT_ID: 91885,         //邮件账号ID
    USER_EMAIL: 11187,         //邮箱地址
    IP: 83688,         //登录IP
    LOGIN_TIME: 80693,         //登录时间
    STATUS: 91903,         //登录结果|login_status|SUCCESS(1,  success ),FAIL(2,  fail );
    CODE: 35189,         //错误码
    DEPART_NAME: 62910,         //部门名字（全路径）
    CLIENT_TYPE: 74401,         //客户端类型|client_type|MA(1,  ma ),WM_PC(2,  WEB_PC ),WM_MOBILE(12,  WEB_MOBILE ),SYS_MANAGER_PC(13, super_ma ),POP(3,  pop ),IMAP(4,  imap ),SMTP(5,  smtp ),EAS(6,  eas ),UMT(7,  umt ),API(8,  接口 ),UBD(10,  ubd ),UDUTIL(11,  ud工具 ),SCHEDULE(14, 定时任务 ),CALWEB(15, 日程 ),SSO_PC(16, SSO_PC ),SSO_MOBILE(17, SSO_MOBILE );
    AREA_CODE: 97329,         //修改ip隶属国家码-省份码-城市码
    REMOTE_LOGIN_FLAG: 26457,         //是否异地登录
    OPERATE_NAME: 5828,         //操作人名字
    MEMO: 67825,         //
};

//
xmail.enums.LogMailDeliverType = {
    UNKNOWN: 0,         //UNKNOWN
    SEND: 1,         //发信
    RECEIVE: 2,         //收信
    DELETE: 3,         //删信
};

// 收信日志表（log_receive）- 字段编号枚举
xmail.enums.LogReceiveField = {
    ID: 3719,         //主键
    CORP_ID: 16757,         //企业id
    MAIL_ACCOUNT_ID: 91885,         //邮件账号ID
    MAIL_INDEX_ID: 4635,         //索引ID
    USER_EMAIL: 11187,         //用户邮箱
    MAIL_FROM: 9793,         //发信人（信头）
    SENDER: 45755,         //发信人
    REAL_SENDER: 80025,         //发信人（smtp登录名）
    PRIME_SENDER: 9193,         //发信人（smtp登录名的主名）
    MAIL_TO: 33648,         //收件人(信头)
    MAIL_SIZE: 44383,         //邮件尺寸(字节数)
    RECEIVE_TIME: 22718,         //收信时间
    SUBJECT: 8685,         //邮件主题
    FOLDER_NAME: 98268,         //文件夹名字
    FOREIGN_DOMAIN: 53421,         //是否是外域
    ATTACH_COUNT: 88056,         //附件数量
    ATTACH_NAMES: 90429,         //附件名称
    DEPART_NAME: 62910,         //部门名字（全路径）
    OPERATE_NAME: 5828,         //操作人名字
};

// 发信日志表（log_send）- 字段编号枚举
xmail.enums.LogSendField = {
    ID: 3719,         //主键
    CORP_ID: 16757,         //企业id
    MAIL_ACCOUNT_ID: 91885,         //邮件账号ID
    USER_EMAIL: 11187,         //用户邮箱
    OPERATE_NAME: 5828,         //操作人名字
    DEPART_NAME: 62910,         //部门名字（全路径）
    MAIL_DELIVER_ID: 92172,         //邮件投递状态跟踪id
    MAIL_FROM: 9793,         //发信人（主名）
    SENDER: 45755,         //
    REAL_SENDER: 80025,         //发信人（smtp登录名）
    PRIME_SENDER: 9193,         //发信人（smtp登录名的主名）
    RCPT_TO: 80507,         //收信人（真实）
    SEND_TIME: 54732,         //发信时间
    SEND_IP: 38765,         //发信IP
    SEND_TYPE: 89539,         //发信类型|log_send_type|PC(1, 网页版邮箱 ),CLIENT(2, 客户端 ),MOBILE(3, 手机版WM ),AUTOFORWARD(4, 自动转发 ),AUTOREPLY(5, 自动回复 );
    MAIL_SIZE: 44383,         //邮件大小
    ATTACH_COUNT: 88056,         //附件数量
    ATTACH_NAMES: 90429,         //附件名称
    SUBJECT: 8685,         //邮件主题
    FOREIGN_DOMAIN: 53421,         //是否是外域
};

// 发信类型
xmail.enums.LogSendType = {
    UNKNOWN: 0,         //UNKNOWN
    PC: 1,         //网页版邮箱
    CLIENT: 2,         //客户端
    MOBILE: 3,         //手机版WM
    AUTOFORWARD: 4,         //自动转发
    AUTOREPLY: 5,         //自动回复
};

// 邮件流量统计表（log_statistic）- 字段编号枚举
xmail.enums.LogStatisticField = {
    ID: 3719,         //
    CORP_ID: 16757,         //企业id
    MAIL_ACCOUNT_ID: 91885,         //邮箱账号id
    USER_EMAIL: 11187,         //邮箱地址（主名主域）
    RECV_TOTAL_NUM: 31973,         //接收邮件数量
    RECV_FOREIGN_NUM: 54478,         //接收外域邮件数量
    SEND_TOTAL_NUM: 78576,         //发送邮件数量
    SEND_FOREIGN_NUM: 27885,         //发送外域邮件数量
    RECV_TOTAL_SIZE: 64438,         //接收邮件大小
    RECV_FOREIGN_SIZE: 12079,         //接收外域邮件大小
    SEND_TOTAL_SIZE: 33991,         //发送邮件大小
    SEND_FOREIGN_SIZE: 55813,         //发送外域邮件大小
    DOMAIN_NAME: 3260,         //域名
    STATISTICAL_TIME: 81215,         //统计日期（YYYY-mm-dd)）
    CREATE_TIME: 82559,         //创建时间
    UPDATE_TIME: 77635,         //更新时间
};

// 登录后默认显示
xmail.enums.LoginRouterPage = {
    UNKNOWN: 0,         //UNKNOWN
    HOME: 1,         //首页
    INBOX: 2,         //收件箱
};

// 登录结果
xmail.enums.LoginStatus = {
    UNKNOWN: 0,         //UNKNOWN
    SUCCESS: 1,         //SUCCESS
    FAIL: 2,         //FAIL
};

//
xmail.enums.LoginTokenType = {
    UNKNOWN: 0,         //UNKNOWN
    PASSWORD: 1,         //密码登录
    SSO_OA: 2,         //单点登录（企业OA）
    SSO_INTERNAL: 3,         //单点登录（内部）
    ADMIN: 4,         //管理员跳转
};

// 标记垃圾邮件类别
xmail.enums.MailAbsType = {
    UNKNOWN: 0,         //UNKNOWN
    NORMAL: 1,         //正常
    SPAM: 2,         //垃圾
    DOMAIN_INTERNAL: 3,         //同域
    DOMAIN_WHITELIST: 4,         //域白名单
};

// 个人反垃圾设置表（mail_account_antispam_info）- 字段编号枚举
xmail.enums.MailAccountAntispamInfoField = {
    ID: 3719,         //
    MAIL_ACCOUNT_ID: 91885,         //邮箱账号id
    CORP_ID: 16757,         //企业id
    SPAM_LEVEL: 88364,         //反垃圾级别|spam_level|IGNORE(1,  不过滤 ),LOW(2,  低级 ),MEDIUM_LOW(3,  中低 ),MEDIUM(4,  中级 ),MEDIUM_HIGH(5,  中高 ),HIGH(6,  高级 );
    EXECUTE_OPT_TYPE: 68708,         //反垃圾处理|spam_execute_opt_type|SPAM_FOLDER(1,  放入垃圾邮件文件夹 ),UN_ACCEPT(2, 拒收 );
    SPAM_MAIL_DELETE_TIME: 55963,         //垃圾邮件删除时间
    REMIND_CYCLE: 29670,         //反垃圾提醒周期
    REMIND_START_TIME: 99739,         //提醒开始时间
    REMIND_END_TIME: 33830,         //提醒结束时间
    MAIL_PICTURE_VISIABLE: 13904,         //邮件图片|mail_picture_visiable|ENABLE(1,  显示邮件图片 ),DISABLE(2,  不显示垃圾邮件中的图片，手动点击后显示 ),DISABLE_SPAM(3,  不显示所有邮件中的图片，手动点击后显示 );
    CREATE_TIME: 82559,         //创建时间
    UPDATE_TIME: 77635,         //更新时间
};

// 客户端授权码表（mail_account_auth_code）- 字段编号枚举
xmail.enums.MailAccountAuthCodeField = {
    ID: 3719,         //
    AUTH_CODE_ID: 24553,         //授权码id
    MAIL_ACCOUNT_ID: 91885,         //邮箱账号id
    CORP_ID: 16757,         //企业ID
    PASSWD: 71955,         //授权码
    PASSWD_TYPE: 82007,         //密码加密类型|passwd_type|SM4(1, 国4加密 ),BCRYPT(2,  bcrypt加密 ),NO_CRYPT(3, 不加密 ),SM3(4, 国3加密 ),MD5(5, MD5加密 ),MD5_SALT(6, MD5加盐 );
    MEMO: 67825,         //授权码用途
    CREATE_TIME: 82559,         //创建时间
    UPDATE_TIME: 77635,         //更新时间
};

// 邮箱绑定关系表（mail_account_bind_info）- 字段编号枚举
xmail.enums.MailAccountBindInfoField = {
    ID: 3719,         //
    CORP_ID: 16757,         //企业id
    MAIL_ACCOUNT_ID: 91885,         //邮件账号ID
    SUITE_ID: 14869,         //应用ID(corp_sso得suiteId）
    BIND_ID: 70963,         //绑定数据
    BIND_TYPE: 35546,         //绑定类型|account_bind_type|SSO(1,  sso单点登录 ),OPEN_APP(2,  开放平台 ),PHONE(3,  手机 )
    STATUS: 91903,         //状态
    PUSH_MSG_ENABLE: 30063,         //消息推送是否开启
    CREATE_TIME: 82559,         //创建时间
    UPDATE_TIME: 77635,         //更新时间
    BIND_IP: 68848,         //
};

// 邮箱账号黑名单表（mail_account_blacklist）- 字段编号枚举
xmail.enums.MailAccountBlacklistField = {
    ID: 3719,         //
    MAIL_ACCOUNT_ID: 91885,         //邮箱账号Id
    CORP_ID: 16757,         //企业id
    BLACK_ADDR: 29992,         //黑名单地址(如果含有@为EMAIL地址； 否则是域名)
    BLACK_ADDR_MATCH_TYPE: 40399,         //匹配地址类型|addr_match_type|XSENDER(1,  按照Xsender匹配 ),FROM(2, 按照from匹配 ),XSENDER_OR_FROM(3, 按照from或者Xsender匹配 );
    CREATE_TIME: 82559,         //创建时间
    UPDATE_TIME: 77635,         //更新时间
};

// 常规设置表（mail_account_common_setting）- 字段编号枚举
xmail.enums.MailAccountCommonSettingField = {
    ID: 3719,         //
    CORP_ID: 16757,         //企业ID
    MAIL_ACCOUNT_ID: 91885,         //邮箱账号id
    PAGE_SIZE: 10944,         //邮件列表每页数量
    LAYOUT: 73445,         //窗口布局|layout|LR(1,  左右布局 ),LIST(2,  列表布局 );
    TOOLBAR_BUTTON_ICON: 95777,         //工具栏按钮是否显示图标
    LOGIN_ROUTER_PAGE: 34119,         //登录后默认显示|login_router_page|HOME(1,  首页 ),INBOX(2,  收件箱 );
    RECV_FROM_DISPLAY: 30087,         //收信时姓名显示|recv_from_display_type|original(1,  发件人自定义姓名 ),CONTACT(2,  通讯录中备注姓名 );
    WEBMAIL_SKIN: 75509,         //皮肤|webmail_skin|OFFICE(1,  商务办公 ),REDSIMPLE(2,  红色简约 ),BRAVEFORWARD(3,  勇者前行 ),SCRIPTURES(4, 经典木纹 ),GREEN(5, 绿意风情 ),PINK(6, 粉色回忆 ),GRASS(7, 青青幽境 ),BLACK(8, 时尚酷黑 ),GOLD(9, 金色时光 );
    SEND_FROM_DISPLAY: 31865,         //我的名称|send_from_display_type|NONE(1,  不显示 ),REAL_NAME(2,  真实姓名 ),CUSTOM(3,  自定义 );
    CUSTOM_NAME: 58035,         //自定义名字
    FONT_NAME: 56843,         //写信默认字体
    FONT_SIZE: 88814,         //写信默认字体大小
    WEB_SENT: 97280,         //保存web已发信件
    RECEIPT: 41487,         //回执
    REPLY_WITH_CONTENT: 71975,         //回复时加入原信
    REPLY_SUBJECT_PREFIX: 7801,         //回复/转发信头|reply_subject_prefix|EN(1, Re:/Fw: ),CN(2, 回复:/转发: );
    ORG_VISIBLE: 50177,         //是否自动加入通讯录
    CC_DEF: 58181,         //默认抄送地址
    BCC_DEF: 91435,         //默认密送地址
    CREATE_TIME: 82559,         //创建时间
    UPDATE_TIME: 77635,         //更新时间
};

// 邮箱账号自动转发+自动保存表（mail_account_deliver_info）- 字段编号枚举
xmail.enums.MailAccountDeliverInfoField = {
    ID: 3719,         //
    MAIL_ACCOUNT_ID: 91885,         //邮箱账号
    CORP_ID: 16757,         //企业id
    REPLY_ENABLE: 47596,         //自动回复是否启用
    REPLY_CONTENT: 13997,         //回复内容
    REPLY_TIME_ENABLE: 91668,         //自动回复生效时间是否启用
    REPLY_START_TIME: 7445,         //开始时间
    REPLY_END_TIME: 87335,         //结束时间
    REPLY_CONTACT_ENABLE: 80549,         //自动回复对通讯录中的联系人是否启用
    REPLY_ONCE_ENABLE: 37528,         //发件人发送一次自动回复是否启用
    FORWARD_ENABLE: 16847,         //自动转发是否启用
    FORWARD_ADDR: 45990,         //转发地址
    FORWARD_DISCARD_ENABLE: 43688,         //保存副本在邮箱中是否启用
    CREATE_TIME: 82559,         //创建时间
    UPDATE_TIME: 77635,         //更新时间
};

// 邮箱账号自动转发+自动回复操作日志表表（mail_account_deliver_log）- 字段编号枚举
xmail.enums.MailAccountDeliverLogField = {
    ID: 3719,         //
    CORP_ID: 16757,         //企业id
    MAIL_ACCOUNT_ID: 91885,         //邮箱账号id
    OPERATE_EMAIL: 69521,         //操作者使用的邮箱账号
    OPERATE_NAME: 5828,         //
    DEPART_NAME: 62910,         //
    OPERATE_TIME: 41374,         //操作时间
    OPERATE_IP: 72444,         //操作IP
    OPERATE_CONTENT: 81859,         //操作内容
    FORWARD_ADDR: 45990,         //转发地址
    FORWARD_DISCARD_ENABLE: 43688,         //保存副本在邮箱中是否启用
    CREATE_TIME: 82559,         //创建时间
    UPDATE_TIME: 77635,         //更新时间
};

// 超大附件表（mail_account_file）- 字段编号枚举
xmail.enums.MailAccountFileField = {
    ID: 3719,         //pkid
    MAIL_ACCOUNT_FILE_ID: 43173,         //邮箱账号文件ID
    CORP_ID: 16757,         //企业id
    MAIL_ACCOUNT_ID: 91885,         //主名的MailAccountId
    FILE_ID: 28684,         //文件ID
    NAME: 9776,         //附件名称
    STATUS: 91903,         //状态|mail_account_file_status|NORMAL(1, 正常 ), DELETED(2,  已删除 ), UPLOADING(4, 上传中 ), UPLOAD_FAIL(5, 上传失败 ),WAIT_DEL(6,   待删除  )
    EXPIRE_TIME: 28313,         //到期时间
    FILE_SIZE: 30987,         //文件字节数
    CREATE_TIME: 82559,         //创建时间
    UPDATE_TIME: 77635,         //更新时间
};

// 状态
xmail.enums.MailAccountFileStatus = {
    UNKNOWN: 0,         //UNKNOWN
    NORMAL: 1,         //正常
    DELETED: 2,         //已删除
    UPLOADING: 4,         //上传中
    UPLOAD_FAIL: 5,         //上传失败
    WAIT_DEL: 6,         //待删除
};

// 邮箱账号分类过滤表（mail_account_filter_info）- 字段编号枚举
xmail.enums.MailAccountFilterInfoField = {
    ID: 3719,         //
    MAIL_ACCOUNT_ID: 91885,         //邮箱账号id
    CORP_ID: 16757,         //企业id
    FILTER_ID: 296,         //规则ID
    PRIORITY: 48929,         //优先级
    STATUS: 91903,         //规则状态|filter_info_status|ENABLE(1,  启用 ),DISABLE(2,  禁用 );
    CREATE_TIME: 82559,         //创建时间
    UPDATE_TIME: 77635,         //更新时间
    NAME: 9776,         //规则名称
    FROM_ENABLE: 62834,         //
    FROM_INCLUDE: 56025,         //发件人是否包含
    FROM_MEMBER_SELECTOR_ID: 5974,         //发件人成员id
    TO_ENABLE: 18580,         //收件人或抄送人是否启用
    TO_INCLUDE: 60489,         //收件人或抄送人是否包含
    TO_MEMBER_SELECTOR_ID: 53809,         //收件人或抄送人成员id
    SUBJECT_ENABLE: 56235,         //主题是否启用
    SUBJECT_INCLUDE: 59362,         //主题是否包含
    SUBJECT_MATCH_ALL: 63588,         //
    SUBJECT_VAL: 38194,         //主题匹配内容
    MAIL_SIZE_ENABLE: 70308,         //邮件大小是否启用
    MAIL_SIZE_MIN: 5265,         //邮件大小规则最小值 单位：KB
    MAIL_SIZE_MAX: 59258,         //邮件大小最大值 单位：KB
    EXECUTE_OPT_TYPE: 68708,         //相应操作|filter_execute_opt_type|DELETE(1,  删除邮件 ),FORWARD(2,  转发至 ),DEL_FORWARD(3,  删除并转发至 ),SAFETIP(4,  添加安全提示 ),RUN(5, 执行以下操作 ),BOUNCE(6, 退信 );
    MOVE_FOLDER_ENABLE: 27603,         //移动到指定文件夹是否启用
    MOVE_FOLDER_ID: 79429,         //移动规则-要移动到的文件夹ID
    FORWARD_ENABLE: 16847,         //转发是否启用
    FORWARD_ADDR: 45990,         //转发地址
    FORWARD_DISCARD_ENABLE: 43688,         //丢弃已自动转发的邮件是否启用
    REPLY_ENABLE: 47596,         //自动回复是否启用
    REPLY_CONTENT: 13997,         //自动回复内容
};

// 邮件分类过滤规则操作日志表表（mail_account_filter_log）- 字段编号枚举
xmail.enums.MailAccountFilterLogField = {
    ID: 3719,         //
    CORP_ID: 16757,         //企业id
    MAIL_ACCOUNT_ID: 91885,         //邮箱账号id
    OPERATE_EMAIL: 69521,         //操作者使用的邮箱账号
    OPERATE_DEPART_NAME: 47771,         //操作人部门名字（全路径）
    OPERATE_TIME: 41374,         //操作时间
    OPERATE_IP: 72444,         //操作IP
    OPERATE_CONTENT: 81859,         //操作内容
    RULE_NAME: 92875,         //规则名称
    RULE_STATUS: 1283,         //规则状态|account_filter_rule_status|ENABLE(1,  启用 ),DISABLE(2,  禁用 );
    TOUCH_CONDITION: 67291,         //触发条件
    EXECUTE_ACTION: 55390,         //执行动作
    CREATE_TIME: 82559,         //创建时间
    UPDATE_TIME: 77635,         //更新时间
};

// 邮箱账号信息表（mail_account_info）- 字段编号枚举
xmail.enums.MailAccountInfoField = {
    ID: 3719,         //
    USER_ID: 37163,         //用户ID
    MAIL_ACCOUNT_ID: 91885,         //邮件账号ID
    PRIME_ACCOUNT_ID: 3639,         //主名的MailAccountId
    CORP_ID: 16757,         //企业id
    DOMAIN_ID: 69476,         //域id
    ACCOUNT: 96511,         //账号(邮箱前缀)
    DOMAIN_NAME: 3260,         //域名
    USER_EMAIL: 11187,         //邮箱地址
    NAME: 9776,         //名字
    USER_TYPE: 27785,         //用户类型|account_user_type|USER(1,  用户 ),ALIAS(2,  别名 ),LIST(3,  列表 );
    PASSWD: 71955,         //密码
    PASSWD_TYPE: 82007,         //密码加密类型|passwd_type|SM4(1, 国4加密 ),BCRYPT(2,  bcrypt加密 ),NO_CRYPT(3, 不加密 ),SM3(4, 国3加密 ),MD5(5, MD5加密 ),MD5_SALT(6, MD5加盐 );
    SPEC_ID: 30330,         //规格id
    STATUS: 91903,         //用户状态|account_status|ENABLE(1,  启用 ),DISABLE(2,  禁用 );
    ABILITY_FLAG: 23109,         //邮箱功能标记:mail_account_ability_flag:1,client_sent,客户端保存已发信 | 2,client_code_enable,客户授权码|3,remote_login_remind,异地登录提醒|4,remote_login_remind_email,邮件异地登录提醒|5,remote_login_remind_sms,手机异地登录提醒|6,secure_login_verify,安全登录验证
    LOGIN_WEB_PC: 35169,         //登录方式WEBPC限制|account_login_web_pc|ENABLE(1,  允许 ),DISABLE(2,  禁止 ),SSL(3,  只允许SSL );
    LOGIN_WEB_MOBILE: 53183,         //登录方式WEB手机限制|account_login_web_mobile|ENABLE(1,  允许 ),DISABLE(2,  禁止 ),SSL(3,  只允许SSL );
    LOGIN_SMTP_SEND: 99583,         //登录方式SMTP发信|account_login_smtp_send|ENABLE(1,  允许 ),DISABLE(2,  禁止 ),SSL(3,  只允许SSL );
    LOGIN_POP_RECV: 99691,         //登录方式POP收信|account_login_pop_recv|ENABLE(1,  允许 ),DISABLE(2,  禁止 ),SSL(3,  只允许SSL );
    LOGIN_IMAP_RECV: 77720,         //登录方式IMAP收信|account_login_imap_recv|ENABLE(1,  允许 ),DISABLE(2,  禁止 ),SSL(3,  只允许SSL );
    SECURE_LOGIN_VERIFY_FREQ: 37916,         //安全登录验证频率|secure_login_verify_freq|ALL(1,  每次 ),REMOTE(2,  异地 )
    SECURE_LOGIN_VERIFY_METHOD: 58101,         //安全登录验证方式|secure_login_verify_method|SMS(1, 短信 )
    BACKUP_FOLDER: 23307,         //是否开启备份文件夹
    ORG_VISIBLE: 50177,         //是否在通讯录显示
    FIRST_MODIFY_PWD_ENABLE: 2360,         //是否首次登录修改密码
    OVER_SPACE: 95523,         //是否超容
    LOGIN_IP_CONTENT: 38315,         //登录限制ip或ip段
    WORKBENCH_FLAG: 578,         //应用功能:mail_account_workbench_flag:1,FLAGA,需要修改DB注释以便生成（位数从1开始） | 2,FLAGB,第二位表示样例
    LIST_MEMBER_SELECTOR_ID: 2970,         //列表成员id
    LIST_PRIVI_FLAG: 677,         //列表权限: 1,all_user,所有用户都可以给此列表发信 | 2,custom_user,只有指定范围内的用户才能给此列表发信 | 3,user_of_list,只有列表内的用户才能给此列表发信
    PRIVI_MEMBER_SELECTOR_ID: 59755,         //列表权限成员id
    EXPIRE_TIME: 28313,         //账号到期时间
    EXPIRE_OPERATE_TYPE: 83410,         //账户到期执行动作|account_expire_operate_type|DISABLE(1,  禁用 ),DELETE(2,  删除 );
    IMAP_LANGUAGE: 50560,         //语言|language|CN(1,  中文简体 ),HK(2,  中文繁体 ),EN(3,  英文 ),JP(4,  日语 ),KR(5,  韩语 );
    CREATE_TIME: 82559,         //创建时间
    UPDATE_TIME: 77635,         //更新时间
};

// pop代收表（mail_account_pop_info）- 字段编号枚举
xmail.enums.MailAccountPopInfoField = {
    ID: 3719,         //
    MAIL_ACCOUNT_ID: 91885,         //邮箱账号id
    CORP_ID: 16757,         //企业ID
    POP_EMAIL: 51062,         //其他邮箱账号
    POP_PASSWD: 90496,         //其他邮箱密码
    POP_PASSWD_TYPE: 81710,         //密码加密类型|passwd_type|SM4(1, 国4加密 ),BCRYPT(2,  bcrypt加密 ),NO_CRYPT(3, 不加密 ),SM3(4, 国3加密 ),MD5(5, MD5加密 ),MD5_SALT(6, MD5加盐 );
    STATUS: 91903,         //账号状态|pop_emal_status|ENABLE(1,  启用 ),DISABLE(2,  禁用 );
    POP_HOST: 27563,         //pop服务器
    POP_PORT: 6942,         //端口号
    SSL_ENABLE: 43144,         //ssl连接是否开启
    FOLDER_ID: 47295,         //存放至的文件夹id
    DISCARD_ENABLE: 88626,         //原邮箱是否丢弃副本
    CREATE_TIME: 82559,         //创建时间
    UPDATE_TIME: 77635,         //更新时间
};

// 邮箱提醒记录表表（mail_account_remind）- 字段编号枚举
xmail.enums.MailAccountRemindField = {
    ID: 3719,         //自增主键
    MAIL_ACCOUNT_ID: 91885,         //邮箱账号id
    REMIND_TYPE: 79883,         //提醒类型|remind_type|ANTISPAM(1,  垃圾邮件 ),PWD(2,  密码过期 )
    LAST_REMIND_TIME: 69938,         //上一次提醒时间
    CREATE_TIME: 82559,         //创建时间
};

// 邮箱定时任务表（mail_account_schedule_task）- 字段编号枚举
xmail.enums.MailAccountScheduleTaskField = {
    ID: 3719,         //
    CORP_ID: 16757,         //企业id
    MAIL_ACCOUNT_ID: 91885,         //邮箱id
    MAIL_INDEX_ID: 4635,         //索引id
    STATUS: 91903,         //状态|schedule_task_status|UN_EXEC(1, 未执行 ),SUCC(2,  完成 ),FAIL(3,  失败 ),WAIT_DELETE(4, 任务已删除、等待后续异步删除 )
    EXEC_TIME: 247,         //执行时间
    FAIL_COUNT: 2510,         //失败次数
    TASK_TYPE: 44913,         //状态|schedule_task_type|SEND_LATER(1, 定时发信 )
    CREATE_TIME: 82559,         //创建时间
    UPDATE_TIME: 77635,         //更新时间
    MEMO: 67825,         //备注
};

// 个性签名表（mail_account_sign）- 字段编号枚举
xmail.enums.MailAccountSignField = {
    ID: 3719,         //
    MAIL_ACCOUNT_ID: 91885,         //邮箱账号id
    CORP_ID: 16757,         //企业ID
    SIGN_ID: 64331,         //签名ID
    NAME: 9776,         //签名名字
    CONTENT: 3345,         //签名内容
    MAIL_ACCOUNT_DEF: 42162,         //是否是邮箱默认签名
    CREATE_TIME: 82559,         //创建时间
    UPDATE_TIME: 77635,         //更新时间
};

// 信任地点表（mail_account_trust_location）- 字段编号枚举
xmail.enums.MailAccountTrustLocationField = {
    ID: 3719,         //
    TRUST_LOCATION_ID: 22708,         //
    MAIL_ACCOUNT_ID: 91885,         //邮箱ID
    CORP_ID: 16757,         //企业id
    ADD_TYPE: 40717,         //信任地址添加类型|trust_location_add_type|AUTO(1,  自动 ),INTELLECT(2,  智能 ),MANUAL(3,  手动 );
    COUNTRY_CODE: 81971,         //
    PROVINCE_CODE: 76927,         //
    CITY_CODE: 94931,         //
    LAST_USE_TIME: 39557,         //最后使用时间
    CREATE_TIME: 82559,         //创建时间
    UPDATE_TIME: 77635,         //更新时间
};

// 邮箱账号版本号表（mail_account_version）- 字段编号枚举
xmail.enums.MailAccountVersionField = {
    ID: 3719,         //
    MAIL_ACCOUNT_ID: 91885,         //邮箱账号id
    CORP_ID: 16757,         // 企业ID
    VERSION_SYNC_SERIAL: 72602,         //版本同步序列值（用于数据同步递进；版本字段更新时都要更新此值；此值不是简单+1，而是保证全表越晚更新记录的值大于先前更新记录的值； 如何数据库支持“自增序列”则使用“自增序列”， 如不支持则暂时更新为数据库当前时间毫秒数（unix_timestamp(current_timestamp(3))*1000）
    VERSION_SCOPE: 50545,         //邮箱账号相关信息版本号分类|mail_account_version_scope|info(1,  基本信息 ),mail_index(2,  邮件索引 ),filter(3,  过滤规则 ),deliver(4, 投递信息 ),blacklist(5, 黑名单 ),antispam(6, 反垃圾配置 ),pop(7, 其他邮箱代收 ),authcode(8, 授权码列表信息 ),bindinfo(9, 绑定信息 )
    VERSION: 89499,         //版本号
};

// 邮箱账号相关信息版本号分类
xmail.enums.MailAccountVersionScope = {
    UNKNOWN: 0,         //UNKNOWN
    INFO: 1,         //基本信息
    MAIL_INDEX: 2,         //邮件索引
    FILTER: 3,         //过滤规则
    DELIVER: 4,         //投递信息
    BLACKLIST: 5,         //黑名单
    ANTISPAM: 6,         //反垃圾配置
    POP: 7,         //其他邮箱代收
    AUTHCODE: 8,         //授权码列表信息
    BINDINFO: 9,         //绑定信息
};

// 邮件加密表（mail_encrypt）- 字段编号枚举
xmail.enums.MailEncryptField = {
    ID: 3719,         //
    MAIL_ENCRYPT_ID: 61645,         //邮件密码ID
    CORP_ID: 16757,         //企业id
    PASSWORD: 1716,         //密码
    ATTACH_COUNT: 88056,         //附件数量
    ATTACH_NAMES: 90429,         //所有附件名称
    CREATE_TIME: 82559,         //创建时间
    UPDATE_TIME: 77635,         //更新时间
};

// 邮件文件夹信息表表（mail_folder）- 字段编号枚举
xmail.enums.MailFolderField = {
    ID: 3719,         //
    CORP_ID: 16757,         //企业ID
    MAIL_ACCOUNT_ID: 91885,         //邮箱ID
    FOLDER_ID: 47295,         //文件夹ID
    PARENT_FOLDER_ID: 48234,         //父文件夹ID （0表示根）
    STATUS: 91903,         //状态|mail_folder_status|NORMAL(1,  正常 ), WAIT_DELETE(2, 邮箱已删除、等待后续异步删除 );
    NAME: 9776,         //文件夹名称（IMAP-UTF7）
    DISPLAY_NAME: 92630,         //文件夹名称（显示使用-UTF8）
    NEXT_IMAP_UID: 6472,         //此文件夹下一个IMAP_UID（历史最大+1）
    FLAG_COUNTED: 67843,         //是否计数标记（文件夹内邮件未读、星标等标记是否计入邮箱计数）
    SPACE_COUNTED: 19582,         //是否占用容量（文件夹内邮件是否计入邮箱使用总封数、空间）
    SUBSCRIBED: 27118,         //是否已订阅（IMAP）
    HIDDEN: 24119,         //是否隐藏
    CREATE_TIME: 82559,         //创建时间
    UPDATE_TIME: 77635,         //修改时间
    SORT_VAL: 1981,         //排序值
    DEPTH: 12226,         //文件夹的层级从0开始（收件箱等顶层目录层级是0）
    MAIL_SIZE: 44383,         //当前文件夹内直属邮件总大小（字节数, 不包括子孙文件夹）
    MAIL_COUNT: 36267,         //当前文件夹内直属邮件数量（不包括子孙文件夹）
    RECENT_COUNT: 92907,         //当前文件夹内直属新信数量（不包括子孙文件夹）
    UNSEEN_COUNT: 58780,         //当前文件夹内直属未读邮件数量（不包括子孙文件夹）
    STARRED_COUNT: 17985,         //当前文件夹内直属星标邮件数量（不包括子孙文件夹）
    WAITED_COUNT: 74869,         //当前文件夹内直属代办邮件数量（不包括子孙文件夹）
};

// 状态
xmail.enums.MailFolderStatus = {
    UNKNOWN: 0,         //UNKNOWN
    NORMAL: 1,         //正常
    WAIT_DELETE: 2,         //邮箱已删除、等待后续异步删除
};

// 邮件索引信息表表（mail_index）- 字段编号枚举
xmail.enums.MailIndexField = {
    ID: 3719,         //
    MAIL_INDEX_ID: 4635,         //索引ID
    CORP_ID: 16757,         //企业id
    MAIL_ACCOUNT_ID: 91885,         //邮箱账号ID
    FOLDER_ID: 47295,         //
    IMAP_UID: 4065,         //IMAP UID
    FILE_ID: 28684,         //邮件原信fileId
    STATUS: 91903,         //状态|mail_index_status|NORMAL(1,  正常 ), WAIT_DELETE(2, 邮箱已删除、等待后续异步删除 );
    ENCRYPT_ID: 38396,         //邮件密码ID
    TNEF: 26539,         //OUTLOOK格式（winmail.dat）
    MAIL_SIZE: 44383,         //邮件尺寸(字节数)
    MAIL_DATE: 22460,         //日期（信头）
    SENDER: 45755,         //发件人
    REAL_SENDER: 80025,         //发信人（smtp登录名）
    PRIME_SENDER: 9193,         //发信人（smtp登录名的主名）
    MAIL_FROM: 9793,         //发信人（信头）
    MAIL_TO: 33648,         //收信人（信头）
    CC: 8822,         //抄送
    BCC: 38498,         //密送
    PRIORITY: 48929,         //优先级|mail_priority|URGENCY(1,  紧急 ),NORMAL(3,  普通 ),SLOW(5,  缓慢 );
    MESSAGE_ID: 10019,         //MSGID（信头）
    SUBJECT: 8685,         //主题
    ATTR_FLAG: 51154,         //邮件索引属性标记:mail_index_attr_flag:1,unbelong_contacts,非常用联系人|2,auto_reply,自动回复标志|3,auto_forward,自动转发标志|4,decrypt,解密|5,send_later,定时发信
    ABS_TYPE: 94162,         //标记垃圾邮件类别|mail_abs_type|NORMAL(1,  正常 ), SPAM(2,  垃圾 ), DOMAIN_INTERNAL(3,  同域 ), DOMAIN_WHITELIST(4,  域白名单 );
    STARRED: 43062,         //星标
    WAITED: 64316,         // 代办邮件
    UNDO_SEND: 93773,         //撤回状态类型|mail_undo_send_type|ALL_SUCC(1,  全部成功 ),PART_SUCC(2,  部分成功 ),ALL_FAIL(3,  全部失败 ),PART_FAIL(4,  部分失败 ),UNDOING(5, 撤回中 ),NO_UNDO(6, 未撤回 ); 
    RECENT: 62306,         //新信
    SEEN: 33951,         //已读
    DRAFT: 44908,         //草稿
    DELETED: 92954,         //删除标记
    ANSWERED: 35010,         //回复
    RECEIPT: 41487,         //回执
    FORWARDED: 77660,         //转发
    SEND_ALONE: 14528,         //群发单显
    ANNOUNCED_MAIL: 16836,         //域公告邮件
    FOREIGN_DOMAIN: 53421,         //是否外域
    ATTACH_COUNT: 88056,         //附件数量
    ATTACH_NAMES: 90429,         //所有附件名称（用于搜索）
    TRACE_ID: 10795,         //跟踪ID(MD5(CONCAT(mail_from,'|',message_id,'|',`subject`,'|',UNIX_TIMESTAMP(mail_date))))
    RECEIVED_TIME: 71488,         //存信时间(同createtime，搬家例外)
    CREATE_TIME: 82559,         //创建时间
    UPDATE_TIME: 77635,         //更新时间
};

// 状态
xmail.enums.MailIndexStatus = {
    UNKNOWN: 0,         //UNKNOWN
    NORMAL: 1,         //正常
    WAIT_DELETE: 2,         //邮箱已删除、等待后续异步删除
};

// 邮件索引信息表表（mail_mime_info）- 字段编号枚举
xmail.enums.MailMimeInfoField = {
    ID: 3719,         //
    FILE_ID: 28684,         //邮件原信fileId
    STATUS: 91903,         //状态|mail_mime_info_status|NORMAL(1,  正常 );
    CREATE_TIME: 82559,         //创建时间
    UPDATE_TIME: 77635,         //更新时间
    ENCRYPT_ID: 38396,         //邮件密码ID
    TNEF: 26539,         //OUTLOOK格式（winmail.dat）
    MAIL_SIZE: 44383,         //邮件尺寸(字节数)
    MAIL_DATE: 22460,         //日期（信头）
    SENDER: 45755,         //发信人（smtp登录名）
    REAL_SENDER: 80025,         //发信人（smtp登录名）
    PRIME_SENDER: 9193,         //发信人（smtp登录名的主名）
    MAIL_FROM: 9793,         //发信人（信头）
    MAIL_TO: 33648,         //收信人（信头）
    CC: 8822,         //抄送
    BCC: 38498,         //密送
    PRIORITY: 48929,         //优先级|mail_priority|URGENCY(1,  紧急 ),NORMAL(3,  普通 ),SLOW(5,  缓慢 );
    RECEIPT: 41487,         //回执
    MESSAGE_ID: 10019,         //MSGID（信头）
    TRACE_ID: 10795,         //跟踪ID(MD5(CONCAT(mail_from,'|',message_id,'|',`subject`,'|',UNIX_TIMESTAMP(mail_date))))
    SUBJECT: 8685,         //主题
    ATTACH_COUNT: 88056,         //附件数量
    ATTACH_NAMES: 90429,         //所有附件名称（用于搜索）
};

// 状态
xmail.enums.MailMimeInfoStatus = {
    UNKNOWN: 0,         //UNKNOWN
    NORMAL: 1,         //正常
};

// 邮件MIME结构信息表表（mail_mime_part）- 字段编号枚举
xmail.enums.MailMimePartField = {
    ID: 3719,         //
    FILE_ID: 28684,         //
    PART_ID: 40620,         //
    SECTION_ID: 14315,         //分段ID（IMAP协议使用）
    PART_TYPE: 48196,         //PART类型类型|mail_part_type|N(1,  普通 ); //正文（文本）、正文（HTML）、内嵌资源、普通附件
    BOUNDARY_ID: 30159,         //
    PARENT_BOUNDARY_ID: 63648,         //
    CREATE_TIME: 82559,         //
    OFFSET: 48153,         //
    LENGTH: 87415,         //
    CONTENT_TYPE: 35405,         //
    CHARSET: 3611,         //
    ENCODING: 31182,         //编码类型|mime_type|N(1,  普通 );
    CONTENT_ID: 36263,         //资源ID
    DISPOSITION: 8701,         //类型|mime_disposition|N(1,  普通 );
    NAME: 9776,         //
    FILENAME: 63153,         //文件名称
};

//
xmail.enums.MailOperatorType = {
    READ: 1,         //读信
    SEND: 2,         //发信
    REPLY: 3,         //回复
    REPLY_ALL: 4,         //回复全部
    REPLY_ALL_ATTACH: 5,         //带附件回复全部
    FORWARD: 6,         //转发
};

// PART类型类型
xmail.enums.MailPartType = {
    UNKNOWN: 0,         //UNKNOWN
    N: 1,         //普通
};

// 邮件图片
xmail.enums.MailPictureVisiable = {
    UNKNOWN: 0,         //UNKNOWN
    ENABLE: 1,         //显示邮件图片
    DISABLE: 2,         //不显示垃圾邮件中的图片，手动点击后显示
    DISABLE_SPAM: 3,         //不显示所有邮件中的图片，手动点击后显示
};

// 优先级
xmail.enums.MailPriority = {
    UNKNOWN: 0,         //UNKNOWN
    URGENCY: 1,         //紧急
    NORMAL: 3,         //普通
    SLOW: 5,         //缓慢
};

//
xmail.enums.MailStatus = {
    UNREAD: 1,         //未读
    READ: 2,         //已读
    FORWARDED: 8,         //转发
    REPLIED: 4,         //回复
    STAR: 5,         //星标
    DE_STAR: 6,         //取消星标
};

// 撤回状态类型
xmail.enums.MailUndoSendType = {
    UNKNOWN: 0,         //UNKNOWN
    ALL_SUCC: 1,         //全部成功
    PART_SUCC: 2,         //部分成功
    ALL_FAIL: 3,         //全部失败
    PART_FAIL: 4,         //部分失败
    UNDOING: 5,         //撤回中
    NO_UNDO: 6,         //未撤回
};

// 邮箱使用情况表（mail_used_info）- 字段编号枚举
xmail.enums.MailUsedInfoField = {
    ID: 3719,         //
    CORP_ID: 16757,         //企业id
    MAIL_ACCOUNT_ID: 91885,         //邮箱id
    USER_EMAIL: 11187,         //邮箱地址
    USER_NAME: 94299,         //邮箱名字
    CREATE_TIME: 82559,         //创建时间
    UPDATE_TIME: 77635,         //更新时间
    FOLDER_ID_MAX: 72375,         //当前邮箱文件夹ID最大值（新建文件夹同步加1；用于支持IMAP协议）
    CUSTOM_FOLDER_COUNT: 37116,         //当前邮箱账号存在自定义文件夹的数量
    MAX_SPACE: 27429,         //最大空间 单位MB
    USED_SPACE: 18116,         //已使用空间 单位字节数
    MAX_NUM: 26206,         //最大邮件数量
    USED_NUM: 92503,         //已使用数量
    UNSEEN_COUNT: 58780,         //未读邮件总数
    STARRED_COUNT: 17985,         //星标邮件总数
    WAITED_COUNT: 74869,         //代办邮件总数
    LAST_MAIL_INDEX_ID: 62982,         //收信箱最新存入的邮件索引ID
};

// 管理员状态
xmail.enums.ManagerInfoStatus = {
    UNKNOWN: 0,         //UNKNOWN
    ENABLE: 1,         //启用
    DISABLE: 2,         //禁用
};

// 管理员操作日志表（manager_log）- 字段编号枚举
xmail.enums.ManagerLogField = {
    ID: 3719,         //
    CORP_ID: 16757,         //企业id
    CORP_NAME: 42622,         //企业名称
    CORP_DEF_DOMAIN: 53039,         //公司默认主域名
    USER_ID: 37163,         //邮箱id
    USER_EMAIL: 11187,         //邮箱名字
    MANAGER_TYPE: 99372,         //管理员类型|manager_type|ADMIN(1,  admin管理员 ),GENERAL(2,  普通管理员 ),SYSTEM(3,  系统管理员 );
    CREATE_TIME: 82559,         //创建时间
    UPDATE_TIME: 77635,         //更新时间
    OPERATE_IP: 72444,         //操作IP
    OPERATE_TIME: 41374,         //操作时间
    OPERATE_NAME: 5828,         //操作名称
    OPERATE_CONTENT: 81859,         //操作内容
    OPERATE_TYPE: 91382,         //登录类型|manager_log_operate_type|LOGIN(1, 登录类型 ),OPERATE(2, 操作日志 );
    OPERATE_ERROR_CODE: 69810,         //操作异常错误码： 0 表示没有异常， 其它值参考 ErrorCode
    OPERATE_PARAM: 36743,         //操作参数
    OPERATE_RESULT: 72536,         //操作结果
};

// 登录类型
xmail.enums.ManagerLogOperateType = {
    UNKNOWN: 0,         //UNKNOWN
    LOGIN: 1,         //登录类型
    OPERATE: 2,         //操作日志
};

// 管理员类型
xmail.enums.ManagerType = {
    UNKNOWN: 0,         //UNKNOWN
    ADMIN: 1,         //ADMIN管理员
    GENERAL: 2,         //普通管理员
    SYSTEM: 3,         //系统管理员
};

// 成员选择表（member_selector）- 字段编号枚举
xmail.enums.MemberSelectorField = {
    ID: 3719,         //
    CORP_ID: 16757,         //企业id
    SELECTOR_ID: 71459,         //成员选择id
    SELECTOR_TYPE: 47925,         //选择器类型|selector_type|AUDIT(1,  审核 ),FILTER(2,  过滤 ),LIST(3,  列表 ),VIEW(4,  视图 ),MANAGER(5,  管理员 ),ACCOUNT_FILTER(6, 分类过滤 ),RULE_LOGIN(7, 登录规则 ),RULE_DELIVER(8, 收发规则 ),RULE_PRIVI(9, 用户权限规则 ),RULE_PASSWD(10, 密码规则 );
    MEMBER_ID: 21351,         //成员id
    MEMBER_TYPE: 95245,         //成员类型|member_type|USER(1,  用户 ),ACCOUNT(2,  邮箱账号 ),EMAIL(3,  邮箱地址 ),DOMAIN(4,  域名 ),LIST(5,  列表 ),AUDIT_GROUP(6,  功能组 ),DEPT_ONCE(7,  部门(仅当前部门) ),DEPT_ALL(8,  部门（递归包括所有子部门） );
    MEMBER_EMAIL: 13416,         //成员地址
    MEMBER_NAME: 45240,         //成员名字
    CREATE_TIME: 82559,         //创建时间
};

//
xmail.enums.MemberSelectorMatchType = {
    UNKNOWN: 0,         //UNKNOWN
    SUBSET: 1,         //子集匹配(指定⊆选择器； 指定集合为成员选择器集合子集)
    ANY: 2,         //任意匹配(指定∩选择器≠Ø; 指定集合与成员选择器集合是否存在交集)
    NONE: 3,         //不存在任何项(指定∩选择器=Ø; 指定集合与成员选择器集合交集为空)
    SUPERSET: 4,         //父集匹配(选择器⊆指定； 成员选择器集合为指定集合子集)
};

// 成员类型
xmail.enums.MemberType = {
    UNKNOWN: 0,         //UNKNOWN
    USER: 1,         //用户
    ACCOUNT: 2,         //邮箱账号
    EMAIL: 3,         //邮箱地址
    DOMAIN: 4,         //域名
    LIST: 5,         //列表
    AUDIT_GROUP: 6,         //功能组
    DEPT_ONCE: 7,         //部门(仅当前部门)
    DEPT_ALL: 8,         //部门（递归包括所有子部门）
};

// 企业快捷菜单表（menu_fast）- 字段编号枚举
xmail.enums.MenuFastField = {
    ID: 3719,         //
    CORP_ID: 16757,         //企业id
    CREATE_TIME: 82559,         //创建时间
    UPDATE_TIME: 77635,         //更新时间
    USER_ID: 37163,         //邮箱id
    USER_EMAIL: 11187,         //邮箱地址
    MENU_ID: 50512,         //菜单ID
    SORT_VAL: 1981,         //排序值
};

// 系统菜单信息表（menu_info）- 字段编号枚举
xmail.enums.MenuInfoField = {
    ID: 3719,         //
    MENU_ID: 50512,         //菜单id
    PRIVI_POS: 38917,         //
    CREATE_TIME: 82559,         //创建时间
    MENU_GROUP: 63223,         //二级菜单分组id
    PARENT_MENU_ID: 30286,         //父级菜单id
    REMARK: 2866,         //描述
    SORT_VAL: 1981,         //排序值
    URL: 33124,         //html的url路径
    MENU_TYPE: 68300,         //菜单类型|menu_type|CORP(1,  企业管理员菜单 ),SUPER(2,  超级管理员菜单 )
    I18N: 63559,         //
    ICON: 60240,         //图标
    BGCLS: 58128,         //背景色
};

//菜单搜索类型 
xmail.enums.MenuSearchEnum = {
    MA: 0,         //ma
    SUPER_MA: -1,         //sma
};

// 菜单类型
xmail.enums.MenuType = {
    UNKNOWN: 0,         //UNKNOWN
    CORP: 1,         //企业管理员菜单
    SUPER: 2,         //超级管理员菜单
};

// 消息模板表表（message_template）- 字段编号枚举
xmail.enums.MessageTemplateField = {
    ID: 3719,         //自增主键id
    MSG_TYPE: 86081,         //消息类型|notice_msg_type|EMAIL(1,  邮件 ),MSG(2,  短信 ),EMAIL_MSG(3,  邮件短信 );
    TEMPLATE_TYPE: 11753,         //模板类型|notice_template_type|UPDATE_PWD(1,  修改密码提醒 ),SELF_FORWARD(2, 自动转发 ),UNBIND_SUCCESS_SMS(3,  解除绑定短信提醒 ),DISTANCE_LOGIN(4, 异地 ),AUTHCODE_ENABLE(5, 开启授权 ),AUTHCODE_CLOSE(6,  关闭授权 ),ADD_AUTHCODE(7, 添加一条授权码 ),BIND_CODE(8,  绑定手机验证码 ),SAFE_LOGIN(9, 安全登录验证码 ),SELF_RESET_PWD(10,  自助重置密码 ),CORP_MA_BIND(11, MA绑定 ),RECEIPT(12, 回执 ),MAIL_NUM_WARN(13, 邮箱数量超容 ),MAIL_SPACE_WARN(14, 邮箱空间超容 ),UPDATE_P_REMIND(15, 密码过期 ),ANTISPAM_REMIND(16, 垃圾邮件 ),LICENSE_REMIND(17, 证书过期 ),CORP_REMIND(18, 企业到期 ),ACCOUNT_EXPIRATION_REMIND(19, 账号到期 ),ACCOUNT_EXPIRATION_RESULT_REMIND(20, 账户到期操作 ),ACCOUNT_EXPIRATION_DAY_REMIND(21, 当天账号过期 ),ANTISPAM_TD_REMIND(22, 垃圾邮件表格 ),DOMAIN_REMIND(23, 域公告结果 ),UNDELIVERED_REMIND(24, 退信 ),UNDELIVERED_MESS(25, 退信提醒 ),BIND_SUCEESS_EMAIL(26, 手机号绑定成功邮件提醒 ),UNBIND_CODE(27, 解绑手机验证码 ),UNBIND_SUCEESS_EMAIL(28, 手机号解绑成功邮件提醒 );
    MSG_CONTEXT_CN: 61242,         //中文消息内容
    MSG_CONTEXT_EN: 42269,         //英文消息内容
    CREATE_TIME: 82559,         //创建时间
    UPDATE_TIME: 77635,         //更新时间
    MAIL_SUBJECT_CN: 41634,         //中文邮件主题
    MAIL_SUBJECT_EN: 36834,         //英文邮件主题
};

// 类型
xmail.enums.MimeDisposition = {
    UNKNOWN: 0,         //UNKNOWN
    N: 1,         //普通
};

// 编码类型
xmail.enums.MimeType = {
    UNKNOWN: 0,         //UNKNOWN
    N: 1,         //普通
};

// 消息类型
xmail.enums.NoticeMsgType = {
    UNKNOWN: 0,         //UNKNOWN
    EMAIL: 1,         //邮件
    MSG: 2,         //短信
    EMAIL_MSG: 3,         //邮件短信
};

// 模板类型
xmail.enums.NoticeTemplateType = {
    UNKNOWN: 0,         //UNKNOWN
    UPDATE_PWD: 1,         //修改密码提醒
    SELF_FORWARD: 2,         //自动转发
    UNBIND_SUCCESS_SMS: 3,         //解除绑定短信提醒
    DISTANCE_LOGIN: 4,         //异地
    AUTHCODE_ENABLE: 5,         //开启授权
    AUTHCODE_CLOSE: 6,         //关闭授权
    ADD_AUTHCODE: 7,         //添加一条授权码
    BIND_CODE: 8,         //绑定手机验证码
    SAFE_LOGIN: 9,         //安全登录验证码
    SELF_RESET_PWD: 10,         //自助重置密码
    CORP_MA_BIND: 11,         //MA绑定
    RECEIPT: 12,         //回执
    MAIL_NUM_WARN: 13,         //邮箱数量超容
    MAIL_SPACE_WARN: 14,         //邮箱空间超容
    UPDATE_P_REMIND: 15,         //密码过期
    ANTISPAM_REMIND: 16,         //垃圾邮件
    LICENSE_REMIND: 17,         //证书过期
    CORP_REMIND: 18,         //企业到期
    ACCOUNT_EXPIRATION_REMIND: 19,         //账号到期
    ACCOUNT_EXPIRATION_RESULT_REMIND: 20,         //账户到期操作
    ACCOUNT_EXPIRATION_DAY_REMIND: 21,         //当天账号过期
    ANTISPAM_TD_REMIND: 22,         //垃圾邮件表格
    DOMAIN_REMIND: 23,         //域公告结果
    UNDELIVERED_REMIND: 24,         //退信
    UNDELIVERED_MESS: 25,         //退信提醒
    BIND_SUCEESS_EMAIL: 26,         //手机号绑定成功邮件提醒
    UNBIND_CODE: 27,         //解绑手机验证码
    UNBIND_SUCEESS_EMAIL: 28,         //手机号解绑成功邮件提醒
};

// 应用类型
xmail.enums.OpenAppType = {
    UNKNOWN: 0,         //UNKNOWN
    FS: 1,         //飞书
};

//
xmail.enums.OrgTreeNodeType = {
    UNKNOWN: 0,         //UNKNOWN
    USER: 1,         //用户
    DEPT: 2,         //部门
    CONTACT_INFO: 3,         //外部联系人
    MAILLIST_ACCOUNT: 4,         //邮件列表地址
    ORG_ROOT: 5,         //组织通讯录主节点
    CONTACT_ROOT: 6,         //外部联系人主节点
    CONTACT_GROUP: 7,         //外部联系人组
    MAILLIST_ROOT: 8,         //邮件列表主节点
};

// 密码加密类型
xmail.enums.PasswdType = {
    UNKNOWN: 0,         //UNKNOWN
    SM4: 1,         //国4加密
    BCRYPT: 2,         //BCRYPT加密
    NO_CRYPT: 3,         //不加密
    SM3: 4,         //国3加密
    MD5: 5,         //MD5加密
    MD5_SALT: 6,         //MD5加盐
};

// 账号状态
xmail.enums.PopEmalStatus = {
    UNKNOWN: 0,         //UNKNOWN
    ENABLE: 1,         //启用
    DISABLE: 2,         //禁用
};

//
xmail.enums.PreviewServerType = {
    ONLYOFFICE: 1,         //onlyoffice
    YOZO: 2,         //yozo
};

// 监狱类型
xmail.enums.PrisonType = {
    IP_PRISON: 1,         //IP监狱
    IP_BLACKLIST: 2,         //IP黑名单
    ACCOUNT_PRISON: 3,         //邮箱账号监狱
    NORMAL: 4,         //状态正常
};

// 系统权限信息表（privi_info）- 字段编号枚举
xmail.enums.PriviInfoField = {
    ID: 3719,         //
    PRIVI_ID: 41846,         //权限id
    PRIVI_POS: 38917,         //
    PARENT_PRIVI_ID: 79693,         //父级菜单id
    CREATE_TIME: 82559,         //创建时间
    REMARK: 2866,         //描述
};

// 产品授权类型
xmail.enums.ProductEdition = {
    UNKNOWN: 0,         //未知
    TRIAL: 1,         //试用版
    STANDARD: 2,         //标准版
    ULTIMATE: 3,         //旗舰版
};

//
xmail.enums.PushMsgType = {
    EMAIL: 1,         //邮件
    MSG: 2,         //短信
    EMAIL_MSG: 3,         //邮件和短信
};

// 收信时姓名显示
xmail.enums.RecvFromDisplayType = {
    UNKNOWN: 0,         //UNKNOWN
    ORIGINAL: 1,         //发件人自定义姓名
    CONTACT: 2,         //通讯录中备注姓名
};

// 提醒类型
xmail.enums.RemindType = {
    UNKNOWN: 0,         //UNKNOWN
    ANTISPAM: 1,         //垃圾邮件
    PWD: 2,         //密码过期
};

// 回复/转发信头
xmail.enums.ReplySubjectPrefix = {
    UNKNOWN: 0,         //UNKNOWN
    EN: 1,         //RE:/FW:
    CN: 2,         //回复:/转发:
};

// 自动转发设置
xmail.enums.RoleDeliverForwardType = {
    UNKNOWN: 0,         //UNKNOWN
    DISABLE: 1,         //禁止发送1
    DISABLE_FOREIGN: 2,         //禁止转发外域
    DEFAULT: -1,         //系统默认
};

// 邮件发送设置
xmail.enums.RoleDeliverSendType = {
    UNKNOWN: 0,         //UNKNOWN
    ENABLE_PART: 1,         //只允许发送到指定邮箱或域
    DISABLE: 2,         //禁止发送
    DISABLE_FOREIGN: 3,         //禁止发送外域
    DISABLE_PART: 4,         //禁止发送到指定邮箱或域
    DEFAULT: -1,         //系统默认
};

// 登录IP限制
xmail.enums.RuleLoginIpLimit = {
    UNKNOWN: 0,         //UNKNOWN
    ENABLE_PART: 1,         //只允许
    DISABLE_PART: 2,         //不允许
    UNLIMITED: 3,         //不限制
    DEFAULT: -1,         //系统默认
};

// 状态
xmail.enums.ScheduleTaskStatus = {
    UNKNOWN: 0,         //UNKNOWN
    UN_EXEC: 1,         //未执行
    SUCC: 2,         //完成
    FAIL: 3,         //失败
    WAIT_DELETE: 4,         //任务已删除、等待后续异步删除
};

// 状态
xmail.enums.ScheduleTaskType = {
    UNKNOWN: 0,         //UNKNOWN
    SEND_LATER: 1,         //定时发信
};

//
xmail.enums.SearchType = {
    QUICK: 1,         //快速的
    ADVANCED: 2,         //高级的
    FULLTEXT: 3,         //全文检索
};

// 安全登录验证频率
xmail.enums.SecureLoginVerifyFreq = {
    UNKNOWN: 0,         //UNKNOWN
    ALL: 1,         //每次
    REMOTE: 2,         //异地
};

// 安全登录验证方式
xmail.enums.SecureLoginVerifyMethod = {
    UNKNOWN: 0,         //UNKNOWN
    SMS: 1,         //短信
};

// 选择器类型
xmail.enums.SelectorType = {
    UNKNOWN: 0,         //UNKNOWN
    AUDIT: 1,         //审核
    FILTER: 2,         //过滤
    LIST: 3,         //列表
    VIEW: 4,         //视图
    MANAGER: 5,         //管理员
    ACCOUNT_FILTER: 6,         //分类过滤
    RULE_LOGIN: 7,         //登录规则
    RULE_DELIVER: 8,         //收发规则
    RULE_PRIVI: 9,         //用户权限规则
    RULE_PASSWD: 10,         //密码规则
};

// 我的名称
xmail.enums.SendFromDisplayType = {
    UNKNOWN: 0,         //UNKNOWN
    NONE: 1,         //不显示
    REAL_NAME: 2,         //真实姓名
    CUSTOM: 3,         //自定义
};

//
xmail.enums.SendMailType = {
    NORMAL: 1,         //常规邮件
    DRAFT: 2,         //草稿邮件
    QUICK: 3,         //快捷邮件
};

//
xmail.enums.SessionStatus = {
    UN_ACTIVE: 0,         //未激活
    ACTIVE: 1,         //已激活
};

//
xmail.enums.SmtpType = {
    NORMAL: 1,         //normalSmtp
    GARBAGE: 2,         //garbageSmtp
    WELCOME: 3,         //welcomeSmtp
};

//
xmail.enums.SortType = {
    DESC: 1,         //倒排序
    ASC: 2,         //正排序
};

// 反垃圾处理
xmail.enums.SpamExecuteOptType = {
    UNKNOWN: 0,         //UNKNOWN
    SPAM_FOLDER: 1,         //放入垃圾邮件文件夹
    UN_ACCEPT: 2,         //拒收
};

// 反垃圾级别
xmail.enums.SpamLevel = {
    UNKNOWN: 0,         //UNKNOWN
    IGNORE: 1,         //不过滤
    LOW: 2,         //低级
    MEDIUM_LOW: 3,         //中低
    MEDIUM: 4,         //中级
    MEDIUM_HIGH: 5,         //中高
    HIGH: 6,         //高级
};

// 系统邮箱规格表（spec_info）- 字段编号枚举
xmail.enums.SpecInfoField = {
    ID: 3719,         //
    SPEC_ID: 30330,         //邮箱规格id
    NAME: 9776,         //规格名字
    MEMO: 67825,         //规格描述
    MAX_SPACE: 27429,         //最大空间 单位MB
    MAX_NUM: 26206,         //用户最大邮件封数
    UPDATE_TIME: 77635,         //更新时间
    CREATE_TIME: 82559,         //创建时间
    MAX_ATTACH_SIZE_SINGLE: 75488,         //单封附件总大小 单位MB
    MAX_TO_NUM_SINGLE: 40238,         //单封邮件最大收件人数量（人）
    MAX_SEND_NUM_DAILY: 533,         //邮件日最大发送量
    MAX_LARGE_ATTACH_SIZE: 63731,         //超大附件容量 单位G
    LARGE_ATTACH_EXPIRE_TIME: 74315,         //超大附件存放期 单位天
    SYS_DEF: 19271,         //是否是系统默认的
};

// 模式
xmail.enums.SsoType = {
    UNKNOWN: 0,         //UNKNOWN
    SIMPLE: 1,         //简易模式
    INTERFACE_BIND: 2,         //接口绑定模式
    USER_BIND: 3,         //用户绑定模式
};

// IP定位修正信息表表（sys_ip_location_correction）- 字段编号枚举
xmail.enums.SysIpLocationCorrectionField = {
    ID: 3719,         //
    START_IP: 17426,         //起始IP
    END_IP: 6075,         //截止IP
    LOCATION_ID: 77616,         //地理位置ID
    CREATE_TIME: 82559,         //创建时间
};

// 默认系统邮箱文件夹ID
xmail.enums.SysMailFolderId = {
    ROOT: 0,         //虚根文件夹ID (如果父文件夹ID为0 表示此文件夹是顶级; 实际没有文件夹ID为0的记录)
    INBOX: 1,         //INBOX
    SENT: 2,         //已发送
    TRASH: 3,         //已删除
    DRAFTS: 4,         //草稿箱
    JUNK: 5,         //垃圾箱
    ARCHIVE: 10,         //已归档
    BACKUP: 16,         //已备份
    MAX: 128,         //最大系统邮箱文件夹ID
};

// 系统管理员(虚拟的)表（sys_manager_info）- 字段编号枚举
xmail.enums.SysManagerInfoField = {
    ID: 3719,         //
    SYS_MANAGER_ID: 18950,         //超级管理员id
    MANAGER_ACCOUNT: 88720,         //邮箱地址
    PASSWD: 71955,         //
    PASSWD_TYPE: 82007,         //密码加密类型|passwd_type|SM4(1, 国4加密 ),BCRYPT(2,  bcrypt加密 ),NO_CRYPT(3, 不加密 ),SM3(4, 国3加密 ),MD5(5, MD5加密 ),MD5_SALT(6, MD5加盐 );
    SYS_PRIVI_GROUP_ID: 21147,         //超级权限组id
    SYS_PRIVI_GROUP_NAME: 80817,         //超级权限组名字
    STATUS: 91903,         //管理员状态|manager_info_status|ENABLE(1,  启用 ),DISABLE(2,  禁用 );
    MEMO: 67825,         //描述
    LAST_LOGIN_IP: 7759,         //最后登录ip
    LAST_LOGIN_TIME: 94451,         //最后登录时间
    CURRENT_LOGIN_IP: 21873,         //当前登录ip
    CURRENT_LOGIN_TIME: 65200,         //当前登录时间
    SYS_CONTACT_NAME: 24932,         //系统联系人姓名
    SYS_CONTACT_EMAIL: 54353,         //系统联系人邮箱
    SYS_CONTACT_TEL: 29517,         //系统联系人电话
    SYS_CONTACT_MOBILE: 81177,         //系统联系人手机
    SYS_CONTACT_FAX: 71740,         //系统联系人传真
    SYS_CONTACT_ADDR: 96502,         //系统联系人地址
    CREATE_TIME: 82559,         //创建时间
    UPDATE_TIME: 77635,         //更新时间
};

// 系统管理员权限功能组表（sys_privi_group）- 字段编号枚举
xmail.enums.SysPriviGroupField = {
    ID: 3719,         //
    SYS_PRIVI_GROUP_ID: 21147,         //系统权限组id
    NAME: 9776,         //权限组名字
    PRIVIAGE1: 47585,         //权限1(privi_info表前64个privi_id )
    PRIVIAGE2: 78311,         //权限1(大于64的privi_id，对64取模，余数就是表名 )
    SYS_DEF: 19271,         //是否是系统默认的
    MEMO: 67825,         //备注
};

// 系统管理员登录限制表（sys_rule_login）- 字段编号枚举
xmail.enums.SysRuleLoginField = {
    ID: 3719,         //
    STATUS: 91903,         //规则状态|sys_rule_status|ENABLE(1,  启用 ),DISABLE(2,  禁用 );
    SYS_RULE_LOGIN_ID: 969,         //规则id
    LOGIN_IP_LIMIT: 41853,         //登录IP限制|rule_login_ip_limit|ENABLE_PART(1,  只允许 ), DISABLE_PART(2,  不允许 ), UNLIMITED(3,  不限制 ), DEFAULT(-1, 系统默认 );
    LOGIN_IP_CONTENT: 38315,         //登录限制ip或ip段
    LOGIN_TIME_LIMIT_ENABLE: 17241,         //是否开启登录时间限制
    LOGIN_TIME_DAY_FLAG: 92719,         //登录时间限制周几:login_time_day_flag: 1,MO,周一 | 2,TU,周二| 3,WE,周三| 4,TH,周四| 5,FR,周五| 6,SA,周六| 7,SU,周日
    LOGIN_TIME_START: 37932,         //登录限制开始时间
    LOGIN_TIME_END: 56108,         //登录限制结束时间
    AUTH_TIMEOUT: 43685,         //超时重新认证时长
    LOGIN_ERROR_TIMES: 28735,         //登录连续错误次数
    CREATE_TIME: 82559,         //创建时间
    UPDATE_TIME: 77635,         //更新时间
};

// 规则状态
xmail.enums.SysRuleStatus = {
    UNKNOWN: 0,         //UNKNOWN
    ENABLE: 1,         //启用
    DISABLE: 2,         //禁用
};

// 系统弱密码表（sys_weak_passwd）- 字段编号枚举
xmail.enums.SysWeakPasswdField = {
    ID: 3719,         //
    WEAK_PASSWD: 21079,         //
    CREATE_TIME: 82559,         //创建时间
};

// 参数配置表表（system_config）- 字段编号枚举
xmail.enums.SystemConfigField = {
    ID: 3719,         //
    CONFIG_KEY: 18484,         //自定义key
    CONFIG_VAL: 15876,         //自定义value json格式
    MEMO: 67825,         //参数说明
};

//
xmail.enums.SystemPrivilege = {
    CORP_MANAGE: 38,         //企业管理
    MAIL_SPEC: 39,         //邮箱规格
    CONFIG_MANAGE: 40,         //配置管理
    LICENSE_MANAGE: 41,         //许可证管理
    SENSITIVE_WORD: 42,         //敏感词设置
    LOGIN_RESTRICTION: 43,         //登录限制
    SUPER_ADMIN: 44,         //超级管理员
    SYSTEM_LOG: 45,         //系统日志
    SYSTEM_CLASSIFICATION: 46,         //系统密级
    HOME_PAGE: 73,         //超管首页
};

// 任务状态
xmail.enums.TaskStatus = {
    UNKNOWN: 0,         //UNKNOWN
    SUCC: 1,         //完成
    FAIL: 2,         //失败
    FAIL_PART: 3,         //部分完成
    DOING: 5,         //进行中
    UN_EXEC: 4,         //未执行
};

// 任务类型
xmail.enums.TaskType = {
    UNKNOWN: 0,         //UNKNOWN
    USER_BATCH_ADD: 1,         //批量添加用户
    USER_BATCH_DEL: 2,         //批量删除用户
    DEPT_BATCH_ADD: 3,         //批量添加部门
    DEPT_BATCH_DEL: 4,         //批量删除部门
    MAIL_DEL: 5,         //域内邮件删除
    MAIL_ENS: 6,         //域内公告邮件
    USER_BATCH_EDIT: 7,         //批量编辑用户
    UMT: 8,         //手动触发搬家
    USER_BATCH_RECOVER: 9,         //批量恢复用户
    LIST_BATCH_ADD: 10,         //批量添加列表
    USER_BATCH_SER: 11,         //批量设置用户
    CONTACTINFO_BATCH_ADD: 12,         //批量添加外部联系人
};

// 模板类型
xmail.enums.TemplateType = {
    UNKNOWN: 0,         //UNKNOWN
    BATCH_ADD_USER: 1,         //batch_add_user.xlsx
    BATCH_EDIT_USER: 2,         //batch_edit_user.xlsx
    BATCH_DEL_USER: 3,         //batch_del_user.xlsx
    BATCH_ADD_DEPT: 4,         //batch_add_dept.xlsx
    EXTERNAL_CONTACTS: 5,         //external_contacts.xlsx
};

// 信任地址添加类型
xmail.enums.TrustLocationAddType = {
    UNKNOWN: 0,         //UNKNOWN
    AUTO: 1,         //自动
    INTELLECT: 2,         //智能
    MANUAL: 3,         //手动
};

// 搬家表表（umt_auth_info）- 字段编号枚举
xmail.enums.UmtAuthInfoField = {
    ID: 3719,         //
    MAIL_ACCOUNT_ID: 91885,         //邮箱id
    USER_EMAIL: 11187,         //邮箱地址
    CORP_ID: 16757,         //企业id
    DOMAIN_ID: 69476,         //域名id
    CREATE_TIME: 82559,         //创建时间
    UPDATE_TIME: 77635,         //更新时间
    SERVER_TYPE: 66185,         //服务器类型|umt_server_type|POP(1,  POP ),IMAP(2,  IMAP );
    HOST: 82989,         //服务器地址
    PORT: 35210,         //服务器端口
    SSL_ENABLE: 43144,         //是否是SSL
    UMT_EMAIL: 66852,         //搬家用户名
    UMT_PASSWD: 61992,         //搬家邮箱密码
    UMT_PASSWD_TYPE: 87113,         //密码加密类型|passwd_type|SM4(1, 国4加密 ),BCRYPT(2,  bcrypt加密 ),NO_CRYPT(3, 不加密 ),SM3(4, 国3加密 ),MD5(5, MD5加密 ),MD5_SALT(6, MD5加盐 );
    FOLDER_ID: 47295,         //文件夹id
    STATUS: 91903,         //搬家状态|umt_auth_status|MOVING(1,  搬家中 ),FINISH(2,  搬家完成 ),ERROR(3,  搬家失败 ),NOSTART(4, 搬家未开始 );
    TOTAL_COUNT: 81066,         //总数
    COMPLETED_NUM: 65499,         //搬家完成数量
    MEMO: 67825,         //备注
};

// 搬家状态
xmail.enums.UmtAuthStatus = {
    UNKNOWN: 0,         //UNKNOWN
    MOVING: 1,         //搬家中
    FINISH: 2,         //搬家完成
    ERROR: 3,         //搬家失败
    NOSTART: 4,         //搬家未开始
};

// 服务器类型
xmail.enums.UmtServerType = {
    UNKNOWN: 0,         //UNKNOWN
    POP: 1,         //POP
    IMAP: 2,         //IMAP
};

//
xmail.enums.UndoSendMailResultCode = {
    WM_SEND_UNDO_MAIL_SUCCESS: 1,         //成功撤回
    WM_SEND_UNDO_MAIL_DELIVER: 2,         //投递中、分类过滤删除或群发单显的加密邮件，无法撤回
    WM_SEND_UNDO_MAIL_DELETE: 3,         //撤回失败，邮件可能已被删除
    WM_SEND_UNDO_MAIL_FOREIGN: 4,         //对方非本邮件系统邮箱或邮箱地址不存在，无法撤回
};

// 修改密码类型
xmail.enums.UpdatePwdOperateType = {
    UNKNOWN: 0,         //UNKNOWN
    ADD: 1,         //添加用户
    UPDATE: 2,         //修改用户
};

// 个人地址簿通讯组表表（user_contact_group）- 字段编号枚举
xmail.enums.UserContactGroupField = {
    ID: 3719,         //主键
    GROUP_ID: 83103,         //通讯组ID
    CORP_ID: 16757,         //企业ID
    PARENT_ID: 60732,         //父通讯组ID
    USER_ID: 37163,         //用户ID
    NAME: 9776,         //通讯组名称
    CREATE_TIME: 82559,         //创建日期
    UPDATE_TIME: 77635,         //修改日期
    SORT_VAL: 1981,         //排序值
};

// 个人地址簿联系人表表（user_contact_info）- 字段编号枚举
xmail.enums.UserContactInfoField = {
    ID: 3719,         //主键
    USER_CONTACT_ID: 30474,         //联系人ID
    CORP_ID: 16757,         //企业ID
    USER_ID: 37163,         //用户ID
    CREATE_TIME: 82559,         //创建时间
    UPDATE_TIME: 77635,         //修改时间
    SURNAME: 33177,         //姓氏
    GIVEN_NAME: 69284,         //名字
    GENDER: 61230,         //性别
    BIRTHDAY: 55906,         //生日
    NICKNAME: 64650,         //昵称
    WECHAT: 90256,         //微信
    QQ: 95053,         //QQ
    EMAIL: 26761,         //电子邮件（多个使用符号“¶”分隔）
    TELEPHONE: 93290,         //电话号码（多个使用符号“¶”分隔）
    FAX: 72446,         //传真号码（多个使用符号“¶”分隔）
    MSN: 20227,         //msn
    COMPANY: 87021,         //公司名称
    DEPART_NAME: 62910,         //部门名称
    POSITION: 14793,         //职位
    WORK_WEBSITE: 22385,         //公司-网址
    WORK_COUNTRY: 80878,         //公司-国家
    WORK_PROVINCE: 18400,         //公司-省
    WORK_CITY: 14416,         //公司-市
    WORK_STREET: 54683,         //公司-街道
    WORK_POSTAL_CODE: 18430,         //公司-邮编
    HOME_COUNTRY: 66250,         //家庭-国家
    HOME_PROVINCE: 30822,         //家庭-省
    HOME_CITY: 87176,         //家庭-市
    HOME_STREET: 83407,         //家庭-街道
    HOME_POSTAL_CODE: 57550,         //家庭-邮编
    MEMO: 67825,         //备注
    CUSTOM: 91760,         //自定义
};

// 个人地址簿关系表表（user_contact_relation）- 字段编号枚举
xmail.enums.UserContactRelationField = {
    ID: 3719,         //主键
    CORP_ID: 16757,         //企业ID
    USER_ID: 37163,         //用户ID
    GROUP_ID: 83103,         //通讯组ID
    USER_CONTACT_ID: 30474,         //联系人ID
    SORT_VAL: 1981,         //排序值
};

//
xmail.enums.UserContactType = {
    PERSON: 1,         //联系人
    GROUP: 2,         //联系组
};

// 企业人和部门关系表表（user_depart）- 字段编号枚举
xmail.enums.UserDepartField = {
    ID: 3719,         //
    CORP_ID: 16757,         //企业id
    DEPART_ID: 33007,         //部门id
    USER_ID: 37163,         //邮箱id
    USER_EMAIL: 11187,         //邮箱地址
    CREATE_TIME: 82559,         //创建时间
    UPDATE_TIME: 77635,         //更新时间
    SORT_VAL: 1981,         //排序值
};

// 用户信息表（user_info）- 字段编号枚举
xmail.enums.UserInfoField = {
    ID: 3719,         //
    USER_ID: 37163,         //用户id
    CORP_ID: 16757,         //企业id
    NAME: 9776,         //名字
    CREATE_TIME: 82559,         //创建时间
    UPDATE_TIME: 77635,         //更新时间
    GENDER: 61230,         //性别|gender|MALE(1,  男性 ),FEMALE(2,  女性 );
    BIRTHDAY: 55906,         //生日
    POSITION: 14793,         //职位
    TEL: 43700,         //座机
    MOBILE: 86202,         //手机
    FAX: 72446,         //传真
    EMPLOYEE_ID: 24630,         //员工编号
    MEMO: 67825,         //备注
    HIREDATE: 56824,         //入职时间
    WEB_LANGUAGE: 19979,         //语言|language|CN(1,  中文简体 ),HK(2,  中文繁体 ),EN(3,  英文 ),JP(4,  日语 ),KR(5,  韩语 );
    REF_USER_ID: 65595,         //外部人员userid
};

//
xmail.enums.UserPrivilege = {
    MAIL: 1,         //邮箱
    CONTACT: 2,         //通讯录
    SCHEDULED_MAIL: 3,         //定时邮件
    SEND_ALONE: 4,         //群发单显
    EMAIL_ENCRYPTION: 5,         //邮件加密
    CLOUD_ATTACHMENT: 6,         //超大附件
    MAIL_UNDO: 7,         //邮件撤回
    SENSITIVE_WORD_REMINDER: 8,         //敏感词提醒
    SAVE_CLIENT_LETTER: 9,         //保存客户端发信
    MAIL_COLLECTION: 10,         //邮件代收
    ACCOUNT_SAFE: 11,         //账户安全
    CUSTOM_SENDER_NAME: 12,         //自定义发件人姓名
    ORG_CONTACT: 13,         //组织通讯录
    USER_CONTACT: 14,         //个人通讯录
    CORP_CONTACT: 15,         //外部联系人
    MAIL_LIST: 16,         //邮件列表
};

// 用户范围枚举
xmail.enums.UserScopeType = {
    ALL: 1,         //所有用户
    POINT: 2,         //指定用户
    NOT_POINT: 3,         //非指定用户
};

// 邮箱账号历史修改密码记录表（user_update_passwd）- 字段编号枚举
xmail.enums.UserUpdatePasswdField = {
    ID: 3719,         //
    USER_ID: 37163,         //邮箱id
    CORP_ID: 16757,         //企业id
    USER_EMAIL: 11187,         //邮箱地址
    OPERATE_NAME: 5828,         //
    DEPART_NAME: 62910,         //
    CREATE_TIME: 82559,         //创建时间
    UPDATE_TIME: 77635,         //更新时间
    LAST_UPDATE_PASS: 8344,         //最后修改密码时间
    IP: 83688,         //修改ip
    AREA_CODE: 97329,         //修改ip隶属国家码
    WEAK_PASS_FLAG: 53216,         //是否弱密码
    CLIENT_TYPE: 74401,         //客户端类型|client_type|MA(1,  ma ),WM_PC(2,  WEB_PC ),WM_MOBILE(12,  WEB_MOBILE ),SYS_MANAGER_PC(13, super_ma ),POP(3,  pop ),IMAP(4,  imap ),SMTP(5,  smtp ),EAS(6,  eas ),UMT(7,  umt ),API(8,  接口 ),UBD(10,  ubd ),UDUTIL(11,  ud工具 ),SCHEDULE(14, 定时任务 ),CALWEB(15, 日程 ),SSO_PC(16, SSO_PC ),SSO_MOBILE(17, SSO_MOBILE );
    OPERATE_TYPE: 91382,         //修改密码类型|update_pwd_operate_type|ADD(1, 添加用户 ),UPDATE(2, 修改用户 );
};

// 用户版本号表（user_version）- 字段编号枚举
xmail.enums.UserVersionField = {
    ID: 3719,         //
    USER_ID: 37163,         //用户id
    CORP_ID: 16757,         //企业ID
    UPDATE_TIME: 77635,         //更新时间
    VERSION_SYNC_SERIAL: 72602,         //版本同步序列值（用于数据同步递进；版本字段更新时都要更新此值；此值不是简单+1，而是保证全表越晚更新记录的值大于先前更新记录的值； 如何数据库支持“自增序列”则使用“自增序列”， 如不支持则暂时更新为数据库当前时间毫秒数（unix_timestamp(current_timestamp(3))*1000）
    VERSION_SCOPE: 50545,         //用户相关信息版本号分类|user_version_scope|info(1,  用户基本信息 ),contact(2,  个人通讯录 )
    VERSION: 89499,         //用户个人通讯录版本号
};

// 用户相关信息版本号分类
xmail.enums.UserVersionScope = {
    UNKNOWN: 0,         //UNKNOWN
    INFO: 1,         //用户基本信息
    CONTACT: 2,         //个人通讯录
};

// 皮肤
xmail.enums.WebmailSkin = {
    UNKNOWN: 0,         //UNKNOWN
    OFFICE: 1,         //商务办公
    REDSIMPLE: 2,         //红色简约
    BRAVEFORWARD: 3,         //勇者前行
    SCRIPTURES: 4,         //经典木纹
    GREEN: 5,         //绿意风情
    PINK: 6,         //粉色回忆
    GRASS: 7,         //青青幽境
    BLACK: 8,         //时尚酷黑
    GOLD: 9,         //金色时光
};

// 用户状态
xmail.enums.WelcomeEmlStatus = {
    UNKNOWN: 0,         //UNKNOWN
    ENABLE: 1,         //启用
    DISABLE: 2,         //禁用
};

// 黑白名单检测结果
xmail.enums.WhiteBlackCheckType = {
    UNKNOWN: 0,         //UNKNOWN
    NONE: 1,         //不存在
    BLACK: 2,         //属于黑名单
    WHITE: 3,         //属于白名单
};

//
xmail.enums.XmailFileSecretType = {
    UNKNOWN: 0,         //未知加密方式
    SM4_ECB_NOPADDING_16: 1,         //SM4等长加密
};

//
xmail.enums.XmailFileType = {
    ORIGINAL: 0,         //普通文件(非XMAIL格式文件)
    COMMON: 1,         //明文文件
    ENCRPTED: 2,         //加密文件
    COMPRESSED: 4,         //压缩文件
};

//
xmail.enums.XmailFileVersion = {
    UNKNOWN: 0,         //未知版本
    V1: 1,         //V1.0 文件数据结构版本
    V2: 2,         //
    V3: 3,         //
};

//
xmail.enums.YozoConvertType = {
    OFFICE: 61,         //文档格式到安全html的转换(office 安全预览)
    PDF: 20,         //pdf
    COMPRESS: 19,         //压缩文件
    PICTURE: 23,         //图片
};

// API接口权限类型;  注意 IDX_XXX 是从1开始
xmail.flags.ApiPriviFlag = {
    //第1位代表: 组织通讯录
    ORG_VAL: (1 << (1 - 1)),  //值
    ORG_IDX: 1,               //第几位； 注意是从1开始

    //第2位代表: 单点
    SSO_VAL: (1 << (2 - 1)),  //值
    SSO_IDX: 2,               //第几位； 注意是从1开始

    //第3位代表: 网盘
    DISK_VAL: (1 << (3 - 1)),  //值
    DISK_IDX: 3,               //第几位； 注意是从1开始

};

// 邮箱功能标记;  注意 IDX_XXX 是从1开始
xmail.flags.CorpAbilityFlag = {
    //第1位代表: 需要修改DB注释以便生成（位数从1开始）
    FLAGA_VAL: (1 << (1 - 1)),  //值
    FLAGA_IDX: 1,               //第几位； 注意是从1开始

    //第2位代表: 第二位表示样例
    FLAGB_VAL: (1 << (2 - 1)),  //值
    FLAGB_IDX: 2,               //第几位； 注意是从1开始

};

// 应用功能;  注意 IDX_XXX 是从1开始
xmail.flags.CorpWorkbenchFlag = {
    //第1位代表: 需要修改DB注释以便生成（位数从1开始）
    FLAGA_VAL: (1 << (1 - 1)),  //值
    FLAGA_IDX: 1,               //第几位； 注意是从1开始

    //第2位代表: 第二位表示样例
    FLAGB_VAL: (1 << (2 - 1)),  //值
    FLAGB_IDX: 2,               //第几位； 注意是从1开始

};

// 列表权限;  注意 IDX_XXX 是从1开始
xmail.flags.ListPriviFlag = {
    //第1位代表: 所有用户都可以给此列表发信
    ALLUSER_VAL: (1 << (1 - 1)),  //值
    ALLUSER_IDX: 1,               //第几位； 注意是从1开始

    //第2位代表: 只有指定范围内的用户才能给此列表发信
    CUSTOMUSER_VAL: (1 << (2 - 1)),  //值
    CUSTOMUSER_IDX: 2,               //第几位； 注意是从1开始

    //第3位代表: 只有列表内的用户才能给此列表发信
    USEROFLIST_VAL: (1 << (3 - 1)),  //值
    USEROFLIST_IDX: 3,               //第几位； 注意是从1开始

};

// 登录时间限制周几;  注意 IDX_XXX 是从1开始
xmail.flags.LoginTimeDayFlag = {
    //第1位代表: 周一
    MO_VAL: (1 << (1 - 1)),  //值
    MO_IDX: 1,               //第几位； 注意是从1开始

    //第2位代表: 周二
    TU_VAL: (1 << (2 - 1)),  //值
    TU_IDX: 2,               //第几位； 注意是从1开始

    //第3位代表: 周三
    WE_VAL: (1 << (3 - 1)),  //值
    WE_IDX: 3,               //第几位； 注意是从1开始

    //第4位代表: 周四
    TH_VAL: (1 << (4 - 1)),  //值
    TH_IDX: 4,               //第几位； 注意是从1开始

    //第5位代表: 周五
    FR_VAL: (1 << (5 - 1)),  //值
    FR_IDX: 5,               //第几位； 注意是从1开始

    //第6位代表: 周六
    SA_VAL: (1 << (6 - 1)),  //值
    SA_IDX: 6,               //第几位； 注意是从1开始

    //第7位代表: 周日
    SU_VAL: (1 << (7 - 1)),  //值
    SU_IDX: 7,               //第几位； 注意是从1开始

};

// 邮箱功能标记;  注意 IDX_XXX 是从1开始
xmail.flags.MailAccountAbilityFlag = {
    //第1位代表: 客户端保存已发信
    CLIENTSENT_VAL: (1 << (1 - 1)),  //值
    CLIENTSENT_IDX: 1,               //第几位； 注意是从1开始

    //第2位代表: 客户授权码
    CLIENTCODEENABLE_VAL: (1 << (2 - 1)),  //值
    CLIENTCODEENABLE_IDX: 2,               //第几位； 注意是从1开始

    //第3位代表: 异地登录提醒
    REMOTELOGINREMIND_VAL: (1 << (3 - 1)),  //值
    REMOTELOGINREMIND_IDX: 3,               //第几位； 注意是从1开始

    //第4位代表: 邮件异地登录提醒
    REMOTELOGINREMINDEMAIL_VAL: (1 << (4 - 1)),  //值
    REMOTELOGINREMINDEMAIL_IDX: 4,               //第几位； 注意是从1开始

    //第5位代表: 手机异地登录提醒
    REMOTELOGINREMINDSMS_VAL: (1 << (5 - 1)),  //值
    REMOTELOGINREMINDSMS_IDX: 5,               //第几位； 注意是从1开始

    //第6位代表: 安全登录验证
    SECURELOGINVERIFY_VAL: (1 << (6 - 1)),  //值
    SECURELOGINVERIFY_IDX: 6,               //第几位； 注意是从1开始

};

// 应用功能;  注意 IDX_XXX 是从1开始
xmail.flags.MailAccountWorkbenchFlag = {
    //第1位代表: 需要修改DB注释以便生成（位数从1开始）
    FLAGA_VAL: (1 << (1 - 1)),  //值
    FLAGA_IDX: 1,               //第几位； 注意是从1开始

    //第2位代表: 第二位表示样例
    FLAGB_VAL: (1 << (2 - 1)),  //值
    FLAGB_IDX: 2,               //第几位； 注意是从1开始

};

// 邮件索引属性标记;  注意 IDX_XXX 是从1开始
xmail.flags.MailIndexAttrFlag = {
    //第1位代表: 非常用联系人
    UNBELONGCONTACTS_VAL: (1 << (1 - 1)),  //值
    UNBELONGCONTACTS_IDX: 1,               //第几位； 注意是从1开始

    //第2位代表: 自动回复标志
    AUTOREPLY_VAL: (1 << (2 - 1)),  //值
    AUTOREPLY_IDX: 2,               //第几位； 注意是从1开始

    //第3位代表: 自动转发标志
    AUTOFORWARD_VAL: (1 << (3 - 1)),  //值
    AUTOFORWARD_IDX: 3,               //第几位； 注意是从1开始

    //第4位代表: 解密
    DECRYPT_VAL: (1 << (4 - 1)),  //值
    DECRYPT_IDX: 4,               //第几位； 注意是从1开始

    //第5位代表: 定时发信
    SENDLATER_VAL: (1 << (5 - 1)),  //值
    SENDLATER_IDX: 5,               //第几位； 注意是从1开始

};

//;  注意 IDX_XXX 是从1开始
xmail.flags.XmailFileFlag = {
    //第1位代表: 是否为冻结； 冻结后只读
    FREEZED_VAL: (1 << (1 - 1)),  //值
    FREEZED_IDX: 1,               //第几位； 注意是从1开始

    //第2位代表: 保留
    RES2_VAL: (1 << (2 - 1)),  //值
    RES2_IDX: 2,               //第几位； 注意是从1开始

    //第3位代表: 保留
    RES3_VAL: (1 << (3 - 1)),  //值
    RES3_IDX: 3,               //第几位； 注意是从1开始

    //第4位代表: 是否为加密格式
    ENCRYPTED_VAL: (1 << (4 - 1)),  //值
    ENCRYPTED_IDX: 4,               //第几位； 注意是从1开始

    //第5位代表: 是否为压缩模式
    COMPRESSED_VAL: (1 << (5 - 1)),  //值
    COMPRESSED_IDX: 5,               //第几位； 注意是从1开始

};

export default xmail;


// WEBPACK FOOTER //
// ./src/api/api.js